import { j as I } from "./jsx-runtime-C5mzlN2N.js";
import { useState as Pe, useEffect as ye, useRef as ze, createContext as Gr, use as Yr, useCallback as qn, useMemo as Zt, memo as Hn } from "react";
import { s as Ye, p as Zr, a as Jr, v as Pt, b as Kr, V as Xr, u as ei, t as ti, c as $n, d as ni, o as Fe, e as Jt, E as ri, S as ii, f as li } from "./SyntaxHighlight-UxOF1xNb.js";
import { CheckIcon as ai, CopyIcon as oi, ChevronRightIcon as ui, ExternalLinkIcon as si } from "lucide-react";
import { c as K } from "./cn-CwJPJKOE.js";
import { u as rt, d as ci, g as Ot, j as fi } from "./chunk-BAXFHI7N-C9WnHsLV.js";
import { c as Vn } from "./index-Z13x6tPX.js";
import { N as hi, f as Un, e as pi } from "./hook-BwOB_iZo.js";
import * as ut from "@radix-ui/react-collapsible";
import { B as mi } from "./Button-Bdk_Ij3U.js";
import { Slot as gi } from "@radix-ui/react-slot";
import { Button as di } from "./ui/Button.js";
import { Callout as ke } from "./ui/Callout.js";
import { Stepper as xi } from "./ui/Stepper.js";
import { g as ki } from "./invariant-DAFpPywt.js";
import { e as bi } from "./index-Bn6Lc9tq.js";
const st = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, yi = {};
function Ft(e, n) {
  const t = yi, r = typeof t.includeImageAlt == "boolean" ? t.includeImageAlt : !0, i = typeof t.includeHtml == "boolean" ? t.includeHtml : !0;
  return Wn(e, r, i);
}
function Wn(e, n, t) {
  if (wi(e)) {
    if ("value" in e)
      return e.type === "html" && !t ? "" : e.value;
    if (n && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return Kt(e.children, n, t);
  }
  return Array.isArray(e) ? Kt(e, n, t) : "";
}
function Kt(e, n, t) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; )
    r[i] = Wn(e[i], n, t);
  return r.join("");
}
function wi(e) {
  return !!(e && typeof e == "object");
}
const Xt = typeof document < "u" && document.createElement("i");
function Dt(e) {
  const n = "&" + e + ";";
  Xt.innerHTML = n;
  const t = Xt.textContent;
  return t.charCodeAt(t.length - 1) === 59 && e !== "semi" || t === n ? !1 : t;
}
function ie(e, n, t, r) {
  const i = e.length;
  let a = 0, l;
  if (n < 0 ? n = -n > i ? 0 : i + n : n = n > i ? i : n, t = t > 0 ? t : 0, r.length < 1e4)
    l = Array.from(r), l.unshift(n, t), e.splice(...l);
  else
    for (t && e.splice(n, t); a < r.length; )
      l = r.slice(a, a + 1e4), l.unshift(n, 0), e.splice(...l), a += 1e4, n += 1e4;
}
function J(e, n) {
  return e.length > 0 ? (ie(e, e.length, 0, n), e) : n;
}
const en = {}.hasOwnProperty;
function Ci(e) {
  const n = {};
  let t = -1;
  for (; ++t < e.length; )
    Si(n, e[t]);
  return n;
}
function Si(e, n) {
  let t;
  for (t in n) {
    const i = (en.call(e, t) ? e[t] : void 0) || (e[t] = {}), a = n[t];
    let l;
    if (a)
      for (l in a) {
        en.call(i, l) || (i[l] = []);
        const o = a[l];
        Ei(
          // @ts-expect-error Looks like a list.
          i[l],
          Array.isArray(o) ? o : o ? [o] : []
        );
      }
  }
}
function Ei(e, n) {
  let t = -1;
  const r = [];
  for (; ++t < n.length; )
    (n[t].add === "after" ? e : r).push(n[t]);
  ie(e, 0, 0, r);
}
function Qn(e, n) {
  const t = Number.parseInt(e, n);
  return (
    // C0 except for HT, LF, FF, CR, space.
    t < 9 || t === 11 || t > 13 && t < 32 || // Control character (DEL) of C0, and C1 controls.
    t > 126 && t < 160 || // Lone high surrogates and low surrogates.
    t > 55295 && t < 57344 || // Noncharacters.
    t > 64975 && t < 65008 || /* eslint-disable no-bitwise */
    (t & 65535) === 65535 || (t & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    t > 1114111 ? "�" : String.fromCodePoint(t)
  );
}
function ve(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const G = pe(/[A-Za-z]/), Q = pe(/[\dA-Za-z]/), Ai = pe(/[#-'*+\--9=?A-Z^-~]/);
function Xe(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const Et = pe(/\d/), Ii = pe(/[\dA-Fa-f]/), Ti = pe(/[!-/:-@[-`{-~]/);
function v(e) {
  return e !== null && e < -2;
}
function q(e) {
  return e !== null && (e < 0 || e === 32);
}
function D(e) {
  return e === -2 || e === -1 || e === 32;
}
const it = pe(/\p{P}|\p{S}/u), we = pe(/\s/);
function pe(e) {
  return n;
  function n(t) {
    return t !== null && t > -1 && e.test(String.fromCharCode(t));
  }
}
function j(e, n, t, r) {
  const i = r ? r - 1 : Number.POSITIVE_INFINITY;
  let a = 0;
  return l;
  function l(u) {
    return D(u) ? (e.enter(t), o(u)) : n(u);
  }
  function o(u) {
    return D(u) && a++ < i ? (e.consume(u), o) : (e.exit(t), n(u));
  }
}
const zi = {
  tokenize: vi
};
function vi(e) {
  const n = e.attempt(
    this.parser.constructs.contentInitial,
    r,
    i
  );
  let t;
  return n;
  function r(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), j(e, n, "linePrefix");
  }
  function i(o) {
    return e.enter("paragraph"), a(o);
  }
  function a(o) {
    const u = e.enter("chunkText", {
      contentType: "text",
      previous: t
    });
    return t && (t.next = u), t = u, l(o);
  }
  function l(o) {
    if (o === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(o);
      return;
    }
    return v(o) ? (e.consume(o), e.exit("chunkText"), a) : (e.consume(o), l);
  }
}
const Pi = {
  tokenize: Oi
}, tn = {
  tokenize: Fi
};
function Oi(e) {
  const n = this, t = [];
  let r = 0, i, a, l;
  return o;
  function o(S) {
    if (r < t.length) {
      const O = t[r];
      return n.containerState = O[1], e.attempt(
        O[0].continuation,
        u,
        s
      )(S);
    }
    return s(S);
  }
  function u(S) {
    if (r++, n.containerState._closeFlow) {
      n.containerState._closeFlow = void 0, i && E();
      const O = n.events.length;
      let F = O, w;
      for (; F--; )
        if (n.events[F][0] === "exit" && n.events[F][1].type === "chunkFlow") {
          w = n.events[F][1].end;
          break;
        }
      k(r);
      let R = O;
      for (; R < n.events.length; )
        n.events[R][1].end = Object.assign({}, w), R++;
      return ie(
        n.events,
        F + 1,
        0,
        n.events.slice(O)
      ), n.events.length = R, s(S);
    }
    return o(S);
  }
  function s(S) {
    if (r === t.length) {
      if (!i)
        return p(S);
      if (i.currentConstruct && i.currentConstruct.concrete)
        return d(S);
      n.interrupt = !!(i.currentConstruct && !i._gfmTableDynamicInterruptHack);
    }
    return n.containerState = {}, e.check(
      tn,
      f,
      c
    )(S);
  }
  function f(S) {
    return i && E(), k(r), p(S);
  }
  function c(S) {
    return n.parser.lazy[n.now().line] = r !== t.length, l = n.now().offset, d(S);
  }
  function p(S) {
    return n.containerState = {}, e.attempt(
      tn,
      h,
      d
    )(S);
  }
  function h(S) {
    return r++, t.push([n.currentConstruct, n.containerState]), p(S);
  }
  function d(S) {
    if (S === null) {
      i && E(), k(0), e.consume(S);
      return;
    }
    return i = i || n.parser.flow(n.now()), e.enter("chunkFlow", {
      contentType: "flow",
      previous: a,
      _tokenizer: i
    }), b(S);
  }
  function b(S) {
    if (S === null) {
      C(e.exit("chunkFlow"), !0), k(0), e.consume(S);
      return;
    }
    return v(S) ? (e.consume(S), C(e.exit("chunkFlow")), r = 0, n.interrupt = void 0, o) : (e.consume(S), b);
  }
  function C(S, O) {
    const F = n.sliceStream(S);
    if (O && F.push(null), S.previous = a, a && (a.next = S), a = S, i.defineSkip(S.start), i.write(F), n.parser.lazy[S.start.line]) {
      let w = i.events.length;
      for (; w--; )
        if (
          // The token starts before the line ending…
          i.events[w][1].start.offset < l && // …and either is not ended yet…
          (!i.events[w][1].end || // …or ends after it.
          i.events[w][1].end.offset > l)
        )
          return;
      const R = n.events.length;
      let H = R, B, x;
      for (; H--; )
        if (n.events[H][0] === "exit" && n.events[H][1].type === "chunkFlow") {
          if (B) {
            x = n.events[H][1].end;
            break;
          }
          B = !0;
        }
      for (k(r), w = R; w < n.events.length; )
        n.events[w][1].end = Object.assign({}, x), w++;
      ie(
        n.events,
        H + 1,
        0,
        n.events.slice(R)
      ), n.events.length = w;
    }
  }
  function k(S) {
    let O = t.length;
    for (; O-- > S; ) {
      const F = t[O];
      n.containerState = F[1], F[0].exit.call(n, e);
    }
    t.length = S;
  }
  function E() {
    i.write([null]), a = void 0, i = void 0, n.containerState._closeFlow = void 0;
  }
}
function Fi(e, n, t) {
  return j(
    e,
    e.attempt(this.parser.constructs.document, n, t),
    "linePrefix",
    this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
  );
}
function Oe(e) {
  if (e === null || q(e) || we(e))
    return 1;
  if (it(e))
    return 2;
}
function Lt(e, n, t) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; ) {
    const a = e[i].resolveAll;
    a && !r.includes(a) && (n = a(n, t), r.push(a));
  }
  return n;
}
const At = {
  name: "attention",
  tokenize: Li,
  resolveAll: Di
};
function Di(e, n) {
  let t = -1, r, i, a, l, o, u, s, f;
  for (; ++t < e.length; )
    if (e[t][0] === "enter" && e[t][1].type === "attentionSequence" && e[t][1]._close) {
      for (r = t; r--; )
        if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && // If the markers are the same:
        n.sliceSerialize(e[r][1]).charCodeAt(0) === n.sliceSerialize(e[t][1]).charCodeAt(0)) {
          if ((e[r][1]._close || e[t][1]._open) && (e[t][1].end.offset - e[t][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[t][1].end.offset - e[t][1].start.offset) % 3))
            continue;
          u = e[r][1].end.offset - e[r][1].start.offset > 1 && e[t][1].end.offset - e[t][1].start.offset > 1 ? 2 : 1;
          const c = Object.assign({}, e[r][1].end), p = Object.assign({}, e[t][1].start);
          nn(c, -u), nn(p, u), l = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: c,
            end: Object.assign({}, e[r][1].end)
          }, o = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: Object.assign({}, e[t][1].start),
            end: p
          }, a = {
            type: u > 1 ? "strongText" : "emphasisText",
            start: Object.assign({}, e[r][1].end),
            end: Object.assign({}, e[t][1].start)
          }, i = {
            type: u > 1 ? "strong" : "emphasis",
            start: Object.assign({}, l.start),
            end: Object.assign({}, o.end)
          }, e[r][1].end = Object.assign({}, l.start), e[t][1].start = Object.assign({}, o.end), s = [], e[r][1].end.offset - e[r][1].start.offset && (s = J(s, [
            ["enter", e[r][1], n],
            ["exit", e[r][1], n]
          ])), s = J(s, [
            ["enter", i, n],
            ["enter", l, n],
            ["exit", l, n],
            ["enter", a, n]
          ]), s = J(
            s,
            Lt(
              n.parser.constructs.insideSpan.null,
              e.slice(r + 1, t),
              n
            )
          ), s = J(s, [
            ["exit", a, n],
            ["enter", o, n],
            ["exit", o, n],
            ["exit", i, n]
          ]), e[t][1].end.offset - e[t][1].start.offset ? (f = 2, s = J(s, [
            ["enter", e[t][1], n],
            ["exit", e[t][1], n]
          ])) : f = 0, ie(e, r - 1, t - r + 3, s), t = r + s.length - f - 2;
          break;
        }
    }
  for (t = -1; ++t < e.length; )
    e[t][1].type === "attentionSequence" && (e[t][1].type = "data");
  return e;
}
function Li(e, n) {
  const t = this.parser.constructs.attentionMarkers.null, r = this.previous, i = Oe(r);
  let a;
  return l;
  function l(u) {
    return a = u, e.enter("attentionSequence"), o(u);
  }
  function o(u) {
    if (u === a)
      return e.consume(u), o;
    const s = e.exit("attentionSequence"), f = Oe(u), c = !f || f === 2 && i || t.includes(u), p = !i || i === 2 && f || t.includes(r);
    return s._open = !!(a === 42 ? c : c && (i || !p)), s._close = !!(a === 42 ? p : p && (f || !c)), n(u);
  }
}
function nn(e, n) {
  e.column += n, e.offset += n, e._bufferIndex += n;
}
const ji = {
  name: "autolink",
  tokenize: Ri
};
function Ri(e, n, t) {
  let r = 0;
  return i;
  function i(h) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), a;
  }
  function a(h) {
    return G(h) ? (e.consume(h), l) : s(h);
  }
  function l(h) {
    return h === 43 || h === 45 || h === 46 || Q(h) ? (r = 1, o(h)) : s(h);
  }
  function o(h) {
    return h === 58 ? (e.consume(h), r = 0, u) : (h === 43 || h === 45 || h === 46 || Q(h)) && r++ < 32 ? (e.consume(h), o) : (r = 0, s(h));
  }
  function u(h) {
    return h === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.exit("autolink"), n) : h === null || h === 32 || h === 60 || Xe(h) ? t(h) : (e.consume(h), u);
  }
  function s(h) {
    return h === 64 ? (e.consume(h), f) : Ai(h) ? (e.consume(h), s) : t(h);
  }
  function f(h) {
    return Q(h) ? c(h) : t(h);
  }
  function c(h) {
    return h === 46 ? (e.consume(h), r = 0, f) : h === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.exit("autolink"), n) : p(h);
  }
  function p(h) {
    if ((h === 45 || Q(h)) && r++ < 63) {
      const d = h === 45 ? p : c;
      return e.consume(h), d;
    }
    return t(h);
  }
}
const lt = {
  tokenize: _i,
  partial: !0
};
function _i(e, n, t) {
  return r;
  function r(a) {
    return D(a) ? j(e, i, "linePrefix")(a) : i(a);
  }
  function i(a) {
    return a === null || v(a) ? n(a) : t(a);
  }
}
const Gn = {
  name: "blockQuote",
  tokenize: Bi,
  continuation: {
    tokenize: Ni
  },
  exit: Mi
};
function Bi(e, n, t) {
  const r = this;
  return i;
  function i(l) {
    if (l === 62) {
      const o = r.containerState;
      return o.open || (e.enter("blockQuote", {
        _container: !0
      }), o.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(l), e.exit("blockQuoteMarker"), a;
    }
    return t(l);
  }
  function a(l) {
    return D(l) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(l), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), n) : (e.exit("blockQuotePrefix"), n(l));
  }
}
function Ni(e, n, t) {
  const r = this;
  return i;
  function i(l) {
    return D(l) ? j(
      e,
      a,
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(l) : a(l);
  }
  function a(l) {
    return e.attempt(Gn, n, t)(l);
  }
}
function Mi(e) {
  e.exit("blockQuote");
}
const Yn = {
  name: "characterEscape",
  tokenize: qi
};
function qi(e, n, t) {
  return r;
  function r(a) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(a), e.exit("escapeMarker"), i;
  }
  function i(a) {
    return Ti(a) ? (e.enter("characterEscapeValue"), e.consume(a), e.exit("characterEscapeValue"), e.exit("characterEscape"), n) : t(a);
  }
}
const Zn = {
  name: "characterReference",
  tokenize: Hi
};
function Hi(e, n, t) {
  const r = this;
  let i = 0, a, l;
  return o;
  function o(c) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(c), e.exit("characterReferenceMarker"), u;
  }
  function u(c) {
    return c === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(c), e.exit("characterReferenceMarkerNumeric"), s) : (e.enter("characterReferenceValue"), a = 31, l = Q, f(c));
  }
  function s(c) {
    return c === 88 || c === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(c), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), a = 6, l = Ii, f) : (e.enter("characterReferenceValue"), a = 7, l = Et, f(c));
  }
  function f(c) {
    if (c === 59 && i) {
      const p = e.exit("characterReferenceValue");
      return l === Q && !Dt(r.sliceSerialize(p)) ? t(c) : (e.enter("characterReferenceMarker"), e.consume(c), e.exit("characterReferenceMarker"), e.exit("characterReference"), n);
    }
    return l(c) && i++ < a ? (e.consume(c), f) : t(c);
  }
}
const rn = {
  tokenize: Vi,
  partial: !0
}, ln = {
  name: "codeFenced",
  tokenize: $i,
  concrete: !0
};
function $i(e, n, t) {
  const r = this, i = {
    tokenize: F,
    partial: !0
  };
  let a = 0, l = 0, o;
  return u;
  function u(w) {
    return s(w);
  }
  function s(w) {
    const R = r.events[r.events.length - 1];
    return a = R && R[1].type === "linePrefix" ? R[2].sliceSerialize(R[1], !0).length : 0, o = w, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), f(w);
  }
  function f(w) {
    return w === o ? (l++, e.consume(w), f) : l < 3 ? t(w) : (e.exit("codeFencedFenceSequence"), D(w) ? j(e, c, "whitespace")(w) : c(w));
  }
  function c(w) {
    return w === null || v(w) ? (e.exit("codeFencedFence"), r.interrupt ? n(w) : e.check(rn, b, O)(w)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), p(w));
  }
  function p(w) {
    return w === null || v(w) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), c(w)) : D(w) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), j(e, h, "whitespace")(w)) : w === 96 && w === o ? t(w) : (e.consume(w), p);
  }
  function h(w) {
    return w === null || v(w) ? c(w) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), d(w));
  }
  function d(w) {
    return w === null || v(w) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), c(w)) : w === 96 && w === o ? t(w) : (e.consume(w), d);
  }
  function b(w) {
    return e.attempt(i, O, C)(w);
  }
  function C(w) {
    return e.enter("lineEnding"), e.consume(w), e.exit("lineEnding"), k;
  }
  function k(w) {
    return a > 0 && D(w) ? j(
      e,
      E,
      "linePrefix",
      a + 1
    )(w) : E(w);
  }
  function E(w) {
    return w === null || v(w) ? e.check(rn, b, O)(w) : (e.enter("codeFlowValue"), S(w));
  }
  function S(w) {
    return w === null || v(w) ? (e.exit("codeFlowValue"), E(w)) : (e.consume(w), S);
  }
  function O(w) {
    return e.exit("codeFenced"), n(w);
  }
  function F(w, R, H) {
    let B = 0;
    return x;
    function x(_) {
      return w.enter("lineEnding"), w.consume(_), w.exit("lineEnding"), T;
    }
    function T(_) {
      return w.enter("codeFencedFence"), D(_) ? j(
        w,
        z,
        "linePrefix",
        r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
      )(_) : z(_);
    }
    function z(_) {
      return _ === o ? (w.enter("codeFencedFenceSequence"), M(_)) : H(_);
    }
    function M(_) {
      return _ === o ? (B++, w.consume(_), M) : B >= l ? (w.exit("codeFencedFenceSequence"), D(_) ? j(w, $, "whitespace")(_) : $(_)) : H(_);
    }
    function $(_) {
      return _ === null || v(_) ? (w.exit("codeFencedFence"), R(_)) : H(_);
    }
  }
}
function Vi(e, n, t) {
  const r = this;
  return i;
  function i(l) {
    return l === null ? t(l) : (e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), a);
  }
  function a(l) {
    return r.parser.lazy[r.now().line] ? t(l) : n(l);
  }
}
const ct = {
  name: "codeIndented",
  tokenize: Wi
}, Ui = {
  tokenize: Qi,
  partial: !0
};
function Wi(e, n, t) {
  const r = this;
  return i;
  function i(s) {
    return e.enter("codeIndented"), j(e, a, "linePrefix", 5)(s);
  }
  function a(s) {
    const f = r.events[r.events.length - 1];
    return f && f[1].type === "linePrefix" && f[2].sliceSerialize(f[1], !0).length >= 4 ? l(s) : t(s);
  }
  function l(s) {
    return s === null ? u(s) : v(s) ? e.attempt(Ui, l, u)(s) : (e.enter("codeFlowValue"), o(s));
  }
  function o(s) {
    return s === null || v(s) ? (e.exit("codeFlowValue"), l(s)) : (e.consume(s), o);
  }
  function u(s) {
    return e.exit("codeIndented"), n(s);
  }
}
function Qi(e, n, t) {
  const r = this;
  return i;
  function i(l) {
    return r.parser.lazy[r.now().line] ? t(l) : v(l) ? (e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), i) : j(e, a, "linePrefix", 5)(l);
  }
  function a(l) {
    const o = r.events[r.events.length - 1];
    return o && o[1].type === "linePrefix" && o[2].sliceSerialize(o[1], !0).length >= 4 ? n(l) : v(l) ? i(l) : t(l);
  }
}
const Gi = {
  name: "codeText",
  tokenize: Ji,
  resolve: Yi,
  previous: Zi
};
function Yi(e) {
  let n = e.length - 4, t = 3, r, i;
  if ((e[t][1].type === "lineEnding" || e[t][1].type === "space") && (e[n][1].type === "lineEnding" || e[n][1].type === "space")) {
    for (r = t; ++r < n; )
      if (e[r][1].type === "codeTextData") {
        e[t][1].type = "codeTextPadding", e[n][1].type = "codeTextPadding", t += 2, n -= 2;
        break;
      }
  }
  for (r = t - 1, n++; ++r <= n; )
    i === void 0 ? r !== n && e[r][1].type !== "lineEnding" && (i = r) : (r === n || e[r][1].type === "lineEnding") && (e[i][1].type = "codeTextData", r !== i + 2 && (e[i][1].end = e[r - 1][1].end, e.splice(i + 2, r - i - 2), n -= r - i - 2, r = i + 2), i = void 0);
  return e;
}
function Zi(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function Ji(e, n, t) {
  let r = 0, i, a;
  return l;
  function l(c) {
    return e.enter("codeText"), e.enter("codeTextSequence"), o(c);
  }
  function o(c) {
    return c === 96 ? (e.consume(c), r++, o) : (e.exit("codeTextSequence"), u(c));
  }
  function u(c) {
    return c === null ? t(c) : c === 32 ? (e.enter("space"), e.consume(c), e.exit("space"), u) : c === 96 ? (a = e.enter("codeTextSequence"), i = 0, f(c)) : v(c) ? (e.enter("lineEnding"), e.consume(c), e.exit("lineEnding"), u) : (e.enter("codeTextData"), s(c));
  }
  function s(c) {
    return c === null || c === 32 || c === 96 || v(c) ? (e.exit("codeTextData"), u(c)) : (e.consume(c), s);
  }
  function f(c) {
    return c === 96 ? (e.consume(c), i++, f) : i === r ? (e.exit("codeTextSequence"), e.exit("codeText"), n(c)) : (a.type = "codeTextData", s(c));
  }
}
function Jn(e) {
  const n = {};
  let t = -1, r, i, a, l, o, u, s;
  for (; ++t < e.length; ) {
    for (; t in n; )
      t = n[t];
    if (r = e[t], t && r[1].type === "chunkFlow" && e[t - 1][1].type === "listItemPrefix" && (u = r[1]._tokenizer.events, a = 0, a < u.length && u[a][1].type === "lineEndingBlank" && (a += 2), a < u.length && u[a][1].type === "content"))
      for (; ++a < u.length && u[a][1].type !== "content"; )
        u[a][1].type === "chunkText" && (u[a][1]._isInFirstContentOfListItem = !0, a++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(n, Ki(e, t)), t = n[t], s = !0);
    else if (r[1]._container) {
      for (a = t, i = void 0; a-- && (l = e[a], l[1].type === "lineEnding" || l[1].type === "lineEndingBlank"); )
        l[0] === "enter" && (i && (e[i][1].type = "lineEndingBlank"), l[1].type = "lineEnding", i = a);
      i && (r[1].end = Object.assign({}, e[i][1].start), o = e.slice(i, t), o.unshift(r), ie(e, i, t - i + 1, o));
    }
  }
  return !s;
}
function Ki(e, n) {
  const t = e[n][1], r = e[n][2];
  let i = n - 1;
  const a = [], l = t._tokenizer || r.parser[t.contentType](t.start), o = l.events, u = [], s = {};
  let f, c, p = -1, h = t, d = 0, b = 0;
  const C = [b];
  for (; h; ) {
    for (; e[++i][1] !== h; )
      ;
    a.push(i), h._tokenizer || (f = r.sliceStream(h), h.next || f.push(null), c && l.defineSkip(h.start), h._isInFirstContentOfListItem && (l._gfmTasklistFirstContentOfListItem = !0), l.write(f), h._isInFirstContentOfListItem && (l._gfmTasklistFirstContentOfListItem = void 0)), c = h, h = h.next;
  }
  for (h = t; ++p < o.length; )
    // Find a void token that includes a break.
    o[p][0] === "exit" && o[p - 1][0] === "enter" && o[p][1].type === o[p - 1][1].type && o[p][1].start.line !== o[p][1].end.line && (b = p + 1, C.push(b), h._tokenizer = void 0, h.previous = void 0, h = h.next);
  for (l.events = [], h ? (h._tokenizer = void 0, h.previous = void 0) : C.pop(), p = C.length; p--; ) {
    const k = o.slice(C[p], C[p + 1]), E = a.pop();
    u.unshift([E, E + k.length - 1]), ie(e, E, 2, k);
  }
  for (p = -1; ++p < u.length; )
    s[d + u[p][0]] = d + u[p][1], d += u[p][1] - u[p][0] - 1;
  return s;
}
const Xi = {
  tokenize: nl,
  resolve: tl
}, el = {
  tokenize: rl,
  partial: !0
};
function tl(e) {
  return Jn(e), e;
}
function nl(e, n) {
  let t;
  return r;
  function r(o) {
    return e.enter("content"), t = e.enter("chunkContent", {
      contentType: "content"
    }), i(o);
  }
  function i(o) {
    return o === null ? a(o) : v(o) ? e.check(
      el,
      l,
      a
    )(o) : (e.consume(o), i);
  }
  function a(o) {
    return e.exit("chunkContent"), e.exit("content"), n(o);
  }
  function l(o) {
    return e.consume(o), e.exit("chunkContent"), t.next = e.enter("chunkContent", {
      contentType: "content",
      previous: t
    }), t = t.next, i;
  }
}
function rl(e, n, t) {
  const r = this;
  return i;
  function i(l) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), j(e, a, "linePrefix");
  }
  function a(l) {
    if (l === null || v(l))
      return t(l);
    const o = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && o && o[1].type === "linePrefix" && o[2].sliceSerialize(o[1], !0).length >= 4 ? n(l) : e.interrupt(r.parser.constructs.flow, t, n)(l);
  }
}
function Kn(e, n, t, r, i, a, l, o, u) {
  const s = u || Number.POSITIVE_INFINITY;
  let f = 0;
  return c;
  function c(k) {
    return k === 60 ? (e.enter(r), e.enter(i), e.enter(a), e.consume(k), e.exit(a), p) : k === null || k === 32 || k === 41 || Xe(k) ? t(k) : (e.enter(r), e.enter(l), e.enter(o), e.enter("chunkString", {
      contentType: "string"
    }), b(k));
  }
  function p(k) {
    return k === 62 ? (e.enter(a), e.consume(k), e.exit(a), e.exit(i), e.exit(r), n) : (e.enter(o), e.enter("chunkString", {
      contentType: "string"
    }), h(k));
  }
  function h(k) {
    return k === 62 ? (e.exit("chunkString"), e.exit(o), p(k)) : k === null || k === 60 || v(k) ? t(k) : (e.consume(k), k === 92 ? d : h);
  }
  function d(k) {
    return k === 60 || k === 62 || k === 92 ? (e.consume(k), h) : h(k);
  }
  function b(k) {
    return !f && (k === null || k === 41 || q(k)) ? (e.exit("chunkString"), e.exit(o), e.exit(l), e.exit(r), n(k)) : f < s && k === 40 ? (e.consume(k), f++, b) : k === 41 ? (e.consume(k), f--, b) : k === null || k === 32 || k === 40 || Xe(k) ? t(k) : (e.consume(k), k === 92 ? C : b);
  }
  function C(k) {
    return k === 40 || k === 41 || k === 92 ? (e.consume(k), b) : b(k);
  }
}
function Xn(e, n, t, r, i, a) {
  const l = this;
  let o = 0, u;
  return s;
  function s(h) {
    return e.enter(r), e.enter(i), e.consume(h), e.exit(i), e.enter(a), f;
  }
  function f(h) {
    return o > 999 || h === null || h === 91 || h === 93 && !u || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    h === 94 && !o && "_hiddenFootnoteSupport" in l.parser.constructs ? t(h) : h === 93 ? (e.exit(a), e.enter(i), e.consume(h), e.exit(i), e.exit(r), n) : v(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), f) : (e.enter("chunkString", {
      contentType: "string"
    }), c(h));
  }
  function c(h) {
    return h === null || h === 91 || h === 93 || v(h) || o++ > 999 ? (e.exit("chunkString"), f(h)) : (e.consume(h), u || (u = !D(h)), h === 92 ? p : c);
  }
  function p(h) {
    return h === 91 || h === 92 || h === 93 ? (e.consume(h), o++, c) : c(h);
  }
}
function er(e, n, t, r, i, a) {
  let l;
  return o;
  function o(p) {
    return p === 34 || p === 39 || p === 40 ? (e.enter(r), e.enter(i), e.consume(p), e.exit(i), l = p === 40 ? 41 : p, u) : t(p);
  }
  function u(p) {
    return p === l ? (e.enter(i), e.consume(p), e.exit(i), e.exit(r), n) : (e.enter(a), s(p));
  }
  function s(p) {
    return p === l ? (e.exit(a), u(l)) : p === null ? t(p) : v(p) ? (e.enter("lineEnding"), e.consume(p), e.exit("lineEnding"), j(e, s, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), f(p));
  }
  function f(p) {
    return p === l || p === null || v(p) ? (e.exit("chunkString"), s(p)) : (e.consume(p), p === 92 ? c : f);
  }
  function c(p) {
    return p === l || p === 92 ? (e.consume(p), f) : f(p);
  }
}
function Ne(e, n) {
  let t;
  return r;
  function r(i) {
    return v(i) ? (e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), t = !0, r) : D(i) ? j(e, r, t ? "linePrefix" : "lineSuffix")(i) : n(i);
  }
}
const il = {
  name: "definition",
  tokenize: al
}, ll = {
  tokenize: ol,
  partial: !0
};
function al(e, n, t) {
  const r = this;
  let i;
  return a;
  function a(h) {
    return e.enter("definition"), l(h);
  }
  function l(h) {
    return Xn.call(
      r,
      e,
      o,
      // Note: we don’t need to reset the way `markdown-rs` does.
      t,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(h);
  }
  function o(h) {
    return i = ve(
      r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)
    ), h === 58 ? (e.enter("definitionMarker"), e.consume(h), e.exit("definitionMarker"), u) : t(h);
  }
  function u(h) {
    return q(h) ? Ne(e, s)(h) : s(h);
  }
  function s(h) {
    return Kn(
      e,
      f,
      // Note: we don’t need to reset the way `markdown-rs` does.
      t,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(h);
  }
  function f(h) {
    return e.attempt(ll, c, c)(h);
  }
  function c(h) {
    return D(h) ? j(e, p, "whitespace")(h) : p(h);
  }
  function p(h) {
    return h === null || v(h) ? (e.exit("definition"), r.parser.defined.push(i), n(h)) : t(h);
  }
}
function ol(e, n, t) {
  return r;
  function r(o) {
    return q(o) ? Ne(e, i)(o) : t(o);
  }
  function i(o) {
    return er(
      e,
      a,
      t,
      "definitionTitle",
      "definitionTitleMarker",
      "definitionTitleString"
    )(o);
  }
  function a(o) {
    return D(o) ? j(e, l, "whitespace")(o) : l(o);
  }
  function l(o) {
    return o === null || v(o) ? n(o) : t(o);
  }
}
const ul = {
  name: "hardBreakEscape",
  tokenize: sl
};
function sl(e, n, t) {
  return r;
  function r(a) {
    return e.enter("hardBreakEscape"), e.consume(a), i;
  }
  function i(a) {
    return v(a) ? (e.exit("hardBreakEscape"), n(a)) : t(a);
  }
}
const cl = {
  name: "headingAtx",
  tokenize: hl,
  resolve: fl
};
function fl(e, n) {
  let t = e.length - 2, r = 3, i, a;
  return e[r][1].type === "whitespace" && (r += 2), t - 2 > r && e[t][1].type === "whitespace" && (t -= 2), e[t][1].type === "atxHeadingSequence" && (r === t - 1 || t - 4 > r && e[t - 2][1].type === "whitespace") && (t -= r + 1 === t ? 2 : 4), t > r && (i = {
    type: "atxHeadingText",
    start: e[r][1].start,
    end: e[t][1].end
  }, a = {
    type: "chunkText",
    start: e[r][1].start,
    end: e[t][1].end,
    contentType: "text"
  }, ie(e, r, t - r + 1, [
    ["enter", i, n],
    ["enter", a, n],
    ["exit", a, n],
    ["exit", i, n]
  ])), e;
}
function hl(e, n, t) {
  let r = 0;
  return i;
  function i(f) {
    return e.enter("atxHeading"), a(f);
  }
  function a(f) {
    return e.enter("atxHeadingSequence"), l(f);
  }
  function l(f) {
    return f === 35 && r++ < 6 ? (e.consume(f), l) : f === null || q(f) ? (e.exit("atxHeadingSequence"), o(f)) : t(f);
  }
  function o(f) {
    return f === 35 ? (e.enter("atxHeadingSequence"), u(f)) : f === null || v(f) ? (e.exit("atxHeading"), n(f)) : D(f) ? j(e, o, "whitespace")(f) : (e.enter("atxHeadingText"), s(f));
  }
  function u(f) {
    return f === 35 ? (e.consume(f), u) : (e.exit("atxHeadingSequence"), o(f));
  }
  function s(f) {
    return f === null || f === 35 || q(f) ? (e.exit("atxHeadingText"), o(f)) : (e.consume(f), s);
  }
}
const pl = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], an = ["pre", "script", "style", "textarea"], ml = {
  name: "htmlFlow",
  tokenize: kl,
  resolveTo: xl,
  concrete: !0
}, gl = {
  tokenize: yl,
  partial: !0
}, dl = {
  tokenize: bl,
  partial: !0
};
function xl(e) {
  let n = e.length;
  for (; n-- && !(e[n][0] === "enter" && e[n][1].type === "htmlFlow"); )
    ;
  return n > 1 && e[n - 2][1].type === "linePrefix" && (e[n][1].start = e[n - 2][1].start, e[n + 1][1].start = e[n - 2][1].start, e.splice(n - 2, 2)), e;
}
function kl(e, n, t) {
  const r = this;
  let i, a, l, o, u;
  return s;
  function s(g) {
    return f(g);
  }
  function f(g) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(g), c;
  }
  function c(g) {
    return g === 33 ? (e.consume(g), p) : g === 47 ? (e.consume(g), a = !0, b) : g === 63 ? (e.consume(g), i = 3, r.interrupt ? n : m) : G(g) ? (e.consume(g), l = String.fromCharCode(g), C) : t(g);
  }
  function p(g) {
    return g === 45 ? (e.consume(g), i = 2, h) : g === 91 ? (e.consume(g), i = 5, o = 0, d) : G(g) ? (e.consume(g), i = 4, r.interrupt ? n : m) : t(g);
  }
  function h(g) {
    return g === 45 ? (e.consume(g), r.interrupt ? n : m) : t(g);
  }
  function d(g) {
    const te = "CDATA[";
    return g === te.charCodeAt(o++) ? (e.consume(g), o === te.length ? r.interrupt ? n : z : d) : t(g);
  }
  function b(g) {
    return G(g) ? (e.consume(g), l = String.fromCharCode(g), C) : t(g);
  }
  function C(g) {
    if (g === null || g === 47 || g === 62 || q(g)) {
      const te = g === 47, ge = l.toLowerCase();
      return !te && !a && an.includes(ge) ? (i = 1, r.interrupt ? n(g) : z(g)) : pl.includes(l.toLowerCase()) ? (i = 6, te ? (e.consume(g), k) : r.interrupt ? n(g) : z(g)) : (i = 7, r.interrupt && !r.parser.lazy[r.now().line] ? t(g) : a ? E(g) : S(g));
    }
    return g === 45 || Q(g) ? (e.consume(g), l += String.fromCharCode(g), C) : t(g);
  }
  function k(g) {
    return g === 62 ? (e.consume(g), r.interrupt ? n : z) : t(g);
  }
  function E(g) {
    return D(g) ? (e.consume(g), E) : x(g);
  }
  function S(g) {
    return g === 47 ? (e.consume(g), x) : g === 58 || g === 95 || G(g) ? (e.consume(g), O) : D(g) ? (e.consume(g), S) : x(g);
  }
  function O(g) {
    return g === 45 || g === 46 || g === 58 || g === 95 || Q(g) ? (e.consume(g), O) : F(g);
  }
  function F(g) {
    return g === 61 ? (e.consume(g), w) : D(g) ? (e.consume(g), F) : S(g);
  }
  function w(g) {
    return g === null || g === 60 || g === 61 || g === 62 || g === 96 ? t(g) : g === 34 || g === 39 ? (e.consume(g), u = g, R) : D(g) ? (e.consume(g), w) : H(g);
  }
  function R(g) {
    return g === u ? (e.consume(g), u = null, B) : g === null || v(g) ? t(g) : (e.consume(g), R);
  }
  function H(g) {
    return g === null || g === 34 || g === 39 || g === 47 || g === 60 || g === 61 || g === 62 || g === 96 || q(g) ? F(g) : (e.consume(g), H);
  }
  function B(g) {
    return g === 47 || g === 62 || D(g) ? S(g) : t(g);
  }
  function x(g) {
    return g === 62 ? (e.consume(g), T) : t(g);
  }
  function T(g) {
    return g === null || v(g) ? z(g) : D(g) ? (e.consume(g), T) : t(g);
  }
  function z(g) {
    return g === 45 && i === 2 ? (e.consume(g), W) : g === 60 && i === 1 ? (e.consume(g), V) : g === 62 && i === 4 ? (e.consume(g), ee) : g === 63 && i === 3 ? (e.consume(g), m) : g === 93 && i === 5 ? (e.consume(g), ae) : v(g) && (i === 6 || i === 7) ? (e.exit("htmlFlowData"), e.check(
      gl,
      oe,
      M
    )(g)) : g === null || v(g) ? (e.exit("htmlFlowData"), M(g)) : (e.consume(g), z);
  }
  function M(g) {
    return e.check(
      dl,
      $,
      oe
    )(g);
  }
  function $(g) {
    return e.enter("lineEnding"), e.consume(g), e.exit("lineEnding"), _;
  }
  function _(g) {
    return g === null || v(g) ? M(g) : (e.enter("htmlFlowData"), z(g));
  }
  function W(g) {
    return g === 45 ? (e.consume(g), m) : z(g);
  }
  function V(g) {
    return g === 47 ? (e.consume(g), l = "", X) : z(g);
  }
  function X(g) {
    if (g === 62) {
      const te = l.toLowerCase();
      return an.includes(te) ? (e.consume(g), ee) : z(g);
    }
    return G(g) && l.length < 8 ? (e.consume(g), l += String.fromCharCode(g), X) : z(g);
  }
  function ae(g) {
    return g === 93 ? (e.consume(g), m) : z(g);
  }
  function m(g) {
    return g === 62 ? (e.consume(g), ee) : g === 45 && i === 2 ? (e.consume(g), m) : z(g);
  }
  function ee(g) {
    return g === null || v(g) ? (e.exit("htmlFlowData"), oe(g)) : (e.consume(g), ee);
  }
  function oe(g) {
    return e.exit("htmlFlow"), n(g);
  }
}
function bl(e, n, t) {
  const r = this;
  return i;
  function i(l) {
    return v(l) ? (e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), a) : t(l);
  }
  function a(l) {
    return r.parser.lazy[r.now().line] ? t(l) : n(l);
  }
}
function yl(e, n, t) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), e.attempt(lt, n, t);
  }
}
const wl = {
  name: "htmlText",
  tokenize: Cl
};
function Cl(e, n, t) {
  const r = this;
  let i, a, l;
  return o;
  function o(m) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(m), u;
  }
  function u(m) {
    return m === 33 ? (e.consume(m), s) : m === 47 ? (e.consume(m), F) : m === 63 ? (e.consume(m), S) : G(m) ? (e.consume(m), H) : t(m);
  }
  function s(m) {
    return m === 45 ? (e.consume(m), f) : m === 91 ? (e.consume(m), a = 0, d) : G(m) ? (e.consume(m), E) : t(m);
  }
  function f(m) {
    return m === 45 ? (e.consume(m), h) : t(m);
  }
  function c(m) {
    return m === null ? t(m) : m === 45 ? (e.consume(m), p) : v(m) ? (l = c, V(m)) : (e.consume(m), c);
  }
  function p(m) {
    return m === 45 ? (e.consume(m), h) : c(m);
  }
  function h(m) {
    return m === 62 ? W(m) : m === 45 ? p(m) : c(m);
  }
  function d(m) {
    const ee = "CDATA[";
    return m === ee.charCodeAt(a++) ? (e.consume(m), a === ee.length ? b : d) : t(m);
  }
  function b(m) {
    return m === null ? t(m) : m === 93 ? (e.consume(m), C) : v(m) ? (l = b, V(m)) : (e.consume(m), b);
  }
  function C(m) {
    return m === 93 ? (e.consume(m), k) : b(m);
  }
  function k(m) {
    return m === 62 ? W(m) : m === 93 ? (e.consume(m), k) : b(m);
  }
  function E(m) {
    return m === null || m === 62 ? W(m) : v(m) ? (l = E, V(m)) : (e.consume(m), E);
  }
  function S(m) {
    return m === null ? t(m) : m === 63 ? (e.consume(m), O) : v(m) ? (l = S, V(m)) : (e.consume(m), S);
  }
  function O(m) {
    return m === 62 ? W(m) : S(m);
  }
  function F(m) {
    return G(m) ? (e.consume(m), w) : t(m);
  }
  function w(m) {
    return m === 45 || Q(m) ? (e.consume(m), w) : R(m);
  }
  function R(m) {
    return v(m) ? (l = R, V(m)) : D(m) ? (e.consume(m), R) : W(m);
  }
  function H(m) {
    return m === 45 || Q(m) ? (e.consume(m), H) : m === 47 || m === 62 || q(m) ? B(m) : t(m);
  }
  function B(m) {
    return m === 47 ? (e.consume(m), W) : m === 58 || m === 95 || G(m) ? (e.consume(m), x) : v(m) ? (l = B, V(m)) : D(m) ? (e.consume(m), B) : W(m);
  }
  function x(m) {
    return m === 45 || m === 46 || m === 58 || m === 95 || Q(m) ? (e.consume(m), x) : T(m);
  }
  function T(m) {
    return m === 61 ? (e.consume(m), z) : v(m) ? (l = T, V(m)) : D(m) ? (e.consume(m), T) : B(m);
  }
  function z(m) {
    return m === null || m === 60 || m === 61 || m === 62 || m === 96 ? t(m) : m === 34 || m === 39 ? (e.consume(m), i = m, M) : v(m) ? (l = z, V(m)) : D(m) ? (e.consume(m), z) : (e.consume(m), $);
  }
  function M(m) {
    return m === i ? (e.consume(m), i = void 0, _) : m === null ? t(m) : v(m) ? (l = M, V(m)) : (e.consume(m), M);
  }
  function $(m) {
    return m === null || m === 34 || m === 39 || m === 60 || m === 61 || m === 96 ? t(m) : m === 47 || m === 62 || q(m) ? B(m) : (e.consume(m), $);
  }
  function _(m) {
    return m === 47 || m === 62 || q(m) ? B(m) : t(m);
  }
  function W(m) {
    return m === 62 ? (e.consume(m), e.exit("htmlTextData"), e.exit("htmlText"), n) : t(m);
  }
  function V(m) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(m), e.exit("lineEnding"), X;
  }
  function X(m) {
    return D(m) ? j(
      e,
      ae,
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(m) : ae(m);
  }
  function ae(m) {
    return e.enter("htmlTextData"), l(m);
  }
}
const jt = {
  name: "labelEnd",
  tokenize: zl,
  resolveTo: Tl,
  resolveAll: Il
}, Sl = {
  tokenize: vl
}, El = {
  tokenize: Pl
}, Al = {
  tokenize: Ol
};
function Il(e) {
  let n = -1;
  for (; ++n < e.length; ) {
    const t = e[n][1];
    (t.type === "labelImage" || t.type === "labelLink" || t.type === "labelEnd") && (e.splice(n + 1, t.type === "labelImage" ? 4 : 2), t.type = "data", n++);
  }
  return e;
}
function Tl(e, n) {
  let t = e.length, r = 0, i, a, l, o;
  for (; t--; )
    if (i = e[t][1], a) {
      if (i.type === "link" || i.type === "labelLink" && i._inactive)
        break;
      e[t][0] === "enter" && i.type === "labelLink" && (i._inactive = !0);
    } else if (l) {
      if (e[t][0] === "enter" && (i.type === "labelImage" || i.type === "labelLink") && !i._balanced && (a = t, i.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else i.type === "labelEnd" && (l = t);
  const u = {
    type: e[a][1].type === "labelLink" ? "link" : "image",
    start: Object.assign({}, e[a][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, s = {
    type: "label",
    start: Object.assign({}, e[a][1].start),
    end: Object.assign({}, e[l][1].end)
  }, f = {
    type: "labelText",
    start: Object.assign({}, e[a + r + 2][1].end),
    end: Object.assign({}, e[l - 2][1].start)
  };
  return o = [
    ["enter", u, n],
    ["enter", s, n]
  ], o = J(o, e.slice(a + 1, a + r + 3)), o = J(o, [["enter", f, n]]), o = J(
    o,
    Lt(
      n.parser.constructs.insideSpan.null,
      e.slice(a + r + 4, l - 3),
      n
    )
  ), o = J(o, [
    ["exit", f, n],
    e[l - 2],
    e[l - 1],
    ["exit", s, n]
  ]), o = J(o, e.slice(l + 1)), o = J(o, [["exit", u, n]]), ie(e, a, e.length, o), e;
}
function zl(e, n, t) {
  const r = this;
  let i = r.events.length, a, l;
  for (; i--; )
    if ((r.events[i][1].type === "labelImage" || r.events[i][1].type === "labelLink") && !r.events[i][1]._balanced) {
      a = r.events[i][1];
      break;
    }
  return o;
  function o(p) {
    return a ? a._inactive ? c(p) : (l = r.parser.defined.includes(
      ve(
        r.sliceSerialize({
          start: a.end,
          end: r.now()
        })
      )
    ), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(p), e.exit("labelMarker"), e.exit("labelEnd"), u) : t(p);
  }
  function u(p) {
    return p === 40 ? e.attempt(
      Sl,
      f,
      l ? f : c
    )(p) : p === 91 ? e.attempt(
      El,
      f,
      l ? s : c
    )(p) : l ? f(p) : c(p);
  }
  function s(p) {
    return e.attempt(
      Al,
      f,
      c
    )(p);
  }
  function f(p) {
    return n(p);
  }
  function c(p) {
    return a._balanced = !0, t(p);
  }
}
function vl(e, n, t) {
  return r;
  function r(c) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(c), e.exit("resourceMarker"), i;
  }
  function i(c) {
    return q(c) ? Ne(e, a)(c) : a(c);
  }
  function a(c) {
    return c === 41 ? f(c) : Kn(
      e,
      l,
      o,
      "resourceDestination",
      "resourceDestinationLiteral",
      "resourceDestinationLiteralMarker",
      "resourceDestinationRaw",
      "resourceDestinationString",
      32
    )(c);
  }
  function l(c) {
    return q(c) ? Ne(e, u)(c) : f(c);
  }
  function o(c) {
    return t(c);
  }
  function u(c) {
    return c === 34 || c === 39 || c === 40 ? er(
      e,
      s,
      t,
      "resourceTitle",
      "resourceTitleMarker",
      "resourceTitleString"
    )(c) : f(c);
  }
  function s(c) {
    return q(c) ? Ne(e, f)(c) : f(c);
  }
  function f(c) {
    return c === 41 ? (e.enter("resourceMarker"), e.consume(c), e.exit("resourceMarker"), e.exit("resource"), n) : t(c);
  }
}
function Pl(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    return Xn.call(
      r,
      e,
      a,
      l,
      "reference",
      "referenceMarker",
      "referenceString"
    )(o);
  }
  function a(o) {
    return r.parser.defined.includes(
      ve(
        r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)
      )
    ) ? n(o) : t(o);
  }
  function l(o) {
    return t(o);
  }
}
function Ol(e, n, t) {
  return r;
  function r(a) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(a), e.exit("referenceMarker"), i;
  }
  function i(a) {
    return a === 93 ? (e.enter("referenceMarker"), e.consume(a), e.exit("referenceMarker"), e.exit("reference"), n) : t(a);
  }
}
const Fl = {
  name: "labelStartImage",
  tokenize: Dl,
  resolveAll: jt.resolveAll
};
function Dl(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(o), e.exit("labelImageMarker"), a;
  }
  function a(o) {
    return o === 91 ? (e.enter("labelMarker"), e.consume(o), e.exit("labelMarker"), e.exit("labelImage"), l) : t(o);
  }
  function l(o) {
    return o === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? t(o) : n(o);
  }
}
const Ll = {
  name: "labelStartLink",
  tokenize: jl,
  resolveAll: jt.resolveAll
};
function jl(e, n, t) {
  const r = this;
  return i;
  function i(l) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelLink"), a;
  }
  function a(l) {
    return l === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? t(l) : n(l);
  }
}
const ft = {
  name: "lineEnding",
  tokenize: Rl
};
function Rl(e, n) {
  return t;
  function t(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), j(e, n, "linePrefix");
  }
}
const Ze = {
  name: "thematicBreak",
  tokenize: _l
};
function _l(e, n, t) {
  let r = 0, i;
  return a;
  function a(s) {
    return e.enter("thematicBreak"), l(s);
  }
  function l(s) {
    return i = s, o(s);
  }
  function o(s) {
    return s === i ? (e.enter("thematicBreakSequence"), u(s)) : r >= 3 && (s === null || v(s)) ? (e.exit("thematicBreak"), n(s)) : t(s);
  }
  function u(s) {
    return s === i ? (e.consume(s), r++, u) : (e.exit("thematicBreakSequence"), D(s) ? j(e, o, "whitespace")(s) : o(s));
  }
}
const Y = {
  name: "list",
  tokenize: Ml,
  continuation: {
    tokenize: ql
  },
  exit: $l
}, Bl = {
  tokenize: Vl,
  partial: !0
}, Nl = {
  tokenize: Hl,
  partial: !0
};
function Ml(e, n, t) {
  const r = this, i = r.events[r.events.length - 1];
  let a = i && i[1].type === "linePrefix" ? i[2].sliceSerialize(i[1], !0).length : 0, l = 0;
  return o;
  function o(h) {
    const d = r.containerState.type || (h === 42 || h === 43 || h === 45 ? "listUnordered" : "listOrdered");
    if (d === "listUnordered" ? !r.containerState.marker || h === r.containerState.marker : Et(h)) {
      if (r.containerState.type || (r.containerState.type = d, e.enter(d, {
        _container: !0
      })), d === "listUnordered")
        return e.enter("listItemPrefix"), h === 42 || h === 45 ? e.check(Ze, t, s)(h) : s(h);
      if (!r.interrupt || h === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), u(h);
    }
    return t(h);
  }
  function u(h) {
    return Et(h) && ++l < 10 ? (e.consume(h), u) : (!r.interrupt || l < 2) && (r.containerState.marker ? h === r.containerState.marker : h === 41 || h === 46) ? (e.exit("listItemValue"), s(h)) : t(h);
  }
  function s(h) {
    return e.enter("listItemMarker"), e.consume(h), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || h, e.check(
      lt,
      // Can’t be empty when interrupting.
      r.interrupt ? t : f,
      e.attempt(
        Bl,
        p,
        c
      )
    );
  }
  function f(h) {
    return r.containerState.initialBlankLine = !0, a++, p(h);
  }
  function c(h) {
    return D(h) ? (e.enter("listItemPrefixWhitespace"), e.consume(h), e.exit("listItemPrefixWhitespace"), p) : t(h);
  }
  function p(h) {
    return r.containerState.size = a + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, n(h);
  }
}
function ql(e, n, t) {
  const r = this;
  return r.containerState._closeFlow = void 0, e.check(lt, i, a);
  function i(o) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, j(
      e,
      n,
      "listItemIndent",
      r.containerState.size + 1
    )(o);
  }
  function a(o) {
    return r.containerState.furtherBlankLines || !D(o) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, l(o)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt(Nl, n, l)(o));
  }
  function l(o) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, j(
      e,
      e.attempt(Y, n, t),
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(o);
  }
}
function Hl(e, n, t) {
  const r = this;
  return j(
    e,
    i,
    "listItemIndent",
    r.containerState.size + 1
  );
  function i(a) {
    const l = r.events[r.events.length - 1];
    return l && l[1].type === "listItemIndent" && l[2].sliceSerialize(l[1], !0).length === r.containerState.size ? n(a) : t(a);
  }
}
function $l(e) {
  e.exit(this.containerState.type);
}
function Vl(e, n, t) {
  const r = this;
  return j(
    e,
    i,
    "listItemPrefixWhitespace",
    r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5
  );
  function i(a) {
    const l = r.events[r.events.length - 1];
    return !D(a) && l && l[1].type === "listItemPrefixWhitespace" ? n(a) : t(a);
  }
}
const on = {
  name: "setextUnderline",
  tokenize: Wl,
  resolveTo: Ul
};
function Ul(e, n) {
  let t = e.length, r, i, a;
  for (; t--; )
    if (e[t][0] === "enter") {
      if (e[t][1].type === "content") {
        r = t;
        break;
      }
      e[t][1].type === "paragraph" && (i = t);
    } else
      e[t][1].type === "content" && e.splice(t, 1), !a && e[t][1].type === "definition" && (a = t);
  const l = {
    type: "setextHeading",
    start: Object.assign({}, e[i][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  };
  return e[i][1].type = "setextHeadingText", a ? (e.splice(i, 0, ["enter", l, n]), e.splice(a + 1, 0, ["exit", e[r][1], n]), e[r][1].end = Object.assign({}, e[a][1].end)) : e[r][1] = l, e.push(["exit", l, n]), e;
}
function Wl(e, n, t) {
  const r = this;
  let i;
  return a;
  function a(s) {
    let f = r.events.length, c;
    for (; f--; )
      if (r.events[f][1].type !== "lineEnding" && r.events[f][1].type !== "linePrefix" && r.events[f][1].type !== "content") {
        c = r.events[f][1].type === "paragraph";
        break;
      }
    return !r.parser.lazy[r.now().line] && (r.interrupt || c) ? (e.enter("setextHeadingLine"), i = s, l(s)) : t(s);
  }
  function l(s) {
    return e.enter("setextHeadingLineSequence"), o(s);
  }
  function o(s) {
    return s === i ? (e.consume(s), o) : (e.exit("setextHeadingLineSequence"), D(s) ? j(e, u, "lineSuffix")(s) : u(s));
  }
  function u(s) {
    return s === null || v(s) ? (e.exit("setextHeadingLine"), n(s)) : t(s);
  }
}
const Ql = {
  tokenize: Gl
};
function Gl(e) {
  const n = this, t = e.attempt(
    // Try to parse a blank line.
    lt,
    r,
    // Try to parse initial flow (essentially, only code).
    e.attempt(
      this.parser.constructs.flowInitial,
      i,
      j(
        e,
        e.attempt(
          this.parser.constructs.flow,
          i,
          e.attempt(Xi, i)
        ),
        "linePrefix"
      )
    )
  );
  return t;
  function r(a) {
    if (a === null) {
      e.consume(a);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(a), e.exit("lineEndingBlank"), n.currentConstruct = void 0, t;
  }
  function i(a) {
    if (a === null) {
      e.consume(a);
      return;
    }
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), n.currentConstruct = void 0, t;
  }
}
const Yl = {
  resolveAll: nr()
}, Zl = tr("string"), Jl = tr("text");
function tr(e) {
  return {
    tokenize: n,
    resolveAll: nr(
      e === "text" ? Kl : void 0
    )
  };
  function n(t) {
    const r = this, i = this.parser.constructs[e], a = t.attempt(i, l, o);
    return l;
    function l(f) {
      return s(f) ? a(f) : o(f);
    }
    function o(f) {
      if (f === null) {
        t.consume(f);
        return;
      }
      return t.enter("data"), t.consume(f), u;
    }
    function u(f) {
      return s(f) ? (t.exit("data"), a(f)) : (t.consume(f), u);
    }
    function s(f) {
      if (f === null)
        return !0;
      const c = i[f];
      let p = -1;
      if (c)
        for (; ++p < c.length; ) {
          const h = c[p];
          if (!h.previous || h.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function nr(e) {
  return n;
  function n(t, r) {
    let i = -1, a;
    for (; ++i <= t.length; )
      a === void 0 ? t[i] && t[i][1].type === "data" && (a = i, i++) : (!t[i] || t[i][1].type !== "data") && (i !== a + 2 && (t[a][1].end = t[i - 1][1].end, t.splice(a + 2, i - a - 2), i = a + 2), a = void 0);
    return e ? e(t, r) : t;
  }
}
function Kl(e, n) {
  let t = 0;
  for (; ++t <= e.length; )
    if ((t === e.length || e[t][1].type === "lineEnding") && e[t - 1][1].type === "data") {
      const r = e[t - 1][1], i = n.sliceStream(r);
      let a = i.length, l = -1, o = 0, u;
      for (; a--; ) {
        const s = i[a];
        if (typeof s == "string") {
          for (l = s.length; s.charCodeAt(l - 1) === 32; )
            o++, l--;
          if (l) break;
          l = -1;
        } else if (s === -2)
          u = !0, o++;
        else if (s !== -1) {
          a++;
          break;
        }
      }
      if (o) {
        const s = {
          type: t === e.length || u || o < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            line: r.end.line,
            column: r.end.column - o,
            offset: r.end.offset - o,
            _index: r.start._index + a,
            _bufferIndex: a ? l : r.start._bufferIndex + l
          },
          end: Object.assign({}, r.end)
        };
        r.end = Object.assign({}, s.start), r.start.offset === r.end.offset ? Object.assign(r, s) : (e.splice(
          t,
          0,
          ["enter", s, n],
          ["exit", s, n]
        ), t += 2);
      }
      t++;
    }
  return e;
}
function Xl(e, n, t) {
  let r = Object.assign(
    t ? Object.assign({}, t) : {
      line: 1,
      column: 1,
      offset: 0
    },
    {
      _index: 0,
      _bufferIndex: -1
    }
  );
  const i = {}, a = [];
  let l = [], o = [];
  const u = {
    consume: E,
    enter: S,
    exit: O,
    attempt: R(F),
    check: R(w),
    interrupt: R(w, {
      interrupt: !0
    })
  }, s = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser: e,
    sliceStream: h,
    sliceSerialize: p,
    now: d,
    defineSkip: b,
    write: c
  };
  let f = n.tokenize.call(s, u);
  return n.resolveAll && a.push(n), s;
  function c(T) {
    return l = J(l, T), C(), l[l.length - 1] !== null ? [] : (H(n, 0), s.events = Lt(a, s.events, s), s.events);
  }
  function p(T, z) {
    return ta(h(T), z);
  }
  function h(T) {
    return ea(l, T);
  }
  function d() {
    const { line: T, column: z, offset: M, _index: $, _bufferIndex: _ } = r;
    return {
      line: T,
      column: z,
      offset: M,
      _index: $,
      _bufferIndex: _
    };
  }
  function b(T) {
    i[T.line] = T.column, x();
  }
  function C() {
    let T;
    for (; r._index < l.length; ) {
      const z = l[r._index];
      if (typeof z == "string")
        for (T = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === T && r._bufferIndex < z.length; )
          k(z.charCodeAt(r._bufferIndex));
      else
        k(z);
    }
  }
  function k(T) {
    f = f(T);
  }
  function E(T) {
    v(T) ? (r.line++, r.column = 1, r.offset += T === -3 ? 2 : 1, x()) : T !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === l[r._index].length && (r._bufferIndex = -1, r._index++)), s.previous = T;
  }
  function S(T, z) {
    const M = z || {};
    return M.type = T, M.start = d(), s.events.push(["enter", M, s]), o.push(M), M;
  }
  function O(T) {
    const z = o.pop();
    return z.end = d(), s.events.push(["exit", z, s]), z;
  }
  function F(T, z) {
    H(T, z.from);
  }
  function w(T, z) {
    z.restore();
  }
  function R(T, z) {
    return M;
    function M($, _, W) {
      let V, X, ae, m;
      return Array.isArray($) ? oe($) : "tokenize" in $ ? (
        // @ts-expect-error Looks like a construct.
        oe([$])
      ) : ee($);
      function ee(U) {
        return Le;
        function Le(fe) {
          const Se = fe !== null && U[fe], de = fe !== null && U.null, ot = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(Se) ? Se : Se ? [Se] : [],
            ...Array.isArray(de) ? de : de ? [de] : []
          ];
          return oe(ot)(fe);
        }
      }
      function oe(U) {
        return V = U, X = 0, U.length === 0 ? W : g(U[X]);
      }
      function g(U) {
        return Le;
        function Le(fe) {
          return m = B(), ae = U, U.partial || (s.currentConstruct = U), U.name && s.parser.constructs.disable.null.includes(U.name) ? ge() : U.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            z ? Object.assign(Object.create(s), z) : s,
            u,
            te,
            ge
          )(fe);
        }
      }
      function te(U) {
        return T(ae, m), _;
      }
      function ge(U) {
        return m.restore(), ++X < V.length ? g(V[X]) : W;
      }
    }
  }
  function H(T, z) {
    T.resolveAll && !a.includes(T) && a.push(T), T.resolve && ie(
      s.events,
      z,
      s.events.length - z,
      T.resolve(s.events.slice(z), s)
    ), T.resolveTo && (s.events = T.resolveTo(s.events, s));
  }
  function B() {
    const T = d(), z = s.previous, M = s.currentConstruct, $ = s.events.length, _ = Array.from(o);
    return {
      restore: W,
      from: $
    };
    function W() {
      r = T, s.previous = z, s.currentConstruct = M, s.events.length = $, o = _, x();
    }
  }
  function x() {
    r.line in i && r.column < 2 && (r.column = i[r.line], r.offset += i[r.line] - 1);
  }
}
function ea(e, n) {
  const t = n.start._index, r = n.start._bufferIndex, i = n.end._index, a = n.end._bufferIndex;
  let l;
  if (t === i)
    l = [e[t].slice(r, a)];
  else {
    if (l = e.slice(t, i), r > -1) {
      const o = l[0];
      typeof o == "string" ? l[0] = o.slice(r) : l.shift();
    }
    a > 0 && l.push(e[i].slice(0, a));
  }
  return l;
}
function ta(e, n) {
  let t = -1;
  const r = [];
  let i;
  for (; ++t < e.length; ) {
    const a = e[t];
    let l;
    if (typeof a == "string")
      l = a;
    else
      switch (a) {
        case -5: {
          l = "\r";
          break;
        }
        case -4: {
          l = `
`;
          break;
        }
        case -3: {
          l = `\r
`;
          break;
        }
        case -2: {
          l = n ? " " : "	";
          break;
        }
        case -1: {
          if (!n && i) continue;
          l = " ";
          break;
        }
        default:
          l = String.fromCharCode(a);
      }
    i = a === -2, r.push(l);
  }
  return r.join("");
}
const na = {
  42: Y,
  43: Y,
  45: Y,
  48: Y,
  49: Y,
  50: Y,
  51: Y,
  52: Y,
  53: Y,
  54: Y,
  55: Y,
  56: Y,
  57: Y,
  62: Gn
}, ra = {
  91: il
}, ia = {
  [-2]: ct,
  [-1]: ct,
  32: ct
}, la = {
  35: cl,
  42: Ze,
  45: [on, Ze],
  60: ml,
  61: on,
  95: Ze,
  96: ln,
  126: ln
}, aa = {
  38: Zn,
  92: Yn
}, oa = {
  [-5]: ft,
  [-4]: ft,
  [-3]: ft,
  33: Fl,
  38: Zn,
  42: At,
  60: [ji, wl],
  91: Ll,
  92: [ul, Yn],
  93: jt,
  95: At,
  96: Gi
}, ua = {
  null: [At, Yl]
}, sa = {
  null: [42, 95]
}, ca = {
  null: []
}, fa = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: sa,
  contentInitial: ra,
  disable: ca,
  document: na,
  flow: la,
  flowInitial: ia,
  insideSpan: ua,
  string: aa,
  text: oa
}, Symbol.toStringTag, { value: "Module" }));
function ha(e) {
  const t = (
    /** @type {FullNormalizedExtension} */
    Ci([fa, ...(e || {}).extensions || []])
  ), r = {
    defined: [],
    lazy: {},
    constructs: t,
    content: i(zi),
    document: i(Pi),
    flow: i(Ql),
    string: i(Zl),
    text: i(Jl)
  };
  return r;
  function i(a) {
    return l;
    function l(o) {
      return Xl(r, a, o);
    }
  }
}
function pa(e) {
  for (; !Jn(e); )
    ;
  return e;
}
const un = /[\0\t\n\r]/g;
function ma() {
  let e = 1, n = "", t = !0, r;
  return i;
  function i(a, l, o) {
    const u = [];
    let s, f, c, p, h;
    for (a = n + (typeof a == "string" ? a.toString() : new TextDecoder(l || void 0).decode(a)), c = 0, n = "", t && (a.charCodeAt(0) === 65279 && c++, t = void 0); c < a.length; ) {
      if (un.lastIndex = c, s = un.exec(a), p = s && s.index !== void 0 ? s.index : a.length, h = a.charCodeAt(p), !s) {
        n = a.slice(c);
        break;
      }
      if (h === 10 && c === p && r)
        u.push(-3), r = void 0;
      else
        switch (r && (u.push(-5), r = void 0), c < p && (u.push(a.slice(c, p)), e += p - c), h) {
          case 0: {
            u.push(65533), e++;
            break;
          }
          case 9: {
            for (f = Math.ceil(e / 4) * 4, u.push(-2); e++ < f; ) u.push(-1);
            break;
          }
          case 10: {
            u.push(-4), e = 1;
            break;
          }
          default:
            r = !0, e = 1;
        }
      c = p + 1;
    }
    return o && (r && u.push(-5), n && u.push(n), u.push(null)), u;
  }
}
const ga = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function da(e) {
  return e.replace(ga, xa);
}
function xa(e, n, t) {
  if (n)
    return n;
  if (t.charCodeAt(0) === 35) {
    const i = t.charCodeAt(1), a = i === 120 || i === 88;
    return Qn(t.slice(a ? 2 : 1), a ? 16 : 10);
  }
  return Dt(t) || e;
}
const rr = {}.hasOwnProperty;
function ka(e, n, t) {
  return typeof n != "string" && (t = n, n = void 0), ba(t)(
    pa(
      ha(t).document().write(ma()(e, n, !0))
    )
  );
}
function ba(e) {
  const n = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: a(Gt),
      autolinkProtocol: B,
      autolinkEmail: B,
      atxHeading: a(Ut),
      blockQuote: a(Se),
      characterEscape: B,
      characterReference: B,
      codeFenced: a(de),
      codeFencedFenceInfo: l,
      codeFencedFenceMeta: l,
      codeIndented: a(de, l),
      codeText: a(ot, l),
      codeTextData: B,
      data: B,
      codeFlowValue: B,
      definition: a(Mr),
      definitionDestinationString: l,
      definitionLabelString: l,
      definitionTitleString: l,
      emphasis: a(qr),
      hardBreakEscape: a(Wt),
      hardBreakTrailing: a(Wt),
      htmlFlow: a(Qt, l),
      htmlFlowData: B,
      htmlText: a(Qt, l),
      htmlTextData: B,
      image: a(Hr),
      label: l,
      link: a(Gt),
      listItem: a($r),
      listItemValue: p,
      listOrdered: a(Yt, c),
      listUnordered: a(Yt),
      paragraph: a(Vr),
      reference: g,
      referenceString: l,
      resourceDestinationString: l,
      resourceTitleString: l,
      setextHeading: a(Ut),
      strong: a(Ur),
      thematicBreak: a(Qr)
    },
    exit: {
      atxHeading: u(),
      atxHeadingSequence: F,
      autolink: u(),
      autolinkEmail: fe,
      autolinkProtocol: Le,
      blockQuote: u(),
      characterEscapeValue: x,
      characterReferenceMarkerHexadecimal: ge,
      characterReferenceMarkerNumeric: ge,
      characterReferenceValue: U,
      codeFenced: u(C),
      codeFencedFence: b,
      codeFencedFenceInfo: h,
      codeFencedFenceMeta: d,
      codeFlowValue: x,
      codeIndented: u(k),
      codeText: u(_),
      codeTextData: x,
      data: x,
      definition: u(),
      definitionDestinationString: O,
      definitionLabelString: E,
      definitionTitleString: S,
      emphasis: u(),
      hardBreakEscape: u(z),
      hardBreakTrailing: u(z),
      htmlFlow: u(M),
      htmlFlowData: x,
      htmlText: u($),
      htmlTextData: x,
      image: u(V),
      label: ae,
      labelText: X,
      lineEnding: T,
      link: u(W),
      listItem: u(),
      listOrdered: u(),
      listUnordered: u(),
      paragraph: u(),
      referenceString: te,
      resourceDestinationString: m,
      resourceTitleString: ee,
      resource: oe,
      setextHeading: u(H),
      setextHeadingLineSequence: R,
      setextHeadingText: w,
      strong: u(),
      thematicBreak: u()
    }
  };
  ir(n, (e || {}).mdastExtensions || []);
  const t = {};
  return r;
  function r(y) {
    let A = {
      type: "root",
      children: []
    };
    const P = {
      stack: [A],
      tokenStack: [],
      config: n,
      enter: o,
      exit: s,
      buffer: l,
      resume: f,
      data: t
    }, L = [];
    let N = -1;
    for (; ++N < y.length; )
      if (y[N][1].type === "listOrdered" || y[N][1].type === "listUnordered")
        if (y[N][0] === "enter")
          L.push(N);
        else {
          const ne = L.pop();
          N = i(y, ne, N);
        }
    for (N = -1; ++N < y.length; ) {
      const ne = n[y[N][0]];
      rr.call(ne, y[N][1].type) && ne[y[N][1].type].call(
        Object.assign(
          {
            sliceSerialize: y[N][2].sliceSerialize
          },
          P
        ),
        y[N][1]
      );
    }
    if (P.tokenStack.length > 0) {
      const ne = P.tokenStack[P.tokenStack.length - 1];
      (ne[1] || sn).call(P, void 0, ne[0]);
    }
    for (A.position = {
      start: he(
        y.length > 0 ? y[0][1].start : {
          line: 1,
          column: 1,
          offset: 0
        }
      ),
      end: he(
        y.length > 0 ? y[y.length - 2][1].end : {
          line: 1,
          column: 1,
          offset: 0
        }
      )
    }, N = -1; ++N < n.transforms.length; )
      A = n.transforms[N](A) || A;
    return A;
  }
  function i(y, A, P) {
    let L = A - 1, N = -1, ne = !1, xe, ue, je, Re;
    for (; ++L <= P; ) {
      const Z = y[L];
      switch (Z[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          Z[0] === "enter" ? N++ : N--, Re = void 0;
          break;
        }
        case "lineEndingBlank": {
          Z[0] === "enter" && (xe && !Re && !N && !je && (je = L), Re = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          Re = void 0;
      }
      if (!N && Z[0] === "enter" && Z[1].type === "listItemPrefix" || N === -1 && Z[0] === "exit" && (Z[1].type === "listUnordered" || Z[1].type === "listOrdered")) {
        if (xe) {
          let Ee = L;
          for (ue = void 0; Ee--; ) {
            const se = y[Ee];
            if (se[1].type === "lineEnding" || se[1].type === "lineEndingBlank") {
              if (se[0] === "exit") continue;
              ue && (y[ue][1].type = "lineEndingBlank", ne = !0), se[1].type = "lineEnding", ue = Ee;
            } else if (!(se[1].type === "linePrefix" || se[1].type === "blockQuotePrefix" || se[1].type === "blockQuotePrefixWhitespace" || se[1].type === "blockQuoteMarker" || se[1].type === "listItemIndent")) break;
          }
          je && (!ue || je < ue) && (xe._spread = !0), xe.end = Object.assign(
            {},
            ue ? y[ue][1].start : Z[1].end
          ), y.splice(ue || L, 0, ["exit", xe, Z[2]]), L++, P++;
        }
        if (Z[1].type === "listItemPrefix") {
          const Ee = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, Z[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          xe = Ee, y.splice(L, 0, ["enter", Ee, Z[2]]), L++, P++, je = void 0, Re = !0;
        }
      }
    }
    return y[A][1]._spread = ne, P;
  }
  function a(y, A) {
    return P;
    function P(L) {
      o.call(this, y(L), L), A && A.call(this, L);
    }
  }
  function l() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function o(y, A, P) {
    this.stack[this.stack.length - 1].children.push(y), this.stack.push(y), this.tokenStack.push([A, P]), y.position = {
      start: he(A.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function u(y) {
    return A;
    function A(P) {
      y && y.call(this, P), s.call(this, P);
    }
  }
  function s(y, A) {
    const P = this.stack.pop(), L = this.tokenStack.pop();
    if (L)
      L[0].type !== y.type && (A ? A.call(this, y, L[0]) : (L[1] || sn).call(this, y, L[0]));
    else throw new Error(
      "Cannot close `" + y.type + "` (" + Ye({
        start: y.start,
        end: y.end
      }) + "): it’s not open"
    );
    P.position.end = he(y.end);
  }
  function f() {
    return Ft(this.stack.pop());
  }
  function c() {
    this.data.expectingFirstListItemValue = !0;
  }
  function p(y) {
    if (this.data.expectingFirstListItemValue) {
      const A = this.stack[this.stack.length - 2];
      A.start = Number.parseInt(this.sliceSerialize(y), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function h() {
    const y = this.resume(), A = this.stack[this.stack.length - 1];
    A.lang = y;
  }
  function d() {
    const y = this.resume(), A = this.stack[this.stack.length - 1];
    A.meta = y;
  }
  function b() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function C() {
    const y = this.resume(), A = this.stack[this.stack.length - 1];
    A.value = y.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function k() {
    const y = this.resume(), A = this.stack[this.stack.length - 1];
    A.value = y.replace(/(\r?\n|\r)$/g, "");
  }
  function E(y) {
    const A = this.resume(), P = this.stack[this.stack.length - 1];
    P.label = A, P.identifier = ve(
      this.sliceSerialize(y)
    ).toLowerCase();
  }
  function S() {
    const y = this.resume(), A = this.stack[this.stack.length - 1];
    A.title = y;
  }
  function O() {
    const y = this.resume(), A = this.stack[this.stack.length - 1];
    A.url = y;
  }
  function F(y) {
    const A = this.stack[this.stack.length - 1];
    if (!A.depth) {
      const P = this.sliceSerialize(y).length;
      A.depth = P;
    }
  }
  function w() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function R(y) {
    const A = this.stack[this.stack.length - 1];
    A.depth = this.sliceSerialize(y).codePointAt(0) === 61 ? 1 : 2;
  }
  function H() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function B(y) {
    const P = this.stack[this.stack.length - 1].children;
    let L = P[P.length - 1];
    (!L || L.type !== "text") && (L = Wr(), L.position = {
      start: he(y.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, P.push(L)), this.stack.push(L);
  }
  function x(y) {
    const A = this.stack.pop();
    A.value += this.sliceSerialize(y), A.position.end = he(y.end);
  }
  function T(y) {
    const A = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const P = A.children[A.children.length - 1];
      P.position.end = he(y.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && n.canContainEols.includes(A.type) && (B.call(this, y), x.call(this, y));
  }
  function z() {
    this.data.atHardBreak = !0;
  }
  function M() {
    const y = this.resume(), A = this.stack[this.stack.length - 1];
    A.value = y;
  }
  function $() {
    const y = this.resume(), A = this.stack[this.stack.length - 1];
    A.value = y;
  }
  function _() {
    const y = this.resume(), A = this.stack[this.stack.length - 1];
    A.value = y;
  }
  function W() {
    const y = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const A = this.data.referenceType || "shortcut";
      y.type += "Reference", y.referenceType = A, delete y.url, delete y.title;
    } else
      delete y.identifier, delete y.label;
    this.data.referenceType = void 0;
  }
  function V() {
    const y = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const A = this.data.referenceType || "shortcut";
      y.type += "Reference", y.referenceType = A, delete y.url, delete y.title;
    } else
      delete y.identifier, delete y.label;
    this.data.referenceType = void 0;
  }
  function X(y) {
    const A = this.sliceSerialize(y), P = this.stack[this.stack.length - 2];
    P.label = da(A), P.identifier = ve(A).toLowerCase();
  }
  function ae() {
    const y = this.stack[this.stack.length - 1], A = this.resume(), P = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, P.type === "link") {
      const L = y.children;
      P.children = L;
    } else
      P.alt = A;
  }
  function m() {
    const y = this.resume(), A = this.stack[this.stack.length - 1];
    A.url = y;
  }
  function ee() {
    const y = this.resume(), A = this.stack[this.stack.length - 1];
    A.title = y;
  }
  function oe() {
    this.data.inReference = void 0;
  }
  function g() {
    this.data.referenceType = "collapsed";
  }
  function te(y) {
    const A = this.resume(), P = this.stack[this.stack.length - 1];
    P.label = A, P.identifier = ve(
      this.sliceSerialize(y)
    ).toLowerCase(), this.data.referenceType = "full";
  }
  function ge(y) {
    this.data.characterReferenceType = y.type;
  }
  function U(y) {
    const A = this.sliceSerialize(y), P = this.data.characterReferenceType;
    let L;
    P ? (L = Qn(
      A,
      P === "characterReferenceMarkerNumeric" ? 10 : 16
    ), this.data.characterReferenceType = void 0) : L = Dt(A);
    const N = this.stack.pop();
    N.value += L, N.position.end = he(y.end);
  }
  function Le(y) {
    x.call(this, y);
    const A = this.stack[this.stack.length - 1];
    A.url = this.sliceSerialize(y);
  }
  function fe(y) {
    x.call(this, y);
    const A = this.stack[this.stack.length - 1];
    A.url = "mailto:" + this.sliceSerialize(y);
  }
  function Se() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function de() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function ot() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function Mr() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function qr() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function Ut() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function Wt() {
    return {
      type: "break"
    };
  }
  function Qt() {
    return {
      type: "html",
      value: ""
    };
  }
  function Hr() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Gt() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function Yt(y) {
    return {
      type: "list",
      ordered: y.type === "listOrdered",
      start: null,
      spread: y._spread,
      children: []
    };
  }
  function $r(y) {
    return {
      type: "listItem",
      spread: y._spread,
      checked: null,
      children: []
    };
  }
  function Vr() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function Ur() {
    return {
      type: "strong",
      children: []
    };
  }
  function Wr() {
    return {
      type: "text",
      value: ""
    };
  }
  function Qr() {
    return {
      type: "thematicBreak"
    };
  }
}
function he(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function ir(e, n) {
  let t = -1;
  for (; ++t < n.length; ) {
    const r = n[t];
    Array.isArray(r) ? ir(e, r) : ya(e, r);
  }
}
function ya(e, n) {
  let t;
  for (t in n)
    if (rr.call(n, t))
      switch (t) {
        case "canContainEols": {
          const r = n[t];
          r && e[t].push(...r);
          break;
        }
        case "transforms": {
          const r = n[t];
          r && e[t].push(...r);
          break;
        }
        case "enter":
        case "exit": {
          const r = n[t];
          r && Object.assign(e[t], r);
          break;
        }
      }
}
function sn(e, n) {
  throw e ? new Error(
    "Cannot close `" + e.type + "` (" + Ye({
      start: e.start,
      end: e.end
    }) + "): a different token (`" + n.type + "`, " + Ye({
      start: n.start,
      end: n.end
    }) + ") is open"
  ) : new Error(
    "Cannot close document, a token (`" + n.type + "`, " + Ye({
      start: n.start,
      end: n.end
    }) + ") is still open"
  );
}
function wa(e) {
  const n = this;
  n.parser = t;
  function t(r) {
    return ka(r, {
      ...n.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: n.data("micromarkExtensions") || [],
      mdastExtensions: n.data("fromMarkdownExtensions") || []
    });
  }
}
function Ca(e, n) {
  const t = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(n), !0)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function Sa(e, n) {
  const t = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(n, t), [e.applyData(n, t), { type: "text", value: `
` }];
}
function Ea(e, n) {
  const t = n.value ? n.value + `
` : "", r = {};
  n.lang && (r.className = ["language-" + n.lang]);
  let i = {
    type: "element",
    tagName: "code",
    properties: r,
    children: [{ type: "text", value: t }]
  };
  return n.meta && (i.data = { meta: n.meta }), e.patch(n, i), i = e.applyData(n, i), i = { type: "element", tagName: "pre", properties: {}, children: [i] }, e.patch(n, i), i;
}
function Aa(e, n) {
  const t = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function Ia(e, n) {
  const t = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function De(e) {
  const n = [];
  let t = -1, r = 0, i = 0;
  for (; ++t < e.length; ) {
    const a = e.charCodeAt(t);
    let l = "";
    if (a === 37 && Q(e.charCodeAt(t + 1)) && Q(e.charCodeAt(t + 2)))
      i = 2;
    else if (a < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(a)) || (l = String.fromCharCode(a));
    else if (a > 55295 && a < 57344) {
      const o = e.charCodeAt(t + 1);
      a < 56320 && o > 56319 && o < 57344 ? (l = String.fromCharCode(a, o), i = 1) : l = "�";
    } else
      l = String.fromCharCode(a);
    l && (n.push(e.slice(r, t), encodeURIComponent(l)), r = t + i + 1, l = ""), i && (t += i, i = 0);
  }
  return n.join("") + e.slice(r);
}
function Ta(e, n) {
  const t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = String(n.identifier).toUpperCase(), i = De(r.toLowerCase()), a = e.footnoteOrder.indexOf(r);
  let l, o = e.footnoteCounts.get(r);
  o === void 0 ? (o = 0, e.footnoteOrder.push(r), l = e.footnoteOrder.length) : l = a + 1, o += 1, e.footnoteCounts.set(r, o);
  const u = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + t + "fn-" + i,
      id: t + "fnref-" + i + (o > 1 ? "-" + o : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(l) }]
  };
  e.patch(n, u);
  const s = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [u]
  };
  return e.patch(n, s), e.applyData(n, s);
}
function za(e, n) {
  const t = {
    type: "element",
    tagName: "h" + n.depth,
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function va(e, n) {
  if (e.options.allowDangerousHtml) {
    const t = { type: "raw", value: n.value };
    return e.patch(n, t), e.applyData(n, t);
  }
}
function lr(e, n) {
  const t = n.referenceType;
  let r = "]";
  if (t === "collapsed" ? r += "[]" : t === "full" && (r += "[" + (n.label || n.identifier) + "]"), n.type === "imageReference")
    return [{ type: "text", value: "![" + n.alt + r }];
  const i = e.all(n), a = i[0];
  a && a.type === "text" ? a.value = "[" + a.value : i.unshift({ type: "text", value: "[" });
  const l = i[i.length - 1];
  return l && l.type === "text" ? l.value += r : i.push({ type: "text", value: r }), i;
}
function Pa(e, n) {
  const t = String(n.identifier).toUpperCase(), r = e.definitionById.get(t);
  if (!r)
    return lr(e, n);
  const i = { src: De(r.url || ""), alt: n.alt };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const a = { type: "element", tagName: "img", properties: i, children: [] };
  return e.patch(n, a), e.applyData(n, a);
}
function Oa(e, n) {
  const t = { src: De(n.url) };
  n.alt !== null && n.alt !== void 0 && (t.alt = n.alt), n.title !== null && n.title !== void 0 && (t.title = n.title);
  const r = { type: "element", tagName: "img", properties: t, children: [] };
  return e.patch(n, r), e.applyData(n, r);
}
function Fa(e, n) {
  const t = { type: "text", value: n.value.replace(/\r?\n|\r/g, " ") };
  e.patch(n, t);
  const r = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [t]
  };
  return e.patch(n, r), e.applyData(n, r);
}
function Da(e, n) {
  const t = String(n.identifier).toUpperCase(), r = e.definitionById.get(t);
  if (!r)
    return lr(e, n);
  const i = { href: De(r.url || "") };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const a = {
    type: "element",
    tagName: "a",
    properties: i,
    children: e.all(n)
  };
  return e.patch(n, a), e.applyData(n, a);
}
function La(e, n) {
  const t = { href: De(n.url) };
  n.title !== null && n.title !== void 0 && (t.title = n.title);
  const r = {
    type: "element",
    tagName: "a",
    properties: t,
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function ja(e, n, t) {
  const r = e.all(n), i = t ? Ra(t) : ar(n), a = {}, l = [];
  if (typeof n.checked == "boolean") {
    const f = r[0];
    let c;
    f && f.type === "element" && f.tagName === "p" ? c = f : (c = { type: "element", tagName: "p", properties: {}, children: [] }, r.unshift(c)), c.children.length > 0 && c.children.unshift({ type: "text", value: " " }), c.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: n.checked, disabled: !0 },
      children: []
    }), a.className = ["task-list-item"];
  }
  let o = -1;
  for (; ++o < r.length; ) {
    const f = r[o];
    (i || o !== 0 || f.type !== "element" || f.tagName !== "p") && l.push({ type: "text", value: `
` }), f.type === "element" && f.tagName === "p" && !i ? l.push(...f.children) : l.push(f);
  }
  const u = r[r.length - 1];
  u && (i || u.type !== "element" || u.tagName !== "p") && l.push({ type: "text", value: `
` });
  const s = { type: "element", tagName: "li", properties: a, children: l };
  return e.patch(n, s), e.applyData(n, s);
}
function Ra(e) {
  let n = !1;
  if (e.type === "list") {
    n = e.spread || !1;
    const t = e.children;
    let r = -1;
    for (; !n && ++r < t.length; )
      n = ar(t[r]);
  }
  return n;
}
function ar(e) {
  const n = e.spread;
  return n ?? e.children.length > 1;
}
function _a(e, n) {
  const t = {}, r = e.all(n);
  let i = -1;
  for (typeof n.start == "number" && n.start !== 1 && (t.start = n.start); ++i < r.length; ) {
    const l = r[i];
    if (l.type === "element" && l.tagName === "li" && l.properties && Array.isArray(l.properties.className) && l.properties.className.includes("task-list-item")) {
      t.className = ["contains-task-list"];
      break;
    }
  }
  const a = {
    type: "element",
    tagName: n.ordered ? "ol" : "ul",
    properties: t,
    children: e.wrap(r, !0)
  };
  return e.patch(n, a), e.applyData(n, a);
}
function Ba(e, n) {
  const t = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function Na(e, n) {
  const t = { type: "root", children: e.wrap(e.all(n)) };
  return e.patch(n, t), e.applyData(n, t);
}
function Ma(e, n) {
  const t = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function qa(e, n) {
  const t = e.all(n), r = t.shift(), i = [];
  if (r) {
    const l = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([r], !0)
    };
    e.patch(n.children[0], l), i.push(l);
  }
  if (t.length > 0) {
    const l = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(t, !0)
    }, o = Zr(n.children[1]), u = Jr(n.children[n.children.length - 1]);
    o && u && (l.position = { start: o, end: u }), i.push(l);
  }
  const a = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(i, !0)
  };
  return e.patch(n, a), e.applyData(n, a);
}
function Ha(e, n, t) {
  const r = t ? t.children : void 0, a = (r ? r.indexOf(n) : 1) === 0 ? "th" : "td", l = t && t.type === "table" ? t.align : void 0, o = l ? l.length : n.children.length;
  let u = -1;
  const s = [];
  for (; ++u < o; ) {
    const c = n.children[u], p = {}, h = l ? l[u] : void 0;
    h && (p.align = h);
    let d = { type: "element", tagName: a, properties: p, children: [] };
    c && (d.children = e.all(c), e.patch(c, d), d = e.applyData(c, d)), s.push(d);
  }
  const f = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(s, !0)
  };
  return e.patch(n, f), e.applyData(n, f);
}
function $a(e, n) {
  const t = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
const cn = 9, fn = 32;
function Va(e) {
  const n = String(e), t = /\r?\n|\r/g;
  let r = t.exec(n), i = 0;
  const a = [];
  for (; r; )
    a.push(
      hn(n.slice(i, r.index), i > 0, !0),
      r[0]
    ), i = r.index + r[0].length, r = t.exec(n);
  return a.push(hn(n.slice(i), i > 0, !1)), a.join("");
}
function hn(e, n, t) {
  let r = 0, i = e.length;
  if (n) {
    let a = e.codePointAt(r);
    for (; a === cn || a === fn; )
      r++, a = e.codePointAt(r);
  }
  if (t) {
    let a = e.codePointAt(i - 1);
    for (; a === cn || a === fn; )
      i--, a = e.codePointAt(i - 1);
  }
  return i > r ? e.slice(r, i) : "";
}
function Ua(e, n) {
  const t = { type: "text", value: Va(String(n.value)) };
  return e.patch(n, t), e.applyData(n, t);
}
function Wa(e, n) {
  const t = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(n, t), e.applyData(n, t);
}
const Qa = {
  blockquote: Ca,
  break: Sa,
  code: Ea,
  delete: Aa,
  emphasis: Ia,
  footnoteReference: Ta,
  heading: za,
  html: va,
  imageReference: Pa,
  image: Oa,
  inlineCode: Fa,
  linkReference: Da,
  link: La,
  listItem: ja,
  list: _a,
  paragraph: Ba,
  // @ts-expect-error: root is different, but hard to type.
  root: Na,
  strong: Ma,
  table: qa,
  tableCell: $a,
  tableRow: Ha,
  text: Ua,
  thematicBreak: Wa,
  toml: Ve,
  yaml: Ve,
  definition: Ve,
  footnoteDefinition: Ve
};
function Ve() {
}
const or = -1, at = 0, Me = 1, et = 2, Rt = 3, _t = 4, Bt = 5, Nt = 6, ur = 7, sr = 8, pn = typeof self == "object" ? self : globalThis, Ga = (e, n) => {
  const t = (i, a) => (e.set(a, i), i), r = (i) => {
    if (e.has(i))
      return e.get(i);
    const [a, l] = n[i];
    switch (a) {
      case at:
      case or:
        return t(l, i);
      case Me: {
        const o = t([], i);
        for (const u of l)
          o.push(r(u));
        return o;
      }
      case et: {
        const o = t({}, i);
        for (const [u, s] of l)
          o[r(u)] = r(s);
        return o;
      }
      case Rt:
        return t(new Date(l), i);
      case _t: {
        const { source: o, flags: u } = l;
        return t(new RegExp(o, u), i);
      }
      case Bt: {
        const o = t(/* @__PURE__ */ new Map(), i);
        for (const [u, s] of l)
          o.set(r(u), r(s));
        return o;
      }
      case Nt: {
        const o = t(/* @__PURE__ */ new Set(), i);
        for (const u of l)
          o.add(r(u));
        return o;
      }
      case ur: {
        const { name: o, message: u } = l;
        return t(new pn[o](u), i);
      }
      case sr:
        return t(BigInt(l), i);
      case "BigInt":
        return t(Object(BigInt(l)), i);
      case "ArrayBuffer":
        return t(new Uint8Array(l).buffer, l);
      case "DataView": {
        const { buffer: o } = new Uint8Array(l);
        return t(new DataView(o), l);
      }
    }
    return t(new pn[a](l), i);
  };
  return r;
}, mn = (e) => Ga(/* @__PURE__ */ new Map(), e)(0), Ae = "", { toString: Ya } = {}, { keys: Za } = Object, _e = (e) => {
  const n = typeof e;
  if (n !== "object" || !e)
    return [at, n];
  const t = Ya.call(e).slice(8, -1);
  switch (t) {
    case "Array":
      return [Me, Ae];
    case "Object":
      return [et, Ae];
    case "Date":
      return [Rt, Ae];
    case "RegExp":
      return [_t, Ae];
    case "Map":
      return [Bt, Ae];
    case "Set":
      return [Nt, Ae];
    case "DataView":
      return [Me, t];
  }
  return t.includes("Array") ? [Me, t] : t.includes("Error") ? [ur, t] : [et, t];
}, Ue = ([e, n]) => e === at && (n === "function" || n === "symbol"), Ja = (e, n, t, r) => {
  const i = (l, o) => {
    const u = r.push(l) - 1;
    return t.set(o, u), u;
  }, a = (l) => {
    if (t.has(l))
      return t.get(l);
    let [o, u] = _e(l);
    switch (o) {
      case at: {
        let f = l;
        switch (u) {
          case "bigint":
            o = sr, f = l.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + u);
            f = null;
            break;
          case "undefined":
            return i([or], l);
        }
        return i([o, f], l);
      }
      case Me: {
        if (u) {
          let p = l;
          return u === "DataView" ? p = new Uint8Array(l.buffer) : u === "ArrayBuffer" && (p = new Uint8Array(l)), i([u, [...p]], l);
        }
        const f = [], c = i([o, f], l);
        for (const p of l)
          f.push(a(p));
        return c;
      }
      case et: {
        if (u)
          switch (u) {
            case "BigInt":
              return i([u, l.toString()], l);
            case "Boolean":
            case "Number":
            case "String":
              return i([u, l.valueOf()], l);
          }
        if (n && "toJSON" in l)
          return a(l.toJSON());
        const f = [], c = i([o, f], l);
        for (const p of Za(l))
          (e || !Ue(_e(l[p]))) && f.push([a(p), a(l[p])]);
        return c;
      }
      case Rt:
        return i([o, l.toISOString()], l);
      case _t: {
        const { source: f, flags: c } = l;
        return i([o, { source: f, flags: c }], l);
      }
      case Bt: {
        const f = [], c = i([o, f], l);
        for (const [p, h] of l)
          (e || !(Ue(_e(p)) || Ue(_e(h)))) && f.push([a(p), a(h)]);
        return c;
      }
      case Nt: {
        const f = [], c = i([o, f], l);
        for (const p of l)
          (e || !Ue(_e(p))) && f.push(a(p));
        return c;
      }
    }
    const { message: s } = l;
    return i([o, { name: u, message: s }], l);
  };
  return a;
}, gn = (e, { json: n, lossy: t } = {}) => {
  const r = [];
  return Ja(!(n || t), !!n, /* @__PURE__ */ new Map(), r)(e), r;
}, tt = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, n) => n && ("json" in n || "lossy" in n) ? mn(gn(e, n)) : structuredClone(e)
) : (e, n) => mn(gn(e, n));
function Ka(e, n) {
  const t = [{ type: "text", value: "↩" }];
  return n > 1 && t.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(n) }]
  }), t;
}
function Xa(e, n) {
  return "Back to reference " + (e + 1) + (n > 1 ? "-" + n : "");
}
function eo(e) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", t = e.options.footnoteBackContent || Ka, r = e.options.footnoteBackLabel || Xa, i = e.options.footnoteLabel || "Footnotes", a = e.options.footnoteLabelTagName || "h2", l = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, o = [];
  let u = -1;
  for (; ++u < e.footnoteOrder.length; ) {
    const s = e.footnoteById.get(
      e.footnoteOrder[u]
    );
    if (!s)
      continue;
    const f = e.all(s), c = String(s.identifier).toUpperCase(), p = De(c.toLowerCase());
    let h = 0;
    const d = [], b = e.footnoteCounts.get(c);
    for (; b !== void 0 && ++h <= b; ) {
      d.length > 0 && d.push({ type: "text", value: " " });
      let E = typeof t == "string" ? t : t(u, h);
      typeof E == "string" && (E = { type: "text", value: E }), d.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + n + "fnref-" + p + (h > 1 ? "-" + h : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof r == "string" ? r : r(u, h),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(E) ? E : [E]
      });
    }
    const C = f[f.length - 1];
    if (C && C.type === "element" && C.tagName === "p") {
      const E = C.children[C.children.length - 1];
      E && E.type === "text" ? E.value += " " : C.children.push({ type: "text", value: " " }), C.children.push(...d);
    } else
      f.push(...d);
    const k = {
      type: "element",
      tagName: "li",
      properties: { id: n + "fn-" + p },
      children: e.wrap(f, !0)
    };
    e.patch(s, k), o.push(k);
  }
  if (o.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: a,
          properties: {
            ...tt(l),
            id: "footnote-label"
          },
          children: [{ type: "text", value: i }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(o, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const It = {}.hasOwnProperty, to = {};
function no(e, n) {
  const t = n || to, r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), l = { ...Qa, ...t.handlers }, o = {
    all: s,
    applyData: io,
    definitionById: r,
    footnoteById: i,
    footnoteCounts: a,
    footnoteOrder: [],
    handlers: l,
    one: u,
    options: t,
    patch: ro,
    wrap: ao
  };
  return Pt(e, function(f) {
    if (f.type === "definition" || f.type === "footnoteDefinition") {
      const c = f.type === "definition" ? r : i, p = String(f.identifier).toUpperCase();
      c.has(p) || c.set(p, f);
    }
  }), o;
  function u(f, c) {
    const p = f.type, h = o.handlers[p];
    if (It.call(o.handlers, p) && h)
      return h(o, f, c);
    if (o.options.passThrough && o.options.passThrough.includes(p)) {
      if ("children" in f) {
        const { children: b, ...C } = f, k = tt(C);
        return k.children = o.all(f), k;
      }
      return tt(f);
    }
    return (o.options.unknownHandler || lo)(o, f, c);
  }
  function s(f) {
    const c = [];
    if ("children" in f) {
      const p = f.children;
      let h = -1;
      for (; ++h < p.length; ) {
        const d = o.one(p[h], f);
        if (d) {
          if (h && p[h - 1].type === "break" && (!Array.isArray(d) && d.type === "text" && (d.value = dn(d.value)), !Array.isArray(d) && d.type === "element")) {
            const b = d.children[0];
            b && b.type === "text" && (b.value = dn(b.value));
          }
          Array.isArray(d) ? c.push(...d) : c.push(d);
        }
      }
    }
    return c;
  }
}
function ro(e, n) {
  e.position && (n.position = Kr(e));
}
function io(e, n) {
  let t = n;
  if (e && e.data) {
    const r = e.data.hName, i = e.data.hChildren, a = e.data.hProperties;
    if (typeof r == "string")
      if (t.type === "element")
        t.tagName = r;
      else {
        const l = "children" in t ? t.children : [t];
        t = { type: "element", tagName: r, properties: {}, children: l };
      }
    t.type === "element" && a && Object.assign(t.properties, tt(a)), "children" in t && t.children && i !== null && i !== void 0 && (t.children = i);
  }
  return t;
}
function lo(e, n) {
  const t = n.data || {}, r = "value" in n && !(It.call(t, "hProperties") || It.call(t, "hChildren")) ? { type: "text", value: n.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function ao(e, n) {
  const t = [];
  let r = -1;
  for (n && t.push({ type: "text", value: `
` }); ++r < e.length; )
    r && t.push({ type: "text", value: `
` }), t.push(e[r]);
  return n && e.length > 0 && t.push({ type: "text", value: `
` }), t;
}
function dn(e) {
  let n = 0, t = e.charCodeAt(n);
  for (; t === 9 || t === 32; )
    n++, t = e.charCodeAt(n);
  return e.slice(n);
}
function xn(e, n) {
  const t = no(e, n), r = t.one(e, void 0), i = eo(t), a = Array.isArray(r) ? { type: "root", children: r } : r || { type: "root", children: [] };
  return i && a.children.push({ type: "text", value: `
` }, i), a;
}
function oo(e, n) {
  return e && "run" in e ? async function(t, r) {
    const i = (
      /** @type {HastRoot} */
      xn(t, { file: r, ...n })
    );
    await e.run(i, r);
  } : function(t, r) {
    return (
      /** @type {HastRoot} */
      xn(t, { file: r, ...e || n })
    );
  };
}
function kn(e) {
  if (e)
    throw e;
}
var ht, bn;
function uo() {
  if (bn) return ht;
  bn = 1;
  var e = Object.prototype.hasOwnProperty, n = Object.prototype.toString, t = Object.defineProperty, r = Object.getOwnPropertyDescriptor, i = function(s) {
    return typeof Array.isArray == "function" ? Array.isArray(s) : n.call(s) === "[object Array]";
  }, a = function(s) {
    if (!s || n.call(s) !== "[object Object]")
      return !1;
    var f = e.call(s, "constructor"), c = s.constructor && s.constructor.prototype && e.call(s.constructor.prototype, "isPrototypeOf");
    if (s.constructor && !f && !c)
      return !1;
    var p;
    for (p in s)
      ;
    return typeof p > "u" || e.call(s, p);
  }, l = function(s, f) {
    t && f.name === "__proto__" ? t(s, f.name, {
      enumerable: !0,
      configurable: !0,
      value: f.newValue,
      writable: !0
    }) : s[f.name] = f.newValue;
  }, o = function(s, f) {
    if (f === "__proto__")
      if (e.call(s, f)) {
        if (r)
          return r(s, f).value;
      } else return;
    return s[f];
  };
  return ht = function u() {
    var s, f, c, p, h, d, b = arguments[0], C = 1, k = arguments.length, E = !1;
    for (typeof b == "boolean" && (E = b, b = arguments[1] || {}, C = 2), (b == null || typeof b != "object" && typeof b != "function") && (b = {}); C < k; ++C)
      if (s = arguments[C], s != null)
        for (f in s)
          c = o(b, f), p = o(s, f), b !== p && (E && p && (a(p) || (h = i(p))) ? (h ? (h = !1, d = c && i(c) ? c : []) : d = c && a(c) ? c : {}, l(b, { name: f, newValue: u(E, d, p) })) : typeof p < "u" && l(b, { name: f, newValue: p }));
    return b;
  }, ht;
}
var so = uo();
const pt = /* @__PURE__ */ ki(so);
function Tt(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function co() {
  const e = [], n = { run: t, use: r };
  return n;
  function t(...i) {
    let a = -1;
    const l = i.pop();
    if (typeof l != "function")
      throw new TypeError("Expected function as last argument, not " + l);
    o(null, ...i);
    function o(u, ...s) {
      const f = e[++a];
      let c = -1;
      if (u) {
        l(u);
        return;
      }
      for (; ++c < i.length; )
        (s[c] === null || s[c] === void 0) && (s[c] = i[c]);
      i = s, f ? fo(f, o)(...s) : l(null, ...s);
    }
  }
  function r(i) {
    if (typeof i != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + i
      );
    return e.push(i), n;
  }
}
function fo(e, n) {
  let t;
  return r;
  function r(...l) {
    const o = e.length > l.length;
    let u;
    o && l.push(i);
    try {
      u = e.apply(this, l);
    } catch (s) {
      const f = (
        /** @type {Error} */
        s
      );
      if (o && t)
        throw f;
      return i(f);
    }
    o || (u && u.then && typeof u.then == "function" ? u.then(a, i) : u instanceof Error ? i(u) : a(u));
  }
  function i(l, ...o) {
    t || (t = !0, n(l, ...o));
  }
  function a(l) {
    i(null, l);
  }
}
const re = { basename: ho, dirname: po, extname: mo, join: go, sep: "/" };
function ho(e, n) {
  if (n !== void 0 && typeof n != "string")
    throw new TypeError('"ext" argument must be a string');
  He(e);
  let t = 0, r = -1, i = e.length, a;
  if (n === void 0 || n.length === 0 || n.length > e.length) {
    for (; i--; )
      if (e.codePointAt(i) === 47) {
        if (a) {
          t = i + 1;
          break;
        }
      } else r < 0 && (a = !0, r = i + 1);
    return r < 0 ? "" : e.slice(t, r);
  }
  if (n === e)
    return "";
  let l = -1, o = n.length - 1;
  for (; i--; )
    if (e.codePointAt(i) === 47) {
      if (a) {
        t = i + 1;
        break;
      }
    } else
      l < 0 && (a = !0, l = i + 1), o > -1 && (e.codePointAt(i) === n.codePointAt(o--) ? o < 0 && (r = i) : (o = -1, r = l));
  return t === r ? r = l : r < 0 && (r = e.length), e.slice(t, r);
}
function po(e) {
  if (He(e), e.length === 0)
    return ".";
  let n = -1, t = e.length, r;
  for (; --t; )
    if (e.codePointAt(t) === 47) {
      if (r) {
        n = t;
        break;
      }
    } else r || (r = !0);
  return n < 0 ? e.codePointAt(0) === 47 ? "/" : "." : n === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, n);
}
function mo(e) {
  He(e);
  let n = e.length, t = -1, r = 0, i = -1, a = 0, l;
  for (; n--; ) {
    const o = e.codePointAt(n);
    if (o === 47) {
      if (l) {
        r = n + 1;
        break;
      }
      continue;
    }
    t < 0 && (l = !0, t = n + 1), o === 46 ? i < 0 ? i = n : a !== 1 && (a = 1) : i > -1 && (a = -1);
  }
  return i < 0 || t < 0 || // We saw a non-dot character immediately before the dot.
  a === 0 || // The (right-most) trimmed path component is exactly `..`.
  a === 1 && i === t - 1 && i === r + 1 ? "" : e.slice(i, t);
}
function go(...e) {
  let n = -1, t;
  for (; ++n < e.length; )
    He(e[n]), e[n] && (t = t === void 0 ? e[n] : t + "/" + e[n]);
  return t === void 0 ? "." : xo(t);
}
function xo(e) {
  He(e);
  const n = e.codePointAt(0) === 47;
  let t = ko(e, !n);
  return t.length === 0 && !n && (t = "."), t.length > 0 && e.codePointAt(e.length - 1) === 47 && (t += "/"), n ? "/" + t : t;
}
function ko(e, n) {
  let t = "", r = 0, i = -1, a = 0, l = -1, o, u;
  for (; ++l <= e.length; ) {
    if (l < e.length)
      o = e.codePointAt(l);
    else {
      if (o === 47)
        break;
      o = 47;
    }
    if (o === 47) {
      if (!(i === l - 1 || a === 1)) if (i !== l - 1 && a === 2) {
        if (t.length < 2 || r !== 2 || t.codePointAt(t.length - 1) !== 46 || t.codePointAt(t.length - 2) !== 46) {
          if (t.length > 2) {
            if (u = t.lastIndexOf("/"), u !== t.length - 1) {
              u < 0 ? (t = "", r = 0) : (t = t.slice(0, u), r = t.length - 1 - t.lastIndexOf("/")), i = l, a = 0;
              continue;
            }
          } else if (t.length > 0) {
            t = "", r = 0, i = l, a = 0;
            continue;
          }
        }
        n && (t = t.length > 0 ? t + "/.." : "..", r = 2);
      } else
        t.length > 0 ? t += "/" + e.slice(i + 1, l) : t = e.slice(i + 1, l), r = l - i - 1;
      i = l, a = 0;
    } else o === 46 && a > -1 ? a++ : a = -1;
  }
  return t;
}
function He(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const bo = { cwd: yo };
function yo() {
  return "/";
}
function zt(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function wo(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!zt(e)) {
    const n = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw n.code = "ERR_INVALID_ARG_TYPE", n;
  }
  if (e.protocol !== "file:") {
    const n = new TypeError("The URL must be of scheme file");
    throw n.code = "ERR_INVALID_URL_SCHEME", n;
  }
  return Co(e);
}
function Co(e) {
  if (e.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const n = e.pathname;
  let t = -1;
  for (; ++t < n.length; )
    if (n.codePointAt(t) === 37 && n.codePointAt(t + 1) === 50) {
      const r = n.codePointAt(t + 2);
      if (r === 70 || r === 102) {
        const i = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw i.code = "ERR_INVALID_FILE_URL_PATH", i;
      }
    }
  return decodeURIComponent(n);
}
const mt = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class cr {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(n) {
    let t;
    n ? zt(n) ? t = { path: n } : typeof n == "string" || So(n) ? t = { value: n } : t = n : t = {}, this.cwd = "cwd" in t ? "" : bo.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let r = -1;
    for (; ++r < mt.length; ) {
      const a = mt[r];
      a in t && t[a] !== void 0 && t[a] !== null && (this[a] = a === "history" ? [...t[a]] : t[a]);
    }
    let i;
    for (i in t)
      mt.includes(i) || (this[i] = t[i]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? re.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(n) {
    dt(n, "basename"), gt(n, "basename"), this.path = re.join(this.dirname || "", n);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? re.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(n) {
    yn(this.basename, "dirname"), this.path = re.join(n || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? re.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(n) {
    if (gt(n, "extname"), yn(this.dirname, "extname"), n) {
      if (n.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (n.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = re.join(this.dirname, this.stem + (n || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(n) {
    zt(n) && (n = wo(n)), dt(n, "path"), this.path !== n && this.history.push(n);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? re.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(n) {
    dt(n, "stem"), gt(n, "stem"), this.path = re.join(this.dirname || "", n + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(n, t, r) {
    const i = this.message(n, t, r);
    throw i.fatal = !0, i;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(n, t, r) {
    const i = this.message(n, t, r);
    return i.fatal = void 0, i;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(n, t, r) {
    const i = new Xr(
      // @ts-expect-error: the overloads are fine.
      n,
      t,
      r
    );
    return this.path && (i.name = this.path + ":" + i.name, i.file = this.path), i.fatal = !1, this.messages.push(i), i;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(n) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(n || void 0).decode(this.value);
  }
}
function gt(e, n) {
  if (e && e.includes(re.sep))
    throw new Error(
      "`" + n + "` cannot be a path: did not expect `" + re.sep + "`"
    );
}
function dt(e, n) {
  if (!e)
    throw new Error("`" + n + "` cannot be empty");
}
function yn(e, n) {
  if (!e)
    throw new Error("Setting `" + n + "` requires `path` to be set too");
}
function So(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const Eo = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  function(e) {
    const r = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), i = r[e], a = function() {
      return i.apply(a, arguments);
    };
    return Object.setPrototypeOf(a, r), a;
  }
), Ao = {}.hasOwnProperty;
class Mt extends Eo {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = co();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const n = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new Mt()
    );
    let t = -1;
    for (; ++t < this.attachers.length; ) {
      const r = this.attachers[t];
      n.use(...r);
    }
    return n.data(pt(!0, {}, this.namespace)), n;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(n, t) {
    return typeof n == "string" ? arguments.length === 2 ? (bt("data", this.frozen), this.namespace[n] = t, this) : Ao.call(this.namespace, n) && this.namespace[n] || void 0 : n ? (bt("data", this.frozen), this.namespace = n, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const n = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [t, ...r] = this.attachers[this.freezeIndex];
      if (r[0] === !1)
        continue;
      r[0] === !0 && (r[0] = void 0);
      const i = t.call(n, ...r);
      typeof i == "function" && this.transformers.use(i);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(n) {
    this.freeze();
    const t = We(n), r = this.parser || this.Parser;
    return xt("parse", r), r(String(t), t);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(n, t) {
    const r = this;
    return this.freeze(), xt("process", this.parser || this.Parser), kt("process", this.compiler || this.Compiler), t ? i(void 0, t) : new Promise(i);
    function i(a, l) {
      const o = We(n), u = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        r.parse(o)
      );
      r.run(u, o, function(f, c, p) {
        if (f || !c || !p)
          return s(f);
        const h = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          c
        ), d = r.stringify(h, p);
        zo(d) ? p.value = d : p.result = d, s(
          f,
          /** @type {VFileWithOutput<CompileResult>} */
          p
        );
      });
      function s(f, c) {
        f || !c ? l(f) : a ? a(c) : t(void 0, c);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(n) {
    let t = !1, r;
    return this.freeze(), xt("processSync", this.parser || this.Parser), kt("processSync", this.compiler || this.Compiler), this.process(n, i), Cn("processSync", "process", t), r;
    function i(a, l) {
      t = !0, kn(a), r = l;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(n, t, r) {
    wn(n), this.freeze();
    const i = this.transformers;
    return !r && typeof t == "function" && (r = t, t = void 0), r ? a(void 0, r) : new Promise(a);
    function a(l, o) {
      const u = We(t);
      i.run(n, u, s);
      function s(f, c, p) {
        const h = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          c || n
        );
        f ? o(f) : l ? l(h) : r(void 0, h, p);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(n, t) {
    let r = !1, i;
    return this.run(n, t, a), Cn("runSync", "run", r), i;
    function a(l, o) {
      kn(l), i = o, r = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(n, t) {
    this.freeze();
    const r = We(t), i = this.compiler || this.Compiler;
    return kt("stringify", i), wn(n), i(n, r);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(n, ...t) {
    const r = this.attachers, i = this.namespace;
    if (bt("use", this.frozen), n != null) if (typeof n == "function")
      u(n, t);
    else if (typeof n == "object")
      Array.isArray(n) ? o(n) : l(n);
    else
      throw new TypeError("Expected usable value, not `" + n + "`");
    return this;
    function a(s) {
      if (typeof s == "function")
        u(s, []);
      else if (typeof s == "object")
        if (Array.isArray(s)) {
          const [f, ...c] = (
            /** @type {PluginTuple<Array<unknown>>} */
            s
          );
          u(f, c);
        } else
          l(s);
      else
        throw new TypeError("Expected usable value, not `" + s + "`");
    }
    function l(s) {
      if (!("plugins" in s) && !("settings" in s))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      o(s.plugins), s.settings && (i.settings = pt(!0, i.settings, s.settings));
    }
    function o(s) {
      let f = -1;
      if (s != null) if (Array.isArray(s))
        for (; ++f < s.length; ) {
          const c = s[f];
          a(c);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + s + "`");
    }
    function u(s, f) {
      let c = -1, p = -1;
      for (; ++c < r.length; )
        if (r[c][0] === s) {
          p = c;
          break;
        }
      if (p === -1)
        r.push([s, ...f]);
      else if (f.length > 0) {
        let [h, ...d] = f;
        const b = r[p][1];
        Tt(b) && Tt(h) && (h = pt(!0, b, h)), r[p] = [s, h, ...d];
      }
    }
  }
}
const Io = new Mt().freeze();
function xt(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function kt(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function bt(e, n) {
  if (n)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function wn(e) {
  if (!Tt(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function Cn(e, n, t) {
  if (!t)
    throw new Error(
      "`" + e + "` finished async. Use `" + n + "` instead"
    );
}
function We(e) {
  return To(e) ? e : new cr(e);
}
function To(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function zo(e) {
  return typeof e == "string" || vo(e);
}
function vo(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const Po = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", Sn = [], En = { allowDangerousHtml: !0 }, Oo = /^(https?|ircs?|mailto|xmpp)$/i, Fo = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  { from: "className", id: "remove-classname" },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function Do(e) {
  const n = Lo(e), [t, r] = Pe(
    /** @type {Error | undefined} */
    void 0
  ), [i, a] = Pe(
    /** @type {Root | undefined} */
    void 0
  );
  if (ye(
    function() {
      let l = !1;
      const o = jo(e);
      return n.run(n.parse(o), o, function(u, s) {
        l || (r(u), a(s));
      }), function() {
        l = !0;
      };
    },
    [
      e.children,
      e.rehypePlugins,
      e.remarkPlugins,
      e.remarkRehypeOptions
    ]
  ), t) throw t;
  return i ? Ro(i, e) : e.fallback;
}
function Lo(e) {
  const n = e.rehypePlugins || Sn, t = e.remarkPlugins || Sn, r = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...En } : En;
  return Io().use(wa).use(t).use(oo, r).use(n);
}
function jo(e) {
  const n = e.children || "", t = new cr();
  return typeof n == "string" && (t.value = n), t;
}
function Ro(e, n) {
  const t = n.allowedElements, r = n.allowElement, i = n.components, a = n.disallowedElements, l = n.skipHtml, o = n.unwrapDisallowed, u = n.urlTransform || _o;
  for (const f of Fo)
    Object.hasOwn(n, f.from) && ei(
      "Unexpected `" + f.from + "` prop, " + (f.to ? "use `" + f.to + "` instead" : "remove it") + " (see <" + Po + "#" + f.id + "> for more info)"
    );
  return Pt(e, s), ti(e, {
    Fragment: I.Fragment,
    components: i,
    ignoreInvalidStyle: !0,
    jsx: I.jsx,
    jsxs: I.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function s(f, c, p) {
    if (f.type === "raw" && p && typeof c == "number")
      return l ? p.children.splice(c, 1) : p.children[c] = { type: "text", value: f.value }, c;
    if (f.type === "element") {
      let h;
      for (h in st)
        if (Object.hasOwn(st, h) && Object.hasOwn(f.properties, h)) {
          const d = f.properties[h], b = st[h];
          (b === null || b.includes(f.tagName)) && (f.properties[h] = u(String(d || ""), h, f));
        }
    }
    if (f.type === "element") {
      let h = t ? !t.includes(f.tagName) : a ? a.includes(f.tagName) : !1;
      if (!h && r && typeof c == "number" && (h = !r(f, c, p)), h && p && typeof c == "number")
        return o && f.children ? p.children.splice(c, 1, ...f.children) : p.children.splice(c, 1), c;
    }
  }
}
function _o(e) {
  const n = e.indexOf(":"), t = e.indexOf("?"), r = e.indexOf("#"), i = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    n === -1 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    i !== -1 && n > i || t !== -1 && n > t || r !== -1 && n > r || // It is a protocol, it should be allowed.
    Oo.test(e.slice(0, n)) ? e : ""
  );
}
function Bo(e, n, t) {
  const i = $n((t || {}).ignore || []), a = No(n);
  let l = -1;
  for (; ++l < a.length; )
    ni(e, "text", o);
  function o(s, f) {
    let c = -1, p;
    for (; ++c < f.length; ) {
      const h = f[c], d = p ? p.children : void 0;
      if (i(
        h,
        d ? d.indexOf(h) : void 0,
        p
      ))
        return;
      p = h;
    }
    if (p)
      return u(s, f);
  }
  function u(s, f) {
    const c = f[f.length - 1], p = a[l][0], h = a[l][1];
    let d = 0;
    const C = c.children.indexOf(s);
    let k = !1, E = [];
    p.lastIndex = 0;
    let S = p.exec(s.value);
    for (; S; ) {
      const O = S.index, F = {
        index: S.index,
        input: S.input,
        stack: [...f, s]
      };
      let w = h(...S, F);
      if (typeof w == "string" && (w = w.length > 0 ? { type: "text", value: w } : void 0), w === !1 ? p.lastIndex = O + 1 : (d !== O && E.push({
        type: "text",
        value: s.value.slice(d, O)
      }), Array.isArray(w) ? E.push(...w) : w && E.push(w), d = O + S[0].length, k = !0), !p.global)
        break;
      S = p.exec(s.value);
    }
    return k ? (d < s.value.length && E.push({ type: "text", value: s.value.slice(d) }), c.children.splice(C, 1, ...E)) : E = [s], C + E.length;
  }
}
function No(e) {
  const n = [];
  if (!Array.isArray(e))
    throw new TypeError("Expected find and replace tuple or list of tuples");
  const t = !e[0] || Array.isArray(e[0]) ? e : [e];
  let r = -1;
  for (; ++r < t.length; ) {
    const i = t[r];
    n.push([Mo(i[0]), qo(i[1])]);
  }
  return n;
}
function Mo(e) {
  return typeof e == "string" ? new RegExp(bi(e), "g") : e;
}
function qo(e) {
  return typeof e == "function" ? e : function() {
    return e;
  };
}
const yt = "phrasing", wt = ["autolink", "link", "image", "label"];
function Ho() {
  return {
    transforms: [Yo],
    enter: {
      literalAutolink: Vo,
      literalAutolinkEmail: Ct,
      literalAutolinkHttp: Ct,
      literalAutolinkWww: Ct
    },
    exit: {
      literalAutolink: Go,
      literalAutolinkEmail: Qo,
      literalAutolinkHttp: Uo,
      literalAutolinkWww: Wo
    }
  };
}
function $o() {
  return {
    unsafe: [
      {
        character: "@",
        before: "[+\\-.\\w]",
        after: "[\\-.\\w]",
        inConstruct: yt,
        notInConstruct: wt
      },
      {
        character: ".",
        before: "[Ww]",
        after: "[\\-.\\w]",
        inConstruct: yt,
        notInConstruct: wt
      },
      {
        character: ":",
        before: "[ps]",
        after: "\\/",
        inConstruct: yt,
        notInConstruct: wt
      }
    ]
  };
}
function Vo(e) {
  this.enter({ type: "link", title: null, url: "", children: [] }, e);
}
function Ct(e) {
  this.config.enter.autolinkProtocol.call(this, e);
}
function Uo(e) {
  this.config.exit.autolinkProtocol.call(this, e);
}
function Wo(e) {
  this.config.exit.data.call(this, e);
  const n = this.stack[this.stack.length - 1];
  Fe(n.type === "link"), n.url = "http://" + this.sliceSerialize(e);
}
function Qo(e) {
  this.config.exit.autolinkEmail.call(this, e);
}
function Go(e) {
  this.exit(e);
}
function Yo(e) {
  Bo(
    e,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, Zo],
      [/(?<=^|\s|\p{P}|\p{S})([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/gu, Jo]
    ],
    { ignore: ["link", "linkReference"] }
  );
}
function Zo(e, n, t, r, i) {
  let a = "";
  if (!fr(i) || (/^w/i.test(n) && (t = n + t, n = "", a = "http://"), !Ko(t)))
    return !1;
  const l = Xo(t + r);
  if (!l[0]) return !1;
  const o = {
    type: "link",
    title: null,
    url: a + n + l[0],
    children: [{ type: "text", value: n + l[0] }]
  };
  return l[1] ? [o, { type: "text", value: l[1] }] : o;
}
function Jo(e, n, t, r) {
  return (
    // Not an expected previous character.
    !fr(r, !0) || // Label ends in not allowed character.
    /[-\d_]$/.test(t) ? !1 : {
      type: "link",
      title: null,
      url: "mailto:" + n + "@" + t,
      children: [{ type: "text", value: n + "@" + t }]
    }
  );
}
function Ko(e) {
  const n = e.split(".");
  return !(n.length < 2 || n[n.length - 1] && (/_/.test(n[n.length - 1]) || !/[a-zA-Z\d]/.test(n[n.length - 1])) || n[n.length - 2] && (/_/.test(n[n.length - 2]) || !/[a-zA-Z\d]/.test(n[n.length - 2])));
}
function Xo(e) {
  const n = /[!"&'),.:;<>?\]}]+$/.exec(e);
  if (!n)
    return [e, void 0];
  e = e.slice(0, n.index);
  let t = n[0], r = t.indexOf(")");
  const i = Jt(e, "(");
  let a = Jt(e, ")");
  for (; r !== -1 && i > a; )
    e += t.slice(0, r + 1), t = t.slice(r + 1), r = t.indexOf(")"), a++;
  return [e, t];
}
function fr(e, n) {
  const t = e.input.charCodeAt(e.index - 1);
  return (e.index === 0 || we(t) || it(t)) && // If it’s an email, the previous character should not be a slash.
  (!n || t !== 47);
}
function $e(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
hr.peek = uu;
function eu() {
  this.buffer();
}
function tu(e) {
  this.enter({ type: "footnoteReference", identifier: "", label: "" }, e);
}
function nu() {
  this.buffer();
}
function ru(e) {
  this.enter(
    { type: "footnoteDefinition", identifier: "", label: "", children: [] },
    e
  );
}
function iu(e) {
  const n = this.resume(), t = this.stack[this.stack.length - 1];
  Fe(t.type === "footnoteReference"), t.identifier = $e(
    this.sliceSerialize(e)
  ).toLowerCase(), t.label = n;
}
function lu(e) {
  this.exit(e);
}
function au(e) {
  const n = this.resume(), t = this.stack[this.stack.length - 1];
  Fe(t.type === "footnoteDefinition"), t.identifier = $e(
    this.sliceSerialize(e)
  ).toLowerCase(), t.label = n;
}
function ou(e) {
  this.exit(e);
}
function uu() {
  return "[";
}
function hr(e, n, t, r) {
  const i = t.createTracker(r);
  let a = i.move("[^");
  const l = t.enter("footnoteReference"), o = t.enter("reference");
  return a += i.move(
    t.safe(t.associationId(e), { after: "]", before: a })
  ), o(), l(), a += i.move("]"), a;
}
function su() {
  return {
    enter: {
      gfmFootnoteCallString: eu,
      gfmFootnoteCall: tu,
      gfmFootnoteDefinitionLabelString: nu,
      gfmFootnoteDefinition: ru
    },
    exit: {
      gfmFootnoteCallString: iu,
      gfmFootnoteCall: lu,
      gfmFootnoteDefinitionLabelString: au,
      gfmFootnoteDefinition: ou
    }
  };
}
function cu(e) {
  let n = !1;
  return e && e.firstLineBlank && (n = !0), {
    handlers: { footnoteDefinition: t, footnoteReference: hr },
    // This is on by default already.
    unsafe: [{ character: "[", inConstruct: ["label", "phrasing", "reference"] }]
  };
  function t(r, i, a, l) {
    const o = a.createTracker(l);
    let u = o.move("[^");
    const s = a.enter("footnoteDefinition"), f = a.enter("label");
    return u += o.move(
      a.safe(a.associationId(r), { before: u, after: "]" })
    ), f(), u += o.move("]:"), r.children && r.children.length > 0 && (o.shift(4), u += o.move(
      (n ? `
` : " ") + a.indentLines(
        a.containerFlow(r, o.current()),
        n ? pr : fu
      )
    )), s(), u;
  }
}
function fu(e, n, t) {
  return n === 0 ? e : pr(e, n, t);
}
function pr(e, n, t) {
  return (t ? "" : "    ") + e;
}
const hu = [
  "autolink",
  "destinationLiteral",
  "destinationRaw",
  "reference",
  "titleQuote",
  "titleApostrophe"
];
mr.peek = xu;
function pu() {
  return {
    canContainEols: ["delete"],
    enter: { strikethrough: gu },
    exit: { strikethrough: du }
  };
}
function mu() {
  return {
    unsafe: [
      {
        character: "~",
        inConstruct: "phrasing",
        notInConstruct: hu
      }
    ],
    handlers: { delete: mr }
  };
}
function gu(e) {
  this.enter({ type: "delete", children: [] }, e);
}
function du(e) {
  this.exit(e);
}
function mr(e, n, t, r) {
  const i = t.createTracker(r), a = t.enter("strikethrough");
  let l = i.move("~~");
  return l += t.containerPhrasing(e, {
    ...i.current(),
    before: l,
    after: "~"
  }), l += i.move("~~"), a(), l;
}
function xu() {
  return "~";
}
function ku(e) {
  return e.length;
}
function bu(e, n) {
  const t = n || {}, r = (t.align || []).concat(), i = t.stringLength || ku, a = [], l = [], o = [], u = [];
  let s = 0, f = -1;
  for (; ++f < e.length; ) {
    const b = [], C = [];
    let k = -1;
    for (e[f].length > s && (s = e[f].length); ++k < e[f].length; ) {
      const E = yu(e[f][k]);
      if (t.alignDelimiters !== !1) {
        const S = i(E);
        C[k] = S, (u[k] === void 0 || S > u[k]) && (u[k] = S);
      }
      b.push(E);
    }
    l[f] = b, o[f] = C;
  }
  let c = -1;
  if (typeof r == "object" && "length" in r)
    for (; ++c < s; )
      a[c] = An(r[c]);
  else {
    const b = An(r);
    for (; ++c < s; )
      a[c] = b;
  }
  c = -1;
  const p = [], h = [];
  for (; ++c < s; ) {
    const b = a[c];
    let C = "", k = "";
    b === 99 ? (C = ":", k = ":") : b === 108 ? C = ":" : b === 114 && (k = ":");
    let E = t.alignDelimiters === !1 ? 1 : Math.max(
      1,
      u[c] - C.length - k.length
    );
    const S = C + "-".repeat(E) + k;
    t.alignDelimiters !== !1 && (E = C.length + E + k.length, E > u[c] && (u[c] = E), h[c] = E), p[c] = S;
  }
  l.splice(1, 0, p), o.splice(1, 0, h), f = -1;
  const d = [];
  for (; ++f < l.length; ) {
    const b = l[f], C = o[f];
    c = -1;
    const k = [];
    for (; ++c < s; ) {
      const E = b[c] || "";
      let S = "", O = "";
      if (t.alignDelimiters !== !1) {
        const F = u[c] - (C[c] || 0), w = a[c];
        w === 114 ? S = " ".repeat(F) : w === 99 ? F % 2 ? (S = " ".repeat(F / 2 + 0.5), O = " ".repeat(F / 2 - 0.5)) : (S = " ".repeat(F / 2), O = S) : O = " ".repeat(F);
      }
      t.delimiterStart !== !1 && !c && k.push("|"), t.padding !== !1 && // Don’t add the opening space if we’re not aligning and the cell is
      // empty: there will be a closing space.
      !(t.alignDelimiters === !1 && E === "") && (t.delimiterStart !== !1 || c) && k.push(" "), t.alignDelimiters !== !1 && k.push(S), k.push(E), t.alignDelimiters !== !1 && k.push(O), t.padding !== !1 && k.push(" "), (t.delimiterEnd !== !1 || c !== s - 1) && k.push("|");
    }
    d.push(
      t.delimiterEnd === !1 ? k.join("").replace(/ +$/, "") : k.join("")
    );
  }
  return d.join(`
`);
}
function yu(e) {
  return e == null ? "" : String(e);
}
function An(e) {
  const n = typeof e == "string" ? e.codePointAt(0) : 0;
  return n === 67 || n === 99 ? 99 : n === 76 || n === 108 ? 108 : n === 82 || n === 114 ? 114 : 0;
}
function wu(e, n, t, r) {
  const i = t.enter("blockquote"), a = t.createTracker(r);
  a.move("> "), a.shift(2);
  const l = t.indentLines(
    t.containerFlow(e, a.current()),
    Cu
  );
  return i(), l;
}
function Cu(e, n, t) {
  return ">" + (t ? "" : " ") + e;
}
function Su(e, n) {
  return In(e, n.inConstruct, !0) && !In(e, n.notInConstruct, !1);
}
function In(e, n, t) {
  if (typeof n == "string" && (n = [n]), !n || n.length === 0)
    return t;
  let r = -1;
  for (; ++r < n.length; )
    if (e.includes(n[r]))
      return !0;
  return !1;
}
function Tn(e, n, t, r) {
  let i = -1;
  for (; ++i < t.unsafe.length; )
    if (t.unsafe[i].character === `
` && Su(t.stack, t.unsafe[i]))
      return /[ \t]/.test(r.before) ? "" : " ";
  return `\\
`;
}
function Eu(e, n) {
  const t = String(e);
  let r = t.indexOf(n), i = r, a = 0, l = 0;
  if (typeof n != "string")
    throw new TypeError("Expected substring");
  for (; r !== -1; )
    r === i ? ++a > l && (l = a) : a = 1, i = r + n.length, r = t.indexOf(n, i);
  return l;
}
function Au(e, n) {
  return !!(n.options.fences === !1 && e.value && // If there’s no info…
  !e.lang && // And there’s a non-whitespace character…
  /[^ \r\n]/.test(e.value) && // And the value doesn’t start or end in a blank…
  !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(e.value));
}
function Iu(e) {
  const n = e.options.fence || "`";
  if (n !== "`" && n !== "~")
    throw new Error(
      "Cannot serialize code with `" + n + "` for `options.fence`, expected `` ` `` or `~`"
    );
  return n;
}
function Tu(e, n, t, r) {
  const i = Iu(t), a = e.value || "", l = i === "`" ? "GraveAccent" : "Tilde";
  if (Au(e, t)) {
    const c = t.enter("codeIndented"), p = t.indentLines(a, zu);
    return c(), p;
  }
  const o = t.createTracker(r), u = i.repeat(Math.max(Eu(a, i) + 1, 3)), s = t.enter("codeFenced");
  let f = o.move(u);
  if (e.lang) {
    const c = t.enter(`codeFencedLang${l}`);
    f += o.move(
      t.safe(e.lang, {
        before: f,
        after: " ",
        encode: ["`"],
        ...o.current()
      })
    ), c();
  }
  if (e.lang && e.meta) {
    const c = t.enter(`codeFencedMeta${l}`);
    f += o.move(" "), f += o.move(
      t.safe(e.meta, {
        before: f,
        after: `
`,
        encode: ["`"],
        ...o.current()
      })
    ), c();
  }
  return f += o.move(`
`), a && (f += o.move(a + `
`)), f += o.move(u), s(), f;
}
function zu(e, n, t) {
  return (t ? "" : "    ") + e;
}
function qt(e) {
  const n = e.options.quote || '"';
  if (n !== '"' && n !== "'")
    throw new Error(
      "Cannot serialize title with `" + n + "` for `options.quote`, expected `\"`, or `'`"
    );
  return n;
}
function vu(e, n, t, r) {
  const i = qt(t), a = i === '"' ? "Quote" : "Apostrophe", l = t.enter("definition");
  let o = t.enter("label");
  const u = t.createTracker(r);
  let s = u.move("[");
  return s += u.move(
    t.safe(t.associationId(e), {
      before: s,
      after: "]",
      ...u.current()
    })
  ), s += u.move("]: "), o(), // If there’s no url, or…
  !e.url || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (o = t.enter("destinationLiteral"), s += u.move("<"), s += u.move(
    t.safe(e.url, { before: s, after: ">", ...u.current() })
  ), s += u.move(">")) : (o = t.enter("destinationRaw"), s += u.move(
    t.safe(e.url, {
      before: s,
      after: e.title ? " " : `
`,
      ...u.current()
    })
  )), o(), e.title && (o = t.enter(`title${a}`), s += u.move(" " + i), s += u.move(
    t.safe(e.title, {
      before: s,
      after: i,
      ...u.current()
    })
  ), s += u.move(i), o()), l(), s;
}
function Pu(e) {
  const n = e.options.emphasis || "*";
  if (n !== "*" && n !== "_")
    throw new Error(
      "Cannot serialize emphasis with `" + n + "` for `options.emphasis`, expected `*`, or `_`"
    );
  return n;
}
function qe(e) {
  return "&#x" + e.toString(16).toUpperCase() + ";";
}
function nt(e, n, t) {
  const r = Oe(e), i = Oe(n);
  return r === void 0 ? i === void 0 ? (
    // Letter inside:
    // we have to encode *both* letters for `_` as it is looser.
    // it already forms for `*` (and GFMs `~`).
    t === "_" ? { inside: !0, outside: !0 } : { inside: !1, outside: !1 }
  ) : i === 1 ? (
    // Whitespace inside: encode both (letter, whitespace).
    { inside: !0, outside: !0 }
  ) : (
    // Punctuation inside: encode outer (letter)
    { inside: !1, outside: !0 }
  ) : r === 1 ? i === void 0 ? (
    // Letter inside: already forms.
    { inside: !1, outside: !1 }
  ) : i === 1 ? (
    // Whitespace inside: encode both (whitespace).
    { inside: !0, outside: !0 }
  ) : (
    // Punctuation inside: already forms.
    { inside: !1, outside: !1 }
  ) : i === void 0 ? (
    // Letter inside: already forms.
    { inside: !1, outside: !1 }
  ) : i === 1 ? (
    // Whitespace inside: encode inner (whitespace).
    { inside: !0, outside: !1 }
  ) : (
    // Punctuation inside: already forms.
    { inside: !1, outside: !1 }
  );
}
gr.peek = Ou;
function gr(e, n, t, r) {
  const i = Pu(t), a = t.enter("emphasis"), l = t.createTracker(r), o = l.move(i);
  let u = l.move(
    t.containerPhrasing(e, {
      after: i,
      before: o,
      ...l.current()
    })
  );
  const s = u.charCodeAt(0), f = nt(
    r.before.charCodeAt(r.before.length - 1),
    s,
    i
  );
  f.inside && (u = qe(s) + u.slice(1));
  const c = u.charCodeAt(u.length - 1), p = nt(r.after.charCodeAt(0), c, i);
  p.inside && (u = u.slice(0, -1) + qe(c));
  const h = l.move(i);
  return a(), t.attentionEncodeSurroundingInfo = {
    after: p.outside,
    before: f.outside
  }, o + u + h;
}
function Ou(e, n, t) {
  return t.options.emphasis || "*";
}
function Fu(e, n) {
  let t = !1;
  return Pt(e, function(r) {
    if ("value" in r && /\r?\n|\r/.test(r.value) || r.type === "break")
      return t = !0, ri;
  }), !!((!e.depth || e.depth < 3) && Ft(e) && (n.options.setext || t));
}
function Du(e, n, t, r) {
  const i = Math.max(Math.min(6, e.depth || 1), 1), a = t.createTracker(r);
  if (Fu(e, t)) {
    const f = t.enter("headingSetext"), c = t.enter("phrasing"), p = t.containerPhrasing(e, {
      ...a.current(),
      before: `
`,
      after: `
`
    });
    return c(), f(), p + `
` + (i === 1 ? "=" : "-").repeat(
      // The whole size…
      p.length - // Minus the position of the character after the last EOL (or
      // 0 if there is none)…
      (Math.max(p.lastIndexOf("\r"), p.lastIndexOf(`
`)) + 1)
    );
  }
  const l = "#".repeat(i), o = t.enter("headingAtx"), u = t.enter("phrasing");
  a.move(l + " ");
  let s = t.containerPhrasing(e, {
    before: "# ",
    after: `
`,
    ...a.current()
  });
  return /^[\t ]/.test(s) && (s = qe(s.charCodeAt(0)) + s.slice(1)), s = s ? l + " " + s : l, t.options.closeAtx && (s += " " + l), u(), o(), s;
}
dr.peek = Lu;
function dr(e) {
  return e.value || "";
}
function Lu() {
  return "<";
}
xr.peek = ju;
function xr(e, n, t, r) {
  const i = qt(t), a = i === '"' ? "Quote" : "Apostrophe", l = t.enter("image");
  let o = t.enter("label");
  const u = t.createTracker(r);
  let s = u.move("![");
  return s += u.move(
    t.safe(e.alt, { before: s, after: "]", ...u.current() })
  ), s += u.move("]("), o(), // If there’s no url but there is a title…
  !e.url && e.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (o = t.enter("destinationLiteral"), s += u.move("<"), s += u.move(
    t.safe(e.url, { before: s, after: ">", ...u.current() })
  ), s += u.move(">")) : (o = t.enter("destinationRaw"), s += u.move(
    t.safe(e.url, {
      before: s,
      after: e.title ? " " : ")",
      ...u.current()
    })
  )), o(), e.title && (o = t.enter(`title${a}`), s += u.move(" " + i), s += u.move(
    t.safe(e.title, {
      before: s,
      after: i,
      ...u.current()
    })
  ), s += u.move(i), o()), s += u.move(")"), l(), s;
}
function ju() {
  return "!";
}
kr.peek = Ru;
function kr(e, n, t, r) {
  const i = e.referenceType, a = t.enter("imageReference");
  let l = t.enter("label");
  const o = t.createTracker(r);
  let u = o.move("![");
  const s = t.safe(e.alt, {
    before: u,
    after: "]",
    ...o.current()
  });
  u += o.move(s + "]["), l();
  const f = t.stack;
  t.stack = [], l = t.enter("reference");
  const c = t.safe(t.associationId(e), {
    before: u,
    after: "]",
    ...o.current()
  });
  return l(), t.stack = f, a(), i === "full" || !s || s !== c ? u += o.move(c + "]") : i === "shortcut" ? u = u.slice(0, -1) : u += o.move("]"), u;
}
function Ru() {
  return "!";
}
br.peek = _u;
function br(e, n, t) {
  let r = e.value || "", i = "`", a = -1;
  for (; new RegExp("(^|[^`])" + i + "([^`]|$)").test(r); )
    i += "`";
  for (/[^ \r\n]/.test(r) && (/^[ \r\n]/.test(r) && /[ \r\n]$/.test(r) || /^`|`$/.test(r)) && (r = " " + r + " "); ++a < t.unsafe.length; ) {
    const l = t.unsafe[a], o = t.compilePattern(l);
    let u;
    if (l.atBreak)
      for (; u = o.exec(r); ) {
        let s = u.index;
        r.charCodeAt(s) === 10 && r.charCodeAt(s - 1) === 13 && s--, r = r.slice(0, s) + " " + r.slice(u.index + 1);
      }
  }
  return i + r + i;
}
function _u() {
  return "`";
}
function yr(e, n) {
  const t = Ft(e);
  return !!(!n.options.resourceLink && // If there’s a url…
  e.url && // And there’s a no title…
  !e.title && // And the content of `node` is a single text node…
  e.children && e.children.length === 1 && e.children[0].type === "text" && // And if the url is the same as the content…
  (t === e.url || "mailto:" + t === e.url) && // And that starts w/ a protocol…
  /^[a-z][a-z+.-]+:/i.test(e.url) && // And that doesn’t contain ASCII control codes (character escapes and
  // references don’t work), space, or angle brackets…
  !/[\0- <>\u007F]/.test(e.url));
}
wr.peek = Bu;
function wr(e, n, t, r) {
  const i = qt(t), a = i === '"' ? "Quote" : "Apostrophe", l = t.createTracker(r);
  let o, u;
  if (yr(e, t)) {
    const f = t.stack;
    t.stack = [], o = t.enter("autolink");
    let c = l.move("<");
    return c += l.move(
      t.containerPhrasing(e, {
        before: c,
        after: ">",
        ...l.current()
      })
    ), c += l.move(">"), o(), t.stack = f, c;
  }
  o = t.enter("link"), u = t.enter("label");
  let s = l.move("[");
  return s += l.move(
    t.containerPhrasing(e, {
      before: s,
      after: "](",
      ...l.current()
    })
  ), s += l.move("]("), u(), // If there’s no url but there is a title…
  !e.url && e.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (u = t.enter("destinationLiteral"), s += l.move("<"), s += l.move(
    t.safe(e.url, { before: s, after: ">", ...l.current() })
  ), s += l.move(">")) : (u = t.enter("destinationRaw"), s += l.move(
    t.safe(e.url, {
      before: s,
      after: e.title ? " " : ")",
      ...l.current()
    })
  )), u(), e.title && (u = t.enter(`title${a}`), s += l.move(" " + i), s += l.move(
    t.safe(e.title, {
      before: s,
      after: i,
      ...l.current()
    })
  ), s += l.move(i), u()), s += l.move(")"), o(), s;
}
function Bu(e, n, t) {
  return yr(e, t) ? "<" : "[";
}
Cr.peek = Nu;
function Cr(e, n, t, r) {
  const i = e.referenceType, a = t.enter("linkReference");
  let l = t.enter("label");
  const o = t.createTracker(r);
  let u = o.move("[");
  const s = t.containerPhrasing(e, {
    before: u,
    after: "]",
    ...o.current()
  });
  u += o.move(s + "]["), l();
  const f = t.stack;
  t.stack = [], l = t.enter("reference");
  const c = t.safe(t.associationId(e), {
    before: u,
    after: "]",
    ...o.current()
  });
  return l(), t.stack = f, a(), i === "full" || !s || s !== c ? u += o.move(c + "]") : i === "shortcut" ? u = u.slice(0, -1) : u += o.move("]"), u;
}
function Nu() {
  return "[";
}
function Ht(e) {
  const n = e.options.bullet || "*";
  if (n !== "*" && n !== "+" && n !== "-")
    throw new Error(
      "Cannot serialize items with `" + n + "` for `options.bullet`, expected `*`, `+`, or `-`"
    );
  return n;
}
function Mu(e) {
  const n = Ht(e), t = e.options.bulletOther;
  if (!t)
    return n === "*" ? "-" : "*";
  if (t !== "*" && t !== "+" && t !== "-")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.bulletOther`, expected `*`, `+`, or `-`"
    );
  if (t === n)
    throw new Error(
      "Expected `bullet` (`" + n + "`) and `bulletOther` (`" + t + "`) to be different"
    );
  return t;
}
function qu(e) {
  const n = e.options.bulletOrdered || ".";
  if (n !== "." && n !== ")")
    throw new Error(
      "Cannot serialize items with `" + n + "` for `options.bulletOrdered`, expected `.` or `)`"
    );
  return n;
}
function Sr(e) {
  const n = e.options.rule || "*";
  if (n !== "*" && n !== "-" && n !== "_")
    throw new Error(
      "Cannot serialize rules with `" + n + "` for `options.rule`, expected `*`, `-`, or `_`"
    );
  return n;
}
function Hu(e, n, t, r) {
  const i = t.enter("list"), a = t.bulletCurrent;
  let l = e.ordered ? qu(t) : Ht(t);
  const o = e.ordered ? l === "." ? ")" : "." : Mu(t);
  let u = n && t.bulletLastUsed ? l === t.bulletLastUsed : !1;
  if (!e.ordered) {
    const f = e.children ? e.children[0] : void 0;
    if (
      // Bullet could be used as a thematic break marker:
      (l === "*" || l === "-") && // Empty first list item:
      f && (!f.children || !f.children[0]) && // Directly in two other list items:
      t.stack[t.stack.length - 1] === "list" && t.stack[t.stack.length - 2] === "listItem" && t.stack[t.stack.length - 3] === "list" && t.stack[t.stack.length - 4] === "listItem" && // That are each the first child.
      t.indexStack[t.indexStack.length - 1] === 0 && t.indexStack[t.indexStack.length - 2] === 0 && t.indexStack[t.indexStack.length - 3] === 0 && (u = !0), Sr(t) === l && f
    ) {
      let c = -1;
      for (; ++c < e.children.length; ) {
        const p = e.children[c];
        if (p && p.type === "listItem" && p.children && p.children[0] && p.children[0].type === "thematicBreak") {
          u = !0;
          break;
        }
      }
    }
  }
  u && (l = o), t.bulletCurrent = l;
  const s = t.containerFlow(e, r);
  return t.bulletLastUsed = l, t.bulletCurrent = a, i(), s;
}
function $u(e) {
  const n = e.options.listItemIndent || "one";
  if (n !== "tab" && n !== "one" && n !== "mixed")
    throw new Error(
      "Cannot serialize items with `" + n + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`"
    );
  return n;
}
function Vu(e, n, t, r) {
  const i = $u(t);
  let a = t.bulletCurrent || Ht(t);
  n && n.type === "list" && n.ordered && (a = (typeof n.start == "number" && n.start > -1 ? n.start : 1) + (t.options.incrementListMarker === !1 ? 0 : n.children.indexOf(e)) + a);
  let l = a.length + 1;
  (i === "tab" || i === "mixed" && (n && n.type === "list" && n.spread || e.spread)) && (l = Math.ceil(l / 4) * 4);
  const o = t.createTracker(r);
  o.move(a + " ".repeat(l - a.length)), o.shift(l);
  const u = t.enter("listItem"), s = t.indentLines(
    t.containerFlow(e, o.current()),
    f
  );
  return u(), s;
  function f(c, p, h) {
    return p ? (h ? "" : " ".repeat(l)) + c : (h ? a : a + " ".repeat(l - a.length)) + c;
  }
}
function Uu(e, n, t, r) {
  const i = t.enter("paragraph"), a = t.enter("phrasing"), l = t.containerPhrasing(e, r);
  return a(), i(), l;
}
const Wu = (
  /** @type {(node?: unknown) => node is Exclude<PhrasingContent, Html>} */
  $n([
    "break",
    "delete",
    "emphasis",
    // To do: next major: removed since footnotes were added to GFM.
    "footnote",
    "footnoteReference",
    "image",
    "imageReference",
    "inlineCode",
    // Enabled by `mdast-util-math`:
    "inlineMath",
    "link",
    "linkReference",
    // Enabled by `mdast-util-mdx`:
    "mdxJsxTextElement",
    // Enabled by `mdast-util-mdx`:
    "mdxTextExpression",
    "strong",
    "text",
    // Enabled by `mdast-util-directive`:
    "textDirective"
  ])
);
function Qu(e, n, t, r) {
  return (e.children.some(function(l) {
    return Wu(l);
  }) ? t.containerPhrasing : t.containerFlow).call(t, e, r);
}
function Gu(e) {
  const n = e.options.strong || "*";
  if (n !== "*" && n !== "_")
    throw new Error(
      "Cannot serialize strong with `" + n + "` for `options.strong`, expected `*`, or `_`"
    );
  return n;
}
Er.peek = Yu;
function Er(e, n, t, r) {
  const i = Gu(t), a = t.enter("strong"), l = t.createTracker(r), o = l.move(i + i);
  let u = l.move(
    t.containerPhrasing(e, {
      after: i,
      before: o,
      ...l.current()
    })
  );
  const s = u.charCodeAt(0), f = nt(
    r.before.charCodeAt(r.before.length - 1),
    s,
    i
  );
  f.inside && (u = qe(s) + u.slice(1));
  const c = u.charCodeAt(u.length - 1), p = nt(r.after.charCodeAt(0), c, i);
  p.inside && (u = u.slice(0, -1) + qe(c));
  const h = l.move(i + i);
  return a(), t.attentionEncodeSurroundingInfo = {
    after: p.outside,
    before: f.outside
  }, o + u + h;
}
function Yu(e, n, t) {
  return t.options.strong || "*";
}
function Zu(e, n, t, r) {
  return t.safe(e.value, r);
}
function Ju(e) {
  const n = e.options.ruleRepetition || 3;
  if (n < 3)
    throw new Error(
      "Cannot serialize rules with repetition `" + n + "` for `options.ruleRepetition`, expected `3` or more"
    );
  return n;
}
function Ku(e, n, t) {
  const r = (Sr(t) + (t.options.ruleSpaces ? " " : "")).repeat(Ju(t));
  return t.options.ruleSpaces ? r.slice(0, -1) : r;
}
const Ar = {
  blockquote: wu,
  break: Tn,
  code: Tu,
  definition: vu,
  emphasis: gr,
  hardBreak: Tn,
  heading: Du,
  html: dr,
  image: xr,
  imageReference: kr,
  inlineCode: br,
  link: wr,
  linkReference: Cr,
  list: Hu,
  listItem: Vu,
  paragraph: Uu,
  root: Qu,
  strong: Er,
  text: Zu,
  thematicBreak: Ku
};
function Xu() {
  return {
    enter: {
      table: es,
      tableData: zn,
      tableHeader: zn,
      tableRow: ns
    },
    exit: {
      codeText: rs,
      table: ts,
      tableData: St,
      tableHeader: St,
      tableRow: St
    }
  };
}
function es(e) {
  const n = e._align;
  this.enter(
    {
      type: "table",
      align: n.map(function(t) {
        return t === "none" ? null : t;
      }),
      children: []
    },
    e
  ), this.data.inTable = !0;
}
function ts(e) {
  this.exit(e), this.data.inTable = void 0;
}
function ns(e) {
  this.enter({ type: "tableRow", children: [] }, e);
}
function St(e) {
  this.exit(e);
}
function zn(e) {
  this.enter({ type: "tableCell", children: [] }, e);
}
function rs(e) {
  let n = this.resume();
  this.data.inTable && (n = n.replace(/\\([\\|])/g, is));
  const t = this.stack[this.stack.length - 1];
  Fe(t.type === "inlineCode"), t.value = n, this.exit(e);
}
function is(e, n) {
  return n === "|" ? n : e;
}
function ls(e) {
  const n = e || {}, t = n.tableCellPadding, r = n.tablePipeAlign, i = n.stringLength, a = t ? " " : "|";
  return {
    unsafe: [
      { character: "\r", inConstruct: "tableCell" },
      { character: `
`, inConstruct: "tableCell" },
      // A pipe, when followed by a tab or space (padding), or a dash or colon
      // (unpadded delimiter row), could result in a table.
      { atBreak: !0, character: "|", after: "[	 :-]" },
      // A pipe in a cell must be encoded.
      { character: "|", inConstruct: "tableCell" },
      // A colon must be followed by a dash, in which case it could start a
      // delimiter row.
      { atBreak: !0, character: ":", after: "-" },
      // A delimiter row can also start with a dash, when followed by more
      // dashes, a colon, or a pipe.
      // This is a stricter version than the built in check for lists, thematic
      // breaks, and setex heading underlines though:
      // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
      { atBreak: !0, character: "-", after: "[:|-]" }
    ],
    handlers: {
      inlineCode: p,
      table: l,
      tableCell: u,
      tableRow: o
    }
  };
  function l(h, d, b, C) {
    return s(f(h, b, C), h.align);
  }
  function o(h, d, b, C) {
    const k = c(h, b, C), E = s([k]);
    return E.slice(0, E.indexOf(`
`));
  }
  function u(h, d, b, C) {
    const k = b.enter("tableCell"), E = b.enter("phrasing"), S = b.containerPhrasing(h, {
      ...C,
      before: a,
      after: a
    });
    return E(), k(), S;
  }
  function s(h, d) {
    return bu(h, {
      align: d,
      // @ts-expect-error: `markdown-table` types should support `null`.
      alignDelimiters: r,
      // @ts-expect-error: `markdown-table` types should support `null`.
      padding: t,
      // @ts-expect-error: `markdown-table` types should support `null`.
      stringLength: i
    });
  }
  function f(h, d, b) {
    const C = h.children;
    let k = -1;
    const E = [], S = d.enter("table");
    for (; ++k < C.length; )
      E[k] = c(C[k], d, b);
    return S(), E;
  }
  function c(h, d, b) {
    const C = h.children;
    let k = -1;
    const E = [], S = d.enter("tableRow");
    for (; ++k < C.length; )
      E[k] = u(C[k], h, d, b);
    return S(), E;
  }
  function p(h, d, b) {
    let C = Ar.inlineCode(h, d, b);
    return b.stack.includes("tableCell") && (C = C.replace(/\|/g, "\\$&")), C;
  }
}
function as() {
  return {
    exit: {
      taskListCheckValueChecked: vn,
      taskListCheckValueUnchecked: vn,
      paragraph: us
    }
  };
}
function os() {
  return {
    unsafe: [{ atBreak: !0, character: "-", after: "[:|-]" }],
    handlers: { listItem: ss }
  };
}
function vn(e) {
  const n = this.stack[this.stack.length - 2];
  Fe(n.type === "listItem"), n.checked = e.type === "taskListCheckValueChecked";
}
function us(e) {
  const n = this.stack[this.stack.length - 2];
  if (n && n.type === "listItem" && typeof n.checked == "boolean") {
    const t = this.stack[this.stack.length - 1];
    Fe(t.type === "paragraph");
    const r = t.children[0];
    if (r && r.type === "text") {
      const i = n.children;
      let a = -1, l;
      for (; ++a < i.length; ) {
        const o = i[a];
        if (o.type === "paragraph") {
          l = o;
          break;
        }
      }
      l === t && (r.value = r.value.slice(1), r.value.length === 0 ? t.children.shift() : t.position && r.position && typeof r.position.start.offset == "number" && (r.position.start.column++, r.position.start.offset++, t.position.start = Object.assign({}, r.position.start)));
    }
  }
  this.exit(e);
}
function ss(e, n, t, r) {
  const i = e.children[0], a = typeof e.checked == "boolean" && i && i.type === "paragraph", l = "[" + (e.checked ? "x" : " ") + "] ", o = t.createTracker(r);
  a && o.move(l);
  let u = Ar.listItem(e, n, t, {
    ...r,
    ...o.current()
  });
  return a && (u = u.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, s)), u;
  function s(f) {
    return f + l;
  }
}
function cs() {
  return [
    Ho(),
    su(),
    pu(),
    Xu(),
    as()
  ];
}
function fs(e) {
  return {
    extensions: [
      $o(),
      cu(e),
      mu(),
      ls(e),
      os()
    ]
  };
}
function Je(e, n, t, r) {
  const i = e.length;
  let a = 0, l;
  if (n < 0 ? n = -n > i ? 0 : i + n : n = n > i ? i : n, t = t > 0 ? t : 0, r.length < 1e4)
    l = Array.from(r), l.unshift(n, t), e.splice(...l);
  else
    for (t && e.splice(n, t); a < r.length; )
      l = r.slice(a, a + 1e4), l.unshift(n, 0), e.splice(...l), a += 1e4, n += 1e4;
}
const Pn = {}.hasOwnProperty;
function hs(e) {
  const n = {};
  let t = -1;
  for (; ++t < e.length; )
    ps(n, e[t]);
  return n;
}
function ps(e, n) {
  let t;
  for (t in n) {
    const i = (Pn.call(e, t) ? e[t] : void 0) || (e[t] = {}), a = n[t];
    let l;
    if (a)
      for (l in a) {
        Pn.call(i, l) || (i[l] = []);
        const o = a[l];
        ms(
          // @ts-expect-error Looks like a list.
          i[l],
          Array.isArray(o) ? o : o ? [o] : []
        );
      }
  }
}
function ms(e, n) {
  let t = -1;
  const r = [];
  for (; ++t < n.length; )
    (n[t].add === "after" ? e : r).push(n[t]);
  Je(e, 0, 0, r);
}
const gs = {
  tokenize: ws,
  partial: !0
}, Ir = {
  tokenize: Cs,
  partial: !0
}, Tr = {
  tokenize: Ss,
  partial: !0
}, zr = {
  tokenize: Es,
  partial: !0
}, ds = {
  tokenize: As,
  partial: !0
}, vr = {
  name: "wwwAutolink",
  tokenize: bs,
  previous: Or
}, Pr = {
  name: "protocolAutolink",
  tokenize: ys,
  previous: Fr
}, ce = {
  name: "emailAutolink",
  tokenize: ks,
  previous: Dr
}, le = {};
function xs() {
  return {
    text: le
  };
}
let be = 48;
for (; be < 123; )
  le[be] = ce, be++, be === 58 ? be = 65 : be === 91 && (be = 97);
le[43] = ce;
le[45] = ce;
le[46] = ce;
le[95] = ce;
le[72] = [ce, Pr];
le[104] = [ce, Pr];
le[87] = [ce, vr];
le[119] = [ce, vr];
function ks(e, n, t) {
  const r = this;
  let i, a;
  return l;
  function l(c) {
    return !vt(c) || !Dr.call(r, r.previous) || $t(r.events) ? t(c) : (e.enter("literalAutolink"), e.enter("literalAutolinkEmail"), o(c));
  }
  function o(c) {
    return vt(c) ? (e.consume(c), o) : c === 64 ? (e.consume(c), u) : t(c);
  }
  function u(c) {
    return c === 46 ? e.check(ds, f, s)(c) : c === 45 || c === 95 || Q(c) ? (a = !0, e.consume(c), u) : f(c);
  }
  function s(c) {
    return e.consume(c), i = !0, u;
  }
  function f(c) {
    return a && i && G(r.previous) ? (e.exit("literalAutolinkEmail"), e.exit("literalAutolink"), n(c)) : t(c);
  }
}
function bs(e, n, t) {
  const r = this;
  return i;
  function i(l) {
    return l !== 87 && l !== 119 || !Or.call(r, r.previous) || $t(r.events) ? t(l) : (e.enter("literalAutolink"), e.enter("literalAutolinkWww"), e.check(gs, e.attempt(Ir, e.attempt(Tr, a), t), t)(l));
  }
  function a(l) {
    return e.exit("literalAutolinkWww"), e.exit("literalAutolink"), n(l);
  }
}
function ys(e, n, t) {
  const r = this;
  let i = "", a = !1;
  return l;
  function l(c) {
    return (c === 72 || c === 104) && Fr.call(r, r.previous) && !$t(r.events) ? (e.enter("literalAutolink"), e.enter("literalAutolinkHttp"), i += String.fromCodePoint(c), e.consume(c), o) : t(c);
  }
  function o(c) {
    if (G(c) && i.length < 5)
      return i += String.fromCodePoint(c), e.consume(c), o;
    if (c === 58) {
      const p = i.toLowerCase();
      if (p === "http" || p === "https")
        return e.consume(c), u;
    }
    return t(c);
  }
  function u(c) {
    return c === 47 ? (e.consume(c), a ? s : (a = !0, u)) : t(c);
  }
  function s(c) {
    return c === null || Xe(c) || q(c) || we(c) || it(c) ? t(c) : e.attempt(Ir, e.attempt(Tr, f), t)(c);
  }
  function f(c) {
    return e.exit("literalAutolinkHttp"), e.exit("literalAutolink"), n(c);
  }
}
function ws(e, n, t) {
  let r = 0;
  return i;
  function i(l) {
    return (l === 87 || l === 119) && r < 3 ? (r++, e.consume(l), i) : l === 46 && r === 3 ? (e.consume(l), a) : t(l);
  }
  function a(l) {
    return l === null ? t(l) : n(l);
  }
}
function Cs(e, n, t) {
  let r, i, a;
  return l;
  function l(s) {
    return s === 46 || s === 95 ? e.check(zr, u, o)(s) : s === null || q(s) || we(s) || s !== 45 && it(s) ? u(s) : (a = !0, e.consume(s), l);
  }
  function o(s) {
    return s === 95 ? r = !0 : (i = r, r = void 0), e.consume(s), l;
  }
  function u(s) {
    return i || r || !a ? t(s) : n(s);
  }
}
function Ss(e, n) {
  let t = 0, r = 0;
  return i;
  function i(l) {
    return l === 40 ? (t++, e.consume(l), i) : l === 41 && r < t ? a(l) : l === 33 || l === 34 || l === 38 || l === 39 || l === 41 || l === 42 || l === 44 || l === 46 || l === 58 || l === 59 || l === 60 || l === 63 || l === 93 || l === 95 || l === 126 ? e.check(zr, n, a)(l) : l === null || q(l) || we(l) ? n(l) : (e.consume(l), i);
  }
  function a(l) {
    return l === 41 && r++, e.consume(l), i;
  }
}
function Es(e, n, t) {
  return r;
  function r(o) {
    return o === 33 || o === 34 || o === 39 || o === 41 || o === 42 || o === 44 || o === 46 || o === 58 || o === 59 || o === 63 || o === 95 || o === 126 ? (e.consume(o), r) : o === 38 ? (e.consume(o), a) : o === 93 ? (e.consume(o), i) : (
      // `<` is an end.
      o === 60 || // So is whitespace.
      o === null || q(o) || we(o) ? n(o) : t(o)
    );
  }
  function i(o) {
    return o === null || o === 40 || o === 91 || q(o) || we(o) ? n(o) : r(o);
  }
  function a(o) {
    return G(o) ? l(o) : t(o);
  }
  function l(o) {
    return o === 59 ? (e.consume(o), r) : G(o) ? (e.consume(o), l) : t(o);
  }
}
function As(e, n, t) {
  return r;
  function r(a) {
    return e.consume(a), i;
  }
  function i(a) {
    return Q(a) ? t(a) : n(a);
  }
}
function Or(e) {
  return e === null || e === 40 || e === 42 || e === 95 || e === 91 || e === 93 || e === 126 || q(e);
}
function Fr(e) {
  return !G(e);
}
function Dr(e) {
  return !(e === 47 || vt(e));
}
function vt(e) {
  return e === 43 || e === 45 || e === 46 || e === 95 || Q(e);
}
function $t(e) {
  let n = e.length, t = !1;
  for (; n--; ) {
    const r = e[n][1];
    if ((r.type === "labelLink" || r.type === "labelImage") && !r._balanced) {
      t = !0;
      break;
    }
    if (r._gfmAutolinkLiteralWalkedInto) {
      t = !1;
      break;
    }
  }
  return e.length > 0 && !t && (e[e.length - 1][1]._gfmAutolinkLiteralWalkedInto = !0), t;
}
function Is(e, n, t) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; ) {
    const a = e[i].resolveAll;
    a && !r.includes(a) && (n = a(n, t), r.push(a));
  }
  return n;
}
const Ts = {
  partial: !0,
  tokenize: zs
};
function zs(e, n, t) {
  return r;
  function r(a) {
    return D(a) ? j(e, i, "linePrefix")(a) : i(a);
  }
  function i(a) {
    return a === null || v(a) ? n(a) : t(a);
  }
}
const vs = {
  tokenize: _s,
  partial: !0
};
function Ps() {
  return {
    document: {
      91: {
        name: "gfmFootnoteDefinition",
        tokenize: Ls,
        continuation: {
          tokenize: js
        },
        exit: Rs
      }
    },
    text: {
      91: {
        name: "gfmFootnoteCall",
        tokenize: Ds
      },
      93: {
        name: "gfmPotentialFootnoteCall",
        add: "after",
        tokenize: Os,
        resolveTo: Fs
      }
    }
  };
}
function Os(e, n, t) {
  const r = this;
  let i = r.events.length;
  const a = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let l;
  for (; i--; ) {
    const u = r.events[i][1];
    if (u.type === "labelImage") {
      l = u;
      break;
    }
    if (u.type === "gfmFootnoteCall" || u.type === "labelLink" || u.type === "label" || u.type === "image" || u.type === "link")
      break;
  }
  return o;
  function o(u) {
    if (!l || !l._balanced)
      return t(u);
    const s = $e(r.sliceSerialize({
      start: l.end,
      end: r.now()
    }));
    return s.codePointAt(0) !== 94 || !a.includes(s.slice(1)) ? t(u) : (e.enter("gfmFootnoteCallLabelMarker"), e.consume(u), e.exit("gfmFootnoteCallLabelMarker"), n(u));
  }
}
function Fs(e, n) {
  let t = e.length;
  for (; t--; )
    if (e[t][1].type === "labelImage" && e[t][0] === "enter") {
      e[t][1];
      break;
    }
  e[t + 1][1].type = "data", e[t + 3][1].type = "gfmFootnoteCallLabelMarker";
  const r = {
    type: "gfmFootnoteCall",
    start: Object.assign({}, e[t + 3][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, i = {
    type: "gfmFootnoteCallMarker",
    start: Object.assign({}, e[t + 3][1].end),
    end: Object.assign({}, e[t + 3][1].end)
  };
  i.end.column++, i.end.offset++, i.end._bufferIndex++;
  const a = {
    type: "gfmFootnoteCallString",
    start: Object.assign({}, i.end),
    end: Object.assign({}, e[e.length - 1][1].start)
  }, l = {
    type: "chunkString",
    contentType: "string",
    start: Object.assign({}, a.start),
    end: Object.assign({}, a.end)
  }, o = [
    // Take the `labelImageMarker` (now `data`, the `!`)
    e[t + 1],
    e[t + 2],
    ["enter", r, n],
    // The `[`
    e[t + 3],
    e[t + 4],
    // The `^`.
    ["enter", i, n],
    ["exit", i, n],
    // Everything in between.
    ["enter", a, n],
    ["enter", l, n],
    ["exit", l, n],
    ["exit", a, n],
    // The ending (`]`, properly parsed and labelled).
    e[e.length - 2],
    e[e.length - 1],
    ["exit", r, n]
  ];
  return e.splice(t, e.length - t + 1, ...o), e;
}
function Ds(e, n, t) {
  const r = this, i = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let a = 0, l;
  return o;
  function o(c) {
    return e.enter("gfmFootnoteCall"), e.enter("gfmFootnoteCallLabelMarker"), e.consume(c), e.exit("gfmFootnoteCallLabelMarker"), u;
  }
  function u(c) {
    return c !== 94 ? t(c) : (e.enter("gfmFootnoteCallMarker"), e.consume(c), e.exit("gfmFootnoteCallMarker"), e.enter("gfmFootnoteCallString"), e.enter("chunkString").contentType = "string", s);
  }
  function s(c) {
    if (
      // Too long.
      a > 999 || // Closing brace with nothing.
      c === 93 && !l || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      c === null || c === 91 || q(c)
    )
      return t(c);
    if (c === 93) {
      e.exit("chunkString");
      const p = e.exit("gfmFootnoteCallString");
      return i.includes($e(r.sliceSerialize(p))) ? (e.enter("gfmFootnoteCallLabelMarker"), e.consume(c), e.exit("gfmFootnoteCallLabelMarker"), e.exit("gfmFootnoteCall"), n) : t(c);
    }
    return q(c) || (l = !0), a++, e.consume(c), c === 92 ? f : s;
  }
  function f(c) {
    return c === 91 || c === 92 || c === 93 ? (e.consume(c), a++, s) : s(c);
  }
}
function Ls(e, n, t) {
  const r = this, i = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let a, l = 0, o;
  return u;
  function u(d) {
    return e.enter("gfmFootnoteDefinition")._container = !0, e.enter("gfmFootnoteDefinitionLabel"), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(d), e.exit("gfmFootnoteDefinitionLabelMarker"), s;
  }
  function s(d) {
    return d === 94 ? (e.enter("gfmFootnoteDefinitionMarker"), e.consume(d), e.exit("gfmFootnoteDefinitionMarker"), e.enter("gfmFootnoteDefinitionLabelString"), e.enter("chunkString").contentType = "string", f) : t(d);
  }
  function f(d) {
    if (
      // Too long.
      l > 999 || // Closing brace with nothing.
      d === 93 && !o || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      d === null || d === 91 || q(d)
    )
      return t(d);
    if (d === 93) {
      e.exit("chunkString");
      const b = e.exit("gfmFootnoteDefinitionLabelString");
      return a = $e(r.sliceSerialize(b)), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(d), e.exit("gfmFootnoteDefinitionLabelMarker"), e.exit("gfmFootnoteDefinitionLabel"), p;
    }
    return q(d) || (o = !0), l++, e.consume(d), d === 92 ? c : f;
  }
  function c(d) {
    return d === 91 || d === 92 || d === 93 ? (e.consume(d), l++, f) : f(d);
  }
  function p(d) {
    return d === 58 ? (e.enter("definitionMarker"), e.consume(d), e.exit("definitionMarker"), i.includes(a) || i.push(a), j(e, h, "gfmFootnoteDefinitionWhitespace")) : t(d);
  }
  function h(d) {
    return n(d);
  }
}
function js(e, n, t) {
  return e.check(Ts, n, e.attempt(vs, n, t));
}
function Rs(e) {
  e.exit("gfmFootnoteDefinition");
}
function _s(e, n, t) {
  const r = this;
  return j(e, i, "gfmFootnoteDefinitionIndent", 5);
  function i(a) {
    const l = r.events[r.events.length - 1];
    return l && l[1].type === "gfmFootnoteDefinitionIndent" && l[2].sliceSerialize(l[1], !0).length === 4 ? n(a) : t(a);
  }
}
function Bs(e) {
  let t = (e || {}).singleTilde;
  const r = {
    name: "strikethrough",
    tokenize: a,
    resolveAll: i
  };
  return t == null && (t = !0), {
    text: {
      126: r
    },
    insideSpan: {
      null: [r]
    },
    attentionMarkers: {
      null: [126]
    }
  };
  function i(l, o) {
    let u = -1;
    for (; ++u < l.length; )
      if (l[u][0] === "enter" && l[u][1].type === "strikethroughSequenceTemporary" && l[u][1]._close) {
        let s = u;
        for (; s--; )
          if (l[s][0] === "exit" && l[s][1].type === "strikethroughSequenceTemporary" && l[s][1]._open && // If the sizes are the same:
          l[u][1].end.offset - l[u][1].start.offset === l[s][1].end.offset - l[s][1].start.offset) {
            l[u][1].type = "strikethroughSequence", l[s][1].type = "strikethroughSequence";
            const f = {
              type: "strikethrough",
              start: Object.assign({}, l[s][1].start),
              end: Object.assign({}, l[u][1].end)
            }, c = {
              type: "strikethroughText",
              start: Object.assign({}, l[s][1].end),
              end: Object.assign({}, l[u][1].start)
            }, p = [["enter", f, o], ["enter", l[s][1], o], ["exit", l[s][1], o], ["enter", c, o]], h = o.parser.constructs.insideSpan.null;
            h && Je(p, p.length, 0, Is(h, l.slice(s + 1, u), o)), Je(p, p.length, 0, [["exit", c, o], ["enter", l[u][1], o], ["exit", l[u][1], o], ["exit", f, o]]), Je(l, s - 1, u - s + 3, p), u = s + p.length - 2;
            break;
          }
      }
    for (u = -1; ++u < l.length; )
      l[u][1].type === "strikethroughSequenceTemporary" && (l[u][1].type = "data");
    return l;
  }
  function a(l, o, u) {
    const s = this.previous, f = this.events;
    let c = 0;
    return p;
    function p(d) {
      return s === 126 && f[f.length - 1][1].type !== "characterEscape" ? u(d) : (l.enter("strikethroughSequenceTemporary"), h(d));
    }
    function h(d) {
      const b = Oe(s);
      if (d === 126)
        return c > 1 ? u(d) : (l.consume(d), c++, h);
      if (c < 2 && !t) return u(d);
      const C = l.exit("strikethroughSequenceTemporary"), k = Oe(d);
      return C._open = !k || k === 2 && !!b, C._close = !b || b === 2 && !!k, o(d);
    }
  }
}
class Ns {
  /**
   * Create a new edit map.
   */
  constructor() {
    this.map = [];
  }
  /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */
  add(n, t, r) {
    Ms(this, n, t, r);
  }
  // To do: add this when moving to `micromark`.
  // /**
  //  * Create an edit: but insert `add` before existing additions.
  //  *
  //  * @param {number} index
  //  * @param {number} remove
  //  * @param {Array<Event>} add
  //  * @returns {undefined}
  //  */
  // addBefore(index, remove, add) {
  //   addImplementation(this, index, remove, add, true)
  // }
  /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */
  consume(n) {
    if (this.map.sort(function(a, l) {
      return a[0] - l[0];
    }), this.map.length === 0)
      return;
    let t = this.map.length;
    const r = [];
    for (; t > 0; )
      t -= 1, r.push(n.slice(this.map[t][0] + this.map[t][1]), this.map[t][2]), n.length = this.map[t][0];
    r.push(n.slice()), n.length = 0;
    let i = r.pop();
    for (; i; ) {
      for (const a of i)
        n.push(a);
      i = r.pop();
    }
    this.map.length = 0;
  }
}
function Ms(e, n, t, r) {
  let i = 0;
  if (!(t === 0 && r.length === 0)) {
    for (; i < e.map.length; ) {
      if (e.map[i][0] === n) {
        e.map[i][1] += t, e.map[i][2].push(...r);
        return;
      }
      i += 1;
    }
    e.map.push([n, t, r]);
  }
}
function qs(e, n) {
  let t = !1;
  const r = [];
  for (; n < e.length; ) {
    const i = e[n];
    if (t) {
      if (i[0] === "enter")
        i[1].type === "tableContent" && r.push(e[n + 1][1].type === "tableDelimiterMarker" ? "left" : "none");
      else if (i[1].type === "tableContent") {
        if (e[n - 1][1].type === "tableDelimiterMarker") {
          const a = r.length - 1;
          r[a] = r[a] === "left" ? "center" : "right";
        }
      } else if (i[1].type === "tableDelimiterRow")
        break;
    } else i[0] === "enter" && i[1].type === "tableDelimiterRow" && (t = !0);
    n += 1;
  }
  return r;
}
function Hs() {
  return {
    flow: {
      null: {
        name: "table",
        tokenize: $s,
        resolveAll: Vs
      }
    }
  };
}
function $s(e, n, t) {
  const r = this;
  let i = 0, a = 0, l;
  return o;
  function o(x) {
    let T = r.events.length - 1;
    for (; T > -1; ) {
      const $ = r.events[T][1].type;
      if ($ === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
      $ === "linePrefix") T--;
      else break;
    }
    const z = T > -1 ? r.events[T][1].type : null, M = z === "tableHead" || z === "tableRow" ? w : u;
    return M === w && r.parser.lazy[r.now().line] ? t(x) : M(x);
  }
  function u(x) {
    return e.enter("tableHead"), e.enter("tableRow"), s(x);
  }
  function s(x) {
    return x === 124 || (l = !0, a += 1), f(x);
  }
  function f(x) {
    return x === null ? t(x) : v(x) ? a > 1 ? (a = 0, r.interrupt = !0, e.exit("tableRow"), e.enter("lineEnding"), e.consume(x), e.exit("lineEnding"), h) : t(x) : D(x) ? j(e, f, "whitespace")(x) : (a += 1, l && (l = !1, i += 1), x === 124 ? (e.enter("tableCellDivider"), e.consume(x), e.exit("tableCellDivider"), l = !0, f) : (e.enter("data"), c(x)));
  }
  function c(x) {
    return x === null || x === 124 || q(x) ? (e.exit("data"), f(x)) : (e.consume(x), x === 92 ? p : c);
  }
  function p(x) {
    return x === 92 || x === 124 ? (e.consume(x), c) : c(x);
  }
  function h(x) {
    return r.interrupt = !1, r.parser.lazy[r.now().line] ? t(x) : (e.enter("tableDelimiterRow"), l = !1, D(x) ? j(e, d, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(x) : d(x));
  }
  function d(x) {
    return x === 45 || x === 58 ? C(x) : x === 124 ? (l = !0, e.enter("tableCellDivider"), e.consume(x), e.exit("tableCellDivider"), b) : F(x);
  }
  function b(x) {
    return D(x) ? j(e, C, "whitespace")(x) : C(x);
  }
  function C(x) {
    return x === 58 ? (a += 1, l = !0, e.enter("tableDelimiterMarker"), e.consume(x), e.exit("tableDelimiterMarker"), k) : x === 45 ? (a += 1, k(x)) : x === null || v(x) ? O(x) : F(x);
  }
  function k(x) {
    return x === 45 ? (e.enter("tableDelimiterFiller"), E(x)) : F(x);
  }
  function E(x) {
    return x === 45 ? (e.consume(x), E) : x === 58 ? (l = !0, e.exit("tableDelimiterFiller"), e.enter("tableDelimiterMarker"), e.consume(x), e.exit("tableDelimiterMarker"), S) : (e.exit("tableDelimiterFiller"), S(x));
  }
  function S(x) {
    return D(x) ? j(e, O, "whitespace")(x) : O(x);
  }
  function O(x) {
    return x === 124 ? d(x) : x === null || v(x) ? !l || i !== a ? F(x) : (e.exit("tableDelimiterRow"), e.exit("tableHead"), n(x)) : F(x);
  }
  function F(x) {
    return t(x);
  }
  function w(x) {
    return e.enter("tableRow"), R(x);
  }
  function R(x) {
    return x === 124 ? (e.enter("tableCellDivider"), e.consume(x), e.exit("tableCellDivider"), R) : x === null || v(x) ? (e.exit("tableRow"), n(x)) : D(x) ? j(e, R, "whitespace")(x) : (e.enter("data"), H(x));
  }
  function H(x) {
    return x === null || x === 124 || q(x) ? (e.exit("data"), R(x)) : (e.consume(x), x === 92 ? B : H);
  }
  function B(x) {
    return x === 92 || x === 124 ? (e.consume(x), H) : H(x);
  }
}
function Vs(e, n) {
  let t = -1, r = !0, i = 0, a = [0, 0, 0, 0], l = [0, 0, 0, 0], o = !1, u = 0, s, f, c;
  const p = new Ns();
  for (; ++t < e.length; ) {
    const h = e[t], d = h[1];
    h[0] === "enter" ? d.type === "tableHead" ? (o = !1, u !== 0 && (On(p, n, u, s, f), f = void 0, u = 0), s = {
      type: "table",
      start: Object.assign({}, d.start),
      // Note: correct end is set later.
      end: Object.assign({}, d.end)
    }, p.add(t, 0, [["enter", s, n]])) : d.type === "tableRow" || d.type === "tableDelimiterRow" ? (r = !0, c = void 0, a = [0, 0, 0, 0], l = [0, t + 1, 0, 0], o && (o = !1, f = {
      type: "tableBody",
      start: Object.assign({}, d.start),
      // Note: correct end is set later.
      end: Object.assign({}, d.end)
    }, p.add(t, 0, [["enter", f, n]])), i = d.type === "tableDelimiterRow" ? 2 : f ? 3 : 1) : i && (d.type === "data" || d.type === "tableDelimiterMarker" || d.type === "tableDelimiterFiller") ? (r = !1, l[2] === 0 && (a[1] !== 0 && (l[0] = l[1], c = Qe(p, n, a, i, void 0, c), a = [0, 0, 0, 0]), l[2] = t)) : d.type === "tableCellDivider" && (r ? r = !1 : (a[1] !== 0 && (l[0] = l[1], c = Qe(p, n, a, i, void 0, c)), a = l, l = [a[1], t, 0, 0])) : d.type === "tableHead" ? (o = !0, u = t) : d.type === "tableRow" || d.type === "tableDelimiterRow" ? (u = t, a[1] !== 0 ? (l[0] = l[1], c = Qe(p, n, a, i, t, c)) : l[1] !== 0 && (c = Qe(p, n, l, i, t, c)), i = 0) : i && (d.type === "data" || d.type === "tableDelimiterMarker" || d.type === "tableDelimiterFiller") && (l[3] = t);
  }
  for (u !== 0 && On(p, n, u, s, f), p.consume(n.events), t = -1; ++t < n.events.length; ) {
    const h = n.events[t];
    h[0] === "enter" && h[1].type === "table" && (h[1]._align = qs(n.events, t));
  }
  return e;
}
function Qe(e, n, t, r, i, a) {
  const l = r === 1 ? "tableHeader" : r === 2 ? "tableDelimiter" : "tableData", o = "tableContent";
  t[0] !== 0 && (a.end = Object.assign({}, Te(n.events, t[0])), e.add(t[0], 0, [["exit", a, n]]));
  const u = Te(n.events, t[1]);
  if (a = {
    type: l,
    start: Object.assign({}, u),
    // Note: correct end is set later.
    end: Object.assign({}, u)
  }, e.add(t[1], 0, [["enter", a, n]]), t[2] !== 0) {
    const s = Te(n.events, t[2]), f = Te(n.events, t[3]), c = {
      type: o,
      start: Object.assign({}, s),
      end: Object.assign({}, f)
    };
    if (e.add(t[2], 0, [["enter", c, n]]), r !== 2) {
      const p = n.events[t[2]], h = n.events[t[3]];
      if (p[1].end = Object.assign({}, h[1].end), p[1].type = "chunkText", p[1].contentType = "text", t[3] > t[2] + 1) {
        const d = t[2] + 1, b = t[3] - t[2] - 1;
        e.add(d, b, []);
      }
    }
    e.add(t[3] + 1, 0, [["exit", c, n]]);
  }
  return i !== void 0 && (a.end = Object.assign({}, Te(n.events, i)), e.add(i, 0, [["exit", a, n]]), a = void 0), a;
}
function On(e, n, t, r, i) {
  const a = [], l = Te(n.events, t);
  i && (i.end = Object.assign({}, l), a.push(["exit", i, n])), r.end = Object.assign({}, l), a.push(["exit", r, n]), e.add(t + 1, 0, a);
}
function Te(e, n) {
  const t = e[n], r = t[0] === "enter" ? "start" : "end";
  return t[1][r];
}
const Us = {
  name: "tasklistCheck",
  tokenize: Qs
};
function Ws() {
  return {
    text: {
      91: Us
    }
  };
}
function Qs(e, n, t) {
  const r = this;
  return i;
  function i(u) {
    return (
      // Exit if there’s stuff before.
      r.previous !== null || // Exit if not in the first content that is the first child of a list
      // item.
      !r._gfmTasklistFirstContentOfListItem ? t(u) : (e.enter("taskListCheck"), e.enter("taskListCheckMarker"), e.consume(u), e.exit("taskListCheckMarker"), a)
    );
  }
  function a(u) {
    return q(u) ? (e.enter("taskListCheckValueUnchecked"), e.consume(u), e.exit("taskListCheckValueUnchecked"), l) : u === 88 || u === 120 ? (e.enter("taskListCheckValueChecked"), e.consume(u), e.exit("taskListCheckValueChecked"), l) : t(u);
  }
  function l(u) {
    return u === 93 ? (e.enter("taskListCheckMarker"), e.consume(u), e.exit("taskListCheckMarker"), e.exit("taskListCheck"), o) : t(u);
  }
  function o(u) {
    return v(u) ? n(u) : D(u) ? e.check({
      tokenize: Gs
    }, n, t)(u) : t(u);
  }
}
function Gs(e, n, t) {
  return j(e, r, "whitespace");
  function r(i) {
    return i === null ? t(i) : n(i);
  }
}
function Ys(e) {
  return hs([
    xs(),
    Ps(),
    Bs(e),
    Hs(),
    Ws()
  ]);
}
const Zs = {};
function Js(e) {
  const n = (
    /** @type {Processor<Root>} */
    this
  ), t = e || Zs, r = n.data(), i = r.micromarkExtensions || (r.micromarkExtensions = []), a = r.fromMarkdownExtensions || (r.fromMarkdownExtensions = []), l = r.toMarkdownExtensions || (r.toMarkdownExtensions = []);
  i.push(Ys(t)), a.push(cs()), l.push(fs(t));
}
const Ks = ({
  children: e,
  title: n,
  language: t,
  showCopy: r = "hover",
  showCopyText: i,
  showLanguageIndicator: a = !0,
  showLineNumbers: l,
  ...o
}) => {
  const [u, s] = Pe(!1), f = ze(null);
  return e ? /* @__PURE__ */ I.jsxs(
    "div",
    {
      className: K(
        "code-block-wrapper relative group bg-muted/50 rounded-md",
        l && "line-numbers"
      ),
      children: [
        n && /* @__PURE__ */ I.jsx("div", { className: "text-xs text-muted-foreground top-2 font-mono border-b w-full py-2 px-4 ", children: n }),
        /* @__PURE__ */ I.jsx(
          "div",
          {
            className: K(
              "code-block text-sm not-prose scrollbar overflow-x-auto scrollbar p-4",
              o.className
            ),
            ref: f,
            children: e
          }
        ),
        a && /* @__PURE__ */ I.jsx(
          "span",
          {
            className: K(
              "absolute top-1.5 end-3 !text-[11px] font-mono text-muted-foreground transition group-hover:opacity-0",
              n && "top-12"
            ),
            children: t
          }
        ),
        r !== "never" && /* @__PURE__ */ I.jsxs(
          "button",
          {
            type: "button",
            "aria-label": "Copy code",
            title: "Copy code",
            className: K(
              "absolute top-2 end-2 p-2 hover:outline hover:outline-border/75 dark:hover:outline-border rounded-md text-sm text-muted-foreground transition",
              n && "top-10",
              r === "hover" && "opacity-0 group-hover:opacity-100",
              i && "flex gap-2 items-center font-medium"
            ),
            disabled: u,
            onClick: () => {
              f.current?.textContent && (s(!0), navigator.clipboard.writeText(f.current.textContent), setTimeout(() => s(!1), 2e3));
            },
            children: [
              u ? /* @__PURE__ */ I.jsx(
                ai,
                {
                  className: "text-emerald-600",
                  size: 16,
                  strokeWidth: 2.5,
                  absoluteStrokeWidth: !0
                }
              ) : /* @__PURE__ */ I.jsx(oi, { size: 16 }),
              i && "Copy"
            ]
          }
        )
      ]
    }
  ) : null;
}, Lr = Gr({
  activeAnchor: "",
  setActiveAnchor: () => {
  },
  observe: () => {
  },
  unobserve: () => {
  }
}), Vt = () => Yr(Lr), Xs = () => {
  const e = ze(null), { observe: n, unobserve: t } = Vt();
  return ye(() => {
    const i = e.current;
    if (i)
      return n(i), () => t(i);
  }, [n, t]), { ref: qn((i) => {
    i && (e.current = i);
  }, []) };
}, sf = ({ children: e }) => {
  const [n, t] = Pe(""), r = ze(null), i = ze(/* @__PURE__ */ new Set()), a = ze(/* @__PURE__ */ new Set());
  ye(() => (r.current = new IntersectionObserver(
    (u) => {
      for (const s of u)
        s.isIntersecting && s.target.id && t(s.target.id);
    },
    {
      rootMargin: "0px 0px -80% 0px",
      threshold: 0.75
    }
  ), a.current.forEach((u) => {
    i.current.add(u), r.current?.observe(u);
  }), a.current.clear(), () => r.current?.disconnect()), []), ye(() => {
    const u = i.current, s = () => {
      const f = window.scrollY === 0, c = window.innerHeight + window.scrollY >= document.body.scrollHeight;
      if (f)
        t("");
      else if (c) {
        const h = Array.from(u).pop()?.id ?? "";
        t(h);
      }
    };
    return document.addEventListener("scroll", s), () => {
      u.clear(), document.removeEventListener("scroll", s);
    };
  }, []);
  const l = Zt(() => ({
    observe: (u) => {
      if (u) {
        if (!r.current) {
          a.current.add(u);
          return;
        }
        i.current.add(u), r.current.observe(u);
      }
    },
    unobserve: (u) => {
      u && (a.current.delete(u), i.current.delete(u), r.current?.unobserve(u));
    }
  }), []), o = Zt(
    () => ({ activeAnchor: n, setActiveAnchor: t, ...l }),
    [n, t, l]
  );
  return /* @__PURE__ */ I.jsx(Lr, { value: o, children: e });
}, ec = {
  green: "bg-green-400 dark:bg-green-800",
  blue: "bg-sky-400 dark:bg-sky-800",
  yellow: "bg-yellow-400 dark:bg-yellow-800",
  red: "bg-red-400 dark:bg-red-800",
  purple: "bg-purple-400 dark:bg-purple-600",
  indigo: "bg-indigo-400 dark:bg-indigo-600",
  gray: "bg-gray-400 dark:bg-gray-600",
  outline: "border border-border rounded-md text-foreground"
}, tc = {
  green: "text-green-500 dark:text-green-600",
  blue: "text-sky-400 dark:text-sky-600",
  yellow: "text-yellow-400 dark:text-yellow-600",
  red: "text-red-400 dark:text-red-600",
  purple: "text-purple-400 dark:text-purple-600",
  indigo: "text-indigo-400 dark:text-indigo-600",
  gray: "text-gray-400 dark:text-gray-600",
  outline: ""
}, Fn = ({
  color: e,
  label: n,
  className: t,
  invert: r
}) => /* @__PURE__ */ I.jsx(
  "span",
  {
    className: K(
      "flex items-center duration-200 transition-opacity text-center uppercase text-[0.65rem] font-bold rounded text-background dark:text-zinc-50 h-full",
      e === "outline" ? "px-3" : "mt-0.5 px-1",
      r ? tc[e] : ec[e],
      t
    ),
    children: n
  }
);
var nc = Object.getOwnPropertyNames, rc = Object.getOwnPropertySymbols, ic = Object.prototype.hasOwnProperty;
function Dn(e, n) {
  return function(r, i, a) {
    return e(r, i, a) && n(r, i, a);
  };
}
function Ge(e) {
  return function(t, r, i) {
    if (!t || !r || typeof t != "object" || typeof r != "object")
      return e(t, r, i);
    var a = i.cache, l = a.get(t), o = a.get(r);
    if (l && o)
      return l === r && o === t;
    a.set(t, r), a.set(r, t);
    var u = e(t, r, i);
    return a.delete(t), a.delete(r), u;
  };
}
function Ln(e) {
  return nc(e).concat(rc(e));
}
var lc = Object.hasOwn || function(e, n) {
  return ic.call(e, n);
};
function Ce(e, n) {
  return e === n || !e && !n && e !== e && n !== n;
}
var ac = "__v", oc = "__o", uc = "_owner", jn = Object.getOwnPropertyDescriptor, Rn = Object.keys;
function sc(e, n, t) {
  var r = e.length;
  if (n.length !== r)
    return !1;
  for (; r-- > 0; )
    if (!t.equals(e[r], n[r], r, r, e, n, t))
      return !1;
  return !0;
}
function cc(e, n) {
  return Ce(e.getTime(), n.getTime());
}
function fc(e, n) {
  return e.name === n.name && e.message === n.message && e.cause === n.cause && e.stack === n.stack;
}
function hc(e, n) {
  return e === n;
}
function _n(e, n, t) {
  var r = e.size;
  if (r !== n.size)
    return !1;
  if (!r)
    return !0;
  for (var i = new Array(r), a = e.entries(), l, o, u = 0; (l = a.next()) && !l.done; ) {
    for (var s = n.entries(), f = !1, c = 0; (o = s.next()) && !o.done; ) {
      if (i[c]) {
        c++;
        continue;
      }
      var p = l.value, h = o.value;
      if (t.equals(p[0], h[0], u, c, e, n, t) && t.equals(p[1], h[1], p[0], h[0], e, n, t)) {
        f = i[c] = !0;
        break;
      }
      c++;
    }
    if (!f)
      return !1;
    u++;
  }
  return !0;
}
var pc = Ce;
function mc(e, n, t) {
  var r = Rn(e), i = r.length;
  if (Rn(n).length !== i)
    return !1;
  for (; i-- > 0; )
    if (!jr(e, n, t, r[i]))
      return !1;
  return !0;
}
function Be(e, n, t) {
  var r = Ln(e), i = r.length;
  if (Ln(n).length !== i)
    return !1;
  for (var a, l, o; i-- > 0; )
    if (a = r[i], !jr(e, n, t, a) || (l = jn(e, a), o = jn(n, a), (l || o) && (!l || !o || l.configurable !== o.configurable || l.enumerable !== o.enumerable || l.writable !== o.writable)))
      return !1;
  return !0;
}
function gc(e, n) {
  return Ce(e.valueOf(), n.valueOf());
}
function dc(e, n) {
  return e.source === n.source && e.flags === n.flags;
}
function Bn(e, n, t) {
  var r = e.size;
  if (r !== n.size)
    return !1;
  if (!r)
    return !0;
  for (var i = new Array(r), a = e.values(), l, o; (l = a.next()) && !l.done; ) {
    for (var u = n.values(), s = !1, f = 0; (o = u.next()) && !o.done; ) {
      if (!i[f] && t.equals(l.value, o.value, l.value, o.value, e, n, t)) {
        s = i[f] = !0;
        break;
      }
      f++;
    }
    if (!s)
      return !1;
  }
  return !0;
}
function xc(e, n) {
  var t = e.length;
  if (n.length !== t)
    return !1;
  for (; t-- > 0; )
    if (e[t] !== n[t])
      return !1;
  return !0;
}
function kc(e, n) {
  return e.hostname === n.hostname && e.pathname === n.pathname && e.protocol === n.protocol && e.port === n.port && e.hash === n.hash && e.username === n.username && e.password === n.password;
}
function jr(e, n, t, r) {
  return (r === uc || r === oc || r === ac) && (e.$$typeof || n.$$typeof) ? !0 : lc(n, r) && t.equals(e[r], n[r], r, r, e, n, t);
}
var bc = "[object Arguments]", yc = "[object Boolean]", wc = "[object Date]", Cc = "[object Error]", Sc = "[object Map]", Ec = "[object Number]", Ac = "[object Object]", Ic = "[object RegExp]", Tc = "[object Set]", zc = "[object String]", vc = "[object URL]", Pc = Array.isArray, Nn = typeof ArrayBuffer == "function" && ArrayBuffer.isView ? ArrayBuffer.isView : null, Mn = Object.assign, Oc = Object.prototype.toString.call.bind(Object.prototype.toString);
function Fc(e) {
  var n = e.areArraysEqual, t = e.areDatesEqual, r = e.areErrorsEqual, i = e.areFunctionsEqual, a = e.areMapsEqual, l = e.areNumbersEqual, o = e.areObjectsEqual, u = e.arePrimitiveWrappersEqual, s = e.areRegExpsEqual, f = e.areSetsEqual, c = e.areTypedArraysEqual, p = e.areUrlsEqual;
  return function(d, b, C) {
    if (d === b)
      return !0;
    if (d == null || b == null)
      return !1;
    var k = typeof d;
    if (k !== typeof b)
      return !1;
    if (k !== "object")
      return k === "number" ? l(d, b, C) : k === "function" ? i(d, b, C) : !1;
    var E = d.constructor;
    if (E !== b.constructor)
      return !1;
    if (E === Object)
      return o(d, b, C);
    if (Pc(d))
      return n(d, b, C);
    if (Nn != null && Nn(d))
      return c(d, b, C);
    if (E === Date)
      return t(d, b, C);
    if (E === RegExp)
      return s(d, b, C);
    if (E === Map)
      return a(d, b, C);
    if (E === Set)
      return f(d, b, C);
    var S = Oc(d);
    return S === wc ? t(d, b, C) : S === Ic ? s(d, b, C) : S === Sc ? a(d, b, C) : S === Tc ? f(d, b, C) : S === Ac ? typeof d.then != "function" && typeof b.then != "function" && o(d, b, C) : S === vc ? p(d, b, C) : S === Cc ? r(d, b, C) : S === bc ? o(d, b, C) : S === yc || S === Ec || S === zc ? u(d, b, C) : !1;
  };
}
function Dc(e) {
  var n = e.circular, t = e.createCustomConfig, r = e.strict, i = {
    areArraysEqual: r ? Be : sc,
    areDatesEqual: cc,
    areErrorsEqual: fc,
    areFunctionsEqual: hc,
    areMapsEqual: r ? Dn(_n, Be) : _n,
    areNumbersEqual: pc,
    areObjectsEqual: r ? Be : mc,
    arePrimitiveWrappersEqual: gc,
    areRegExpsEqual: dc,
    areSetsEqual: r ? Dn(Bn, Be) : Bn,
    areTypedArraysEqual: r ? Be : xc,
    areUrlsEqual: kc
  };
  if (t && (i = Mn({}, i, t(i))), n) {
    var a = Ge(i.areArraysEqual), l = Ge(i.areMapsEqual), o = Ge(i.areObjectsEqual), u = Ge(i.areSetsEqual);
    i = Mn({}, i, {
      areArraysEqual: a,
      areMapsEqual: l,
      areObjectsEqual: o,
      areSetsEqual: u
    });
  }
  return i;
}
function Lc(e) {
  return function(n, t, r, i, a, l, o) {
    return e(n, t, o);
  };
}
function jc(e) {
  var n = e.circular, t = e.comparator, r = e.createState, i = e.equals, a = e.strict;
  if (r)
    return function(u, s) {
      var f = r(), c = f.cache, p = c === void 0 ? n ? /* @__PURE__ */ new WeakMap() : void 0 : c, h = f.meta;
      return t(u, s, {
        cache: p,
        equals: i,
        meta: h,
        strict: a
      });
    };
  if (n)
    return function(u, s) {
      return t(u, s, {
        cache: /* @__PURE__ */ new WeakMap(),
        equals: i,
        meta: void 0,
        strict: a
      });
    };
  var l = {
    cache: void 0,
    equals: i,
    meta: void 0,
    strict: a
  };
  return function(u, s) {
    return t(u, s, l);
  };
}
var Rc = me();
me({ strict: !0 });
me({ circular: !0 });
me({
  circular: !0,
  strict: !0
});
me({
  createInternalComparator: function() {
    return Ce;
  }
});
me({
  strict: !0,
  createInternalComparator: function() {
    return Ce;
  }
});
me({
  circular: !0,
  createInternalComparator: function() {
    return Ce;
  }
});
me({
  circular: !0,
  createInternalComparator: function() {
    return Ce;
  },
  strict: !0
});
function me(e) {
  e === void 0 && (e = {});
  var n = e.circular, t = n === void 0 ? !1 : n, r = e.createInternalComparator, i = e.createState, a = e.strict, l = a === void 0 ? !1 : a, o = Dc(e), u = Fc(o), s = r ? r(u) : Lc(u);
  return jc({ circular: t, comparator: u, createState: i, equals: s, strict: l });
}
const _c = ({
  category: e,
  onRequestClose: n
}) => {
  const t = hi(e), [r, i] = Pe(!1), a = rt(), l = e.collapsible ?? !0, o = e.collapsed ?? !0, u = !!(!l || !o || t), [s, f] = Pe(u), c = ci(e.link?.id ?? "");
  ye(() => {
    t && f(!0);
  }, [t]);
  const p = l && /* @__PURE__ */ I.jsx(
    mi,
    {
      onClick: (b) => {
        b.preventDefault(), f((C) => !C), i(!0);
      },
      variant: "ghost",
      size: "icon",
      className: "size-6 hover:bg-[hsl(from_hsl(var(--accent))_h_s_calc(l-5))] hover:dark:bg-[hsl(from_hsl(var(--accent))_h_s_calc(l+5))]",
      children: /* @__PURE__ */ I.jsx(
        ui,
        {
          size: 16,
          className: K(
            r && "transition",
            "shrink-0 group-data-[state=open]:rotate-90 rtl:rotate-180"
          )
        }
      )
    }
  ), h = e.icon && /* @__PURE__ */ I.jsx(
    e.icon,
    {
      size: 16,
      className: K("align-[-0.125em] ", c && "text-primary")
    }
  ), d = Ke({
    className: [
      "group text-start font-medium",
      l || typeof e.link < "u" ? "cursor-pointer" : "cursor-default hover:bg-transparent"
    ]
  });
  return /* @__PURE__ */ I.jsxs(
    ut.Root,
    {
      className: "flex flex-col",
      defaultOpen: u,
      open: s,
      onOpenChange: () => f(!0),
      children: [
        /* @__PURE__ */ I.jsx(ut.Trigger, { className: "group", asChild: !0, disabled: !l, children: e.link?.type === "doc" ? /* @__PURE__ */ I.jsxs(
          Ot,
          {
            to: {
              pathname: Un(e.link.id),
              search: a.search
            },
            className: d,
            onClick: () => {
              i(!0), c && !s && f(!0);
            },
            children: [
              h,
              /* @__PURE__ */ I.jsxs("div", { className: "flex items-center gap-2 justify-between w-full text-foreground/80 group-aria-[current='page']:text-primary", children: [
                /* @__PURE__ */ I.jsx("div", { className: "truncate", children: e.label }),
                p
              ] })
            ]
          }
        ) : /* @__PURE__ */ I.jsxs("div", { onClick: () => i(!0), className: d, children: [
          h,
          /* @__PURE__ */ I.jsxs("div", { className: "flex items-center justify-between w-full", children: [
            /* @__PURE__ */ I.jsx("div", { className: "flex gap-2 truncate w-full", children: e.label }),
            p
          ] })
        ] }) }),
        /* @__PURE__ */ I.jsx(
          ut.Content,
          {
            className: K(
              // CollapsibleContent class is used to animate and it should only be applied when the user has triggered the toggle
              r && "CollapsibleContent",
              e.items.length === 0 && "hidden",
              "ms-6 my-1"
            ),
            children: /* @__PURE__ */ I.jsx("ul", { className: "relative after:absolute after:-start-[--padding-nav-item] after:translate-x-[1.5px] after:top-0 after:bottom-0 after:w-px after:bg-border", children: e.items.map((b) => /* @__PURE__ */ I.jsx(
              Bc,
              {
                onRequestClose: n,
                item: b
              },
              ("id" in b ? b.id : "") + ("href" in b ? b.href : "") + b.label
            )) })
          }
        )
      ]
    }
  );
}, Rr = Hn(_c, Rc);
Rr.displayName = "SidebarCategory";
const Ke = Vn(
  "flex items-center gap-2 px-[--padding-nav-item] my-0.5 py-1.5 rounded-lg hover:bg-accent tabular-nums",
  {
    variants: {
      isActive: {
        true: "bg-accent font-medium",
        false: "text-foreground/80"
      },
      isMuted: {
        true: "text-foreground/30",
        false: ""
      },
      isPending: {
        true: "bg-accent animate-pulse",
        false: ""
      }
    },
    defaultVariants: {
      isActive: !1
    }
  }
), _r = "data-anchor", Bc = ({
  item: e,
  onRequestClose: n
}) => {
  const t = rt(), { activeAnchor: r } = Vt();
  switch (e.type) {
    case "category":
      return /* @__PURE__ */ I.jsx(Rr, { category: e, onRequestClose: n });
    case "doc":
      return /* @__PURE__ */ I.jsxs(
        Ot,
        {
          className: ({ isActive: i, isPending: a }) => Ke({ isActive: i, isPending: a }),
          to: Un(e.id),
          onClick: n,
          end: !0,
          children: [
            e.icon && /* @__PURE__ */ I.jsx(e.icon, { size: 16, className: "align-[-0.125em]" }),
            e.badge ? /* @__PURE__ */ I.jsxs(I.Fragment, { children: [
              /* @__PURE__ */ I.jsx("span", { className: "truncate flex-1", title: e.label, children: e.label }),
              /* @__PURE__ */ I.jsx(Fn, { ...e.badge })
            ] }) : e.label
          ]
        }
      );
    case "link":
      return e.href.startsWith("http") ? /* @__PURE__ */ I.jsxs(
        "a",
        {
          className: Ke(),
          href: e.href,
          target: "_blank",
          rel: "noopener noreferrer",
          onClick: n,
          children: [
            /* @__PURE__ */ I.jsx("span", { className: "whitespace-normal", children: e.label }),
            /* @__PURE__ */ I.jsx("span", { className: "whitespace-nowrap", children: /* @__PURE__ */ I.jsx(si, { className: "inline -translate-y-0.5", size: 12 }) })
          ]
        }
      ) : /* @__PURE__ */ I.jsx(
        Nr,
        {
          to: {
            pathname: e.href.split("#")[0],
            hash: e.href.split("#")[1],
            search: t.search
          },
          [_r]: e.href.split("#")[1],
          className: Ke({
            isActive: e.href === [t.pathname, r].join("#"),
            className: e.badge?.placement !== "start" && "justify-between"
          }),
          onClick: n,
          children: e.badge ? /* @__PURE__ */ I.jsxs(I.Fragment, { children: [
            /* @__PURE__ */ I.jsx("span", { className: "truncate", title: e.label, children: e.label }),
            /* @__PURE__ */ I.jsx(Fn, { ...e.badge })
          ] }) : /* @__PURE__ */ I.jsx("span", { className: "break-all", children: e.label })
        }
      );
  }
}, Nc = (e, n = { block: "center" }) => {
  if (!e) return;
  const t = e.getBoundingClientRect();
  t.top >= 0 && t.left >= 0 && t.bottom <= (window.innerHeight || document.documentElement.clientHeight) && t.right <= (window.innerWidth || document.documentElement.clientWidth) || e.scrollIntoView(n);
}, Br = () => {
  const { setActiveAnchor: e } = Vt();
  return qn(
    (t) => {
      const r = t.replace(/^#/, ""), i = r.split("/").at(0), a = document.getElementById(decodeURIComponent(r)), l = document.querySelector(
        `[${_r}="${i}"]`
      );
      return a ? (a.scrollIntoView(), Nc(l), requestIdleCallback(() => e(i)), !0) : !1;
    },
    [e]
  );
}, cf = () => {
  const e = rt(), n = Br(), t = ze(!1);
  ye(() => {
    !e.hash || !t.current || n(e.hash);
  }, [e.hash, n]), ye(() => {
    if (!e.hash) {
      t.current = !0;
      return;
    }
    const r = new MutationObserver((i, a) => {
      n(e.hash) && (t.current = !0, a.disconnect());
    });
    return r.observe(document.body, { childList: !0, subtree: !0 }), () => r.disconnect();
  }, [e.hash, n]);
}, Nr = (e) => {
  const n = rt(), t = Br(), r = fi(e.to), [i, a] = r.split("#"), l = (o) => {
    e.onClick?.(o), !(a !== n.hash.slice(1) || i !== n.pathname) && (o.preventDefault(), t(a));
  };
  return /* @__PURE__ */ I.jsx(Ot, { ...e, onClick: l });
}, Mc = Vn("group relative", {
  variants: {
    level: {
      6: "text-md",
      5: "text-lg",
      4: "text-xl",
      3: "text-xl font-semibold",
      2: "text-2xl font-bold",
      1: "text-4xl font-extrabold"
    }
  },
  defaultVariants: {
    level: 1
  }
}), qc = (e) => {
  switch (e) {
    case 1:
      return "h1";
    case 2:
      return "h2";
    case 3:
      return "h3";
    case 4:
      return "h4";
    case 5:
      return "h5";
    case 6:
      return "h6";
    default:
      return "h1";
  }
}, Ie = ({
  level: e,
  children: n,
  id: t,
  className: r,
  registerSidebarAnchor: i
}) => {
  const a = qc(e ?? 1), { ref: l } = Xs();
  return /* @__PURE__ */ I.jsxs(
    a,
    {
      className: Mc({ className: r, level: e }),
      ref: i ? l : void 0,
      id: t,
      children: [
        t && /* @__PURE__ */ I.jsx(
          "a",
          {
            href: `#${t}`,
            className: "before:content-['#'] no-underline absolute text-primary -start-[0.8em] pe-2.5 opacity-0 group-hover:opacity-50 hover:!opacity-100 transition-opacity duration-200",
            "aria-label": `Link to ${t}`,
            children: "​"
          }
        ),
        n
      ]
    }
  );
}, Hc = ({
  asChild: e,
  onClick: n,
  enabled: t = !0,
  ...r
}) => {
  const i = e ? gi : "span";
  return /* @__PURE__ */ I.jsx(
    i,
    {
      onClick: (a) => {
        if (t) {
          const l = document.createRange();
          l.selectNodeContents(a.currentTarget);
          const o = window.getSelection();
          o?.removeAllRanges(), o?.addRange(l);
        }
        n?.(a);
      },
      ...r
    }
  );
}, $c = ({
  className: e,
  children: n,
  selectOnClick: t,
  onClick: r
}) => /* @__PURE__ */ I.jsx(Hc, { asChild: !0, enabled: t, onClick: r, children: /* @__PURE__ */ I.jsx(
  "code",
  {
    className: K(
      "font-mono border p-1 py-0.5 rounded bg-border/50 dark:bg-border/70 [overflow-wrap:anywhere]",
      e
    ),
    children: n
  }
) }), Vc = {
  img: ({ node: e, ...n }) => /\.(mp4|webm|mov|avi)$/.test(n.src ?? "") ? /* @__PURE__ */ I.jsx("video", { src: n.src, controls: !0, playsInline: !0, autoPlay: !0, loop: !0 }) : /* @__PURE__ */ I.jsx("img", { ...n, className: "rounded-md" }),
  h1: ({ children: e, id: n }) => /* @__PURE__ */ I.jsx(Ie, { level: 1, id: n, children: e }),
  h2: ({ children: e, id: n }) => /* @__PURE__ */ I.jsx(Ie, { level: 2, id: n, children: e }),
  h3: ({ children: e, id: n }) => /* @__PURE__ */ I.jsx(Ie, { level: 3, id: n, children: e }),
  h4: ({ children: e, id: n }) => /* @__PURE__ */ I.jsx(Ie, { level: 4, id: n, children: e }),
  h5: ({ children: e, id: n }) => /* @__PURE__ */ I.jsx(Ie, { level: 5, id: n, children: e }),
  h6: ({ children: e, id: n }) => /* @__PURE__ */ I.jsx(Ie, { level: 6, id: n, children: e }),
  a: ({ href: e, node: n, ...t }) => e && !e.startsWith("http") ? /* @__PURE__ */ I.jsx(Nr, { to: e, relative: "path", ...t }) : /* @__PURE__ */ I.jsx("a", { href: e, target: "_blank", ...t, rel: "noreferrer" }),
  Button: di,
  Callout: ke,
  Stepper: xi,
  SyntaxHighlight: ii,
  tip: (e) => /* @__PURE__ */ I.jsx(ke, { type: "tip", ...e }),
  info: (e) => /* @__PURE__ */ I.jsx(ke, { type: "info", ...e }),
  note: (e) => /* @__PURE__ */ I.jsx(ke, { type: "note", ...e }),
  caution: (e) => /* @__PURE__ */ I.jsx(ke, { type: "caution", ...e }),
  warning: (e) => /* @__PURE__ */ I.jsx(ke, { type: "caution", ...e }),
  danger: (e) => /* @__PURE__ */ I.jsx(ke, { type: "danger", ...e }),
  pre: (e) => /* @__PURE__ */ I.jsx("pre", { className: K("not-prose my-4", e.className), ...e }),
  code: ({
    className: e,
    node: n,
    children: t,
    title: r,
    inline: i,
    showLineNumbers: a,
    ...l
  }) => {
    const o = e?.match(/language?-(\w+)/);
    return i === "true" || i === !0 ? /* @__PURE__ */ I.jsx($c, { className: K(e, "inline"), children: t }) : /* @__PURE__ */ I.jsx(
      Ks,
      {
        language: o?.[1],
        showLanguageIndicator: !0,
        showLineNumbers: a,
        title: r,
        children: /* @__PURE__ */ I.jsx("code", { className: K(e, "not-inline"), ...l, children: t })
      }
    );
  }
}, Uc = [Js], ff = "prose dark:prose-invert prose-neutral", Wc = Hn(
  ({
    content: e,
    className: n,
    components: t
  }) => {
    const { syntaxHighlighting: r } = pi().options, i = li(
      r?.themes
    );
    return /* @__PURE__ */ I.jsx("div", { className: n, children: /* @__PURE__ */ I.jsx(
      Do,
      {
        remarkPlugins: Uc,
        rehypePlugins: i,
        components: { ...Vc, ...t },
        children: e
      }
    ) });
  }
);
Wc.displayName = "Markdown";
export {
  Nr as A,
  Ie as H,
  $c as I,
  Wc as M,
  ff as P,
  Hc as S,
  sf as V,
  Bc as a,
  cf as b,
  Vc as c,
  Nc as s,
  Vt as u
};
//# sourceMappingURL=Markdown-D96AphCL.js.map
